import * as React from 'react';
import Dropzone from 'react-dropzone';
import { Link } from 'react-router-dom';
import Prompt from './prompt';
//import ExtenderDispatcher from '../../../components/ExtenderDispatcher';
import AutoComplete from '../../../components/AutoComplete';
import ActionButton from '../../../components/ActionButton';
import {
  GetDocument,
  CheckIn,
  SaveDocument,
  SubmitDocument,
  GetNextDocument,
  UpdateUserFieldSettings,
  //GetDocumentAudit,
  GetAvailableTemplates,
  UpdateTemplate,
  ExecuteExtender,
  SendDocumentToImageReview,
  //ChangeQueueAssignment,
  DeleteDocument,
  AddNote,
  DownloadAttachment,
  PullDocument,
  DeleteAttachment,
  UploadAttachment,
  DownloadPDF,
  DownloadRelatedDocumentPacket,
  DownloadPDFWithStamps,
  FetchAssignableUsers,
  MoveAssignDocument,
  GetAvailableTemplatesByBp2,
  GetDocumentStatusInfo,
  SendEmail,
  ChangeBusinessProcesses,
  GetAssignees,
  //ExecuteFullExtenderSet,
  GetDocumentZoomSetting,
  ExecuteExtender3,
  GetRelatedDocs,
  UndeleteDocument,
  DownloadPDFWithAttachments,
  ExecuteRuntimePlugin,
  ReadIntegrationAlerts,
  CreateTemplateForDocument,
  GetDocumentIntakeLogs

} from '../../../actions/DocumentActions';
import {
  GetDocumentUserActivity,
  GetDocumentIntegrationActivity,
  GetDocumentSystemActivity,
  GetDocumentSystemNotes,
  DownloadDocAudit,
} from '../../../actions/DocAuditActions';
import { UpdateSetting } from '../../../actions/UserActions';
import {
  GetImages,
  FetchImage,
  RotateImage,
} from '../../../actions/ImageActions';
import DocumentStore from '../../../stores/DocumentStore';
import SearchStore from '../../../stores/SearchStore';
import BPStore from '../../../stores/BPStore';
import AuditStore from '../../../stores/AuditStore';
import BulkActionStore from '../../../stores/BulkActionStore';
import DocImageViewer from './DocImageViewer';
import FieldEditor from './FieldEditor';
import TableCellEditor from './TableCellEditor';
import { RequestNav } from '../../../actions/NavActions';
import actionTypes from '../../../actions/ActionTypes';
import { GetBPList } from '../../../actions/BPActions';
import { PostAlert } from '../../../actions/AlertActions';
import HotKeyStore from '../../../stores/HotKeyStore';
import { createBrowserHistory } from 'history';
import { LoadReaders } from '../../../actions/ReadersActions';
import ReadersStore from '../../../stores/ReadersStore';
import { LoadDefaults } from '../../../actions/DefaultActions';
import DefaultsStore from '../../../stores/DefaultsStore';
import SystemSettingsStore from '../../../stores/SystemSettingsStore';
import { GetSystemSettings2 } from '../../../actions/SystemSettingsActions';

const customHistory = createBrowserHistory();

var isDraggingColumn = false;
var startColX = 0;
var dragColIndex = 0;
var startColWidth = 0;
var useMagic = true;
var _existingKeys = [];
var _pendingKeys = [];

class DocumentEditor extends React.Component {
  constructor(props) {
    super(props);
    // state
    this.state = {
      currentDoc: undefined,
      currentFieldSet: { fieldSetId: 0, fieldDefs: [] },
      isLoading: false,
      isRunningPlugin: false,
      preventViewing: false,
      isSaving: false,
      currentDocId: 0,
      documentLoaded: false,
      showAttachmentMenu: false,
      showPdfMenu: false,
      showUserAssign: false,
      canAssignUser: false,
      showSnagMenu: false,
      workflowName: '',
      stepName: '',
      formTypeName: '',
      templateName: '',
      checkedOutBy: '',
      documentID: 0,
      attachmentCount: 0,
      noteCount: 1,
      lockedByMe: false,
      lockedByOther: false,
      automatedTask: false,
      userCanSubmit: false,
      userCanEdit: false,
      userCanSendToReview: false,
      userCanDelete: false,
      userCanMoveAssign: false,
      isDraggingSplitBar: false,
      userCanAddNotes: false,
      userCanDownload: false,
      topHeight: 400,
      bottomHeight: 10,
      topHeightOnDragStart: 0,
      imageviewerHeight: 400 - 32,
      //tableHeight: window.innerHeight - 400 - 100,
      tableHeight: window.innerHeight - 400 - 239,
      imageviewerWidth: window.innerWidth - 300,
      tableWidth: window.innerWidth - 30,
      images: [],
      currentImage: undefined,
      imageCount: 0,
      loadingImage: false,
      snapshots: [],
      returnUrl: '/ActiveDocuments',
      currentEdit: { rowId: 1, colId: 1, orderId: 1 },
      allRowCheck: false,
      showTrash: true,
      showChecks: false,
      showTools: false,
      rowData: [],
      // Tracks the active sort per FieldSet: { [fieldSetId]: { rowSortField, rowSortDir } }
      fieldSetSortState: {},
      showColumnEdit: false,
      showDocumentMenu: false,
      showAudit: false,
      showAudit2: false,
      currentAuditView: 'user',
      isAuditLoading: false,
      auditInfo: undefined,
      auditInfo2: undefined,
      auditInfo3: undefined,
      showTemplateChange: false,
      selectedTemplate: { templateId: -1, templateName: 'Template...' },
      suggestedTemplateId: { templateId: -1, templateName: 'Template...' },
      suggestedReaderId: 0,
      suggestedDefaultId: 0,
      templateSearchText: '',
      availableTemplates: [],
      filteredTemplates: [],
      applyTemplate: true,
      userSearch: '',
      showDeleteConfirm: false,
      showUserNotes: false,
      showAddNote: true,
      newNote: '',
      showExcelPaste: false,
      excelData: [],
      showProperties: false,
      showIntakeLogs: false,
      hasStamps: false,
      showStampMenu: false,
      showStampScreen: false,
      queuesDirty: false,
      stampRequest: {
        showDocId: true,
        showUserName: true,
        showDate: true,
        showTime: true,
        size: 2,
        sizeDesc: 'Medium',
        useTransparency: false,
        stamps: [],
      },
      lastStampPos: -1,
      showMoveAssign: false,
      moveAssignStepId: -1,
      moveAssignableUsers: [],
      moveAssignUsers: [],
      moveAssignUserSearch: '',
      moveAssignSelectedUsers: [],
      relatedInfo: {
        show: false,
        left: 187,
        formType: 'Payables',
        field: 'Vendor Id',
      },
      isRotatingLeft: false,
      isRotatingRight: false,

      //bp
      availableBps: [],
      selectedBpId: -1,
      selectedBpId2: -1,
      showChangeBusinessProcess: false,
      filteredTemplates2: [],
      availableTemplates2: [],
      selectedTemplate2: { templateId: -1, templateName: 'Template...' },
      suggestedTemplateId2: { templateId: -1, templateName: 'Template...' },
      templateSearchText2: '',
      fieldsHaveError: false,
      showAllColumns: false,
      isSubmitting: false,

      relatedDocChange: false,
      showReasonForReject: false,
      rejectReasonNote: '',
      showAICaptureConfirm: false,
      showEmailPDF: false,
      emailTo: '',
      emailSubject: '',
      emailMessage: '',
      inProgressAnimation: false,
      selectedChangeBpTemplate: -1,
      showErrorMessage: false,
      errorMessages: [],
      documentZoomSetting: 100,
      showAlert: false,
      alertTitle: '',
      alertMessage: '',
      alertNextOnClose: false,
      tempCount: 0,
      loadExtenderRows: false,
      showExpandedView: false,
      expandedViewText: '',
      expandedViewTitle: '',
      fetchingUserActivity: false,
      fetchingIntegrationActivity: false,
      fetchingSystemActivity: false,
      fetchingSystemNotes: false,
      showAuditViews: true,
      showAuditUserNotes: true,
      showAuditSystemNotes: true,
      showAuditSystemActivity: true,
      showIntegrationAlert: false,
      showRuntimeMenu: false,
      allReaders: [],
      allDefaults: [],
      newTemplateName: '',
      newTemplateLink: 'DIRECT',
      newTemplateId: 0,
      newTemplateError: '',

      trinFormsBaseUrl: '',
      trinFormsCompleteUrl: '',
      intakeLogs: [],
      expandedIntakeLogRows: []
    };

    this.loadDocumentFromDB = this.loadDocumentFromDB.bind(this);
    this.handleAttachmentClick = this.handleAttachmentClick.bind(this);
    this.handlePdfClick = this.handlePdfClick.bind(this);
    this.handleDocumentClick = this.handleDocumentClick.bind(this);
    this.toggleSnagMenu = this.toggleSnagMenu.bind(this);
    this.onMouseMove = this.onMouseMove.bind(this);
    this.onMouseUp = this.onMouseUp.bind(this);
    this.onSplitBarMouseDown = this.onSplitBarMouseDown.bind(this);
    this.onDocumentChange = this.onDocumentChange.bind(this);
    this.onWindowResize = this.onWindowResize.bind(this);
    this.onReaderChange = this.onReaderChange.bind(this);
    this.onDefaultChange = this.onDefaultChange.bind(this);
    this.handleImageNav = this.handleImageNav.bind(this);
    this.generateSnapshot = this.generateSnapshot.bind(this);
    this.handleHeaderFieldEdit = this.handleHeaderFieldEdit.bind(this);
    this.handleTableFieldEdit = this.handleTableFieldEdit.bind(this);
    this.updateCurrentSnapshot = this.updateCurrentSnapshot.bind(this);
    this.undoLatestChange = this.undoLatestChange.bind(this);
    this.beforeUnloadListener = this.beforeUnloadListener.bind(this);
    this.handleSaveClick = this.handleSaveClick.bind(this);
    this.initSnapshot = this.initSnapshot.bind(this);
    this.handleApproveClick = this.handleApproveClick.bind(this);
    this.handleRejectClick = this.handleRejectClick.bind(this);
    this.handleNextClick = this.handleNextClick.bind(this);
    this.onCellClick = this.onCellClick.bind(this);
    this.DragColumnSize = this.DragColumnSize.bind(this);
    this.stopDraggingColSize = this.stopDraggingColSize.bind(this);
    this.setRowCheck = this.setRowCheck.bind(this);
    this.setAllRowCheck = this.setAllRowCheck.bind(this);
    this.toggleChecks = this.toggleChecks.bind(this);
    this.toggleShowTools = this.toggleShowTools.bind(this);
    this.toggleFieldSet = this.toggleFieldSet.bind(this);
    this.toggleColumnEdit = this.toggleColumnEdit.bind(this);
    this.toggleColumnDisplay = this.toggleColumnDisplay.bind(this);
    //this.createNewRow = this.createNewRow.bind(this);
    this.onMoveCell = this.onMoveCell.bind(this);
    this.deleteRow = this.deleteRow.bind(this);
    this.deleteRows = this.deleteRows.bind(this);
    this.toggleDocMenu = this.toggleDocMenu.bind(this);
    this.hideDocMenu = this.hideDocMenu.bind(this);
    this.onSearchUpdate = this.onSearchUpdate.bind(this);
    this.toggleShowAudit = this.toggleShowAudit.bind(this);
    this.switchAuditView = this.switchAuditView.bind(this);
    this.toggleTemplateChange = this.toggleTemplateChange.bind(this);
    this.suggestTemplateItem = this.suggestTemplateItem.bind(this);
    this.templateSuggestionClick = this.templateSuggestionClick.bind(this);
    this.onChangeTemplateSearchText =
      this.onChangeTemplateSearchText.bind(this);
    this.onClickTemplateSearch = this.onClickTemplateSearch.bind(this);
    this.filterTemplates = this.filterTemplates.bind(this);
    this.toggleApplyTemplate = this.toggleApplyTemplate.bind(this);
    this.onClickTemplateChange = this.onClickTemplateChange.bind(this);
    this.setFieldError = this.setFieldError.bind(this);
    this.ValidateDocument = this.ValidateDocument.bind(this);
    this.closeAllList = this.closeAllList.bind(this);
    this.handleImageRevClick = this.handleImageRevClick.bind(this);
    this.removeAssignment = this.removeAssignment.bind(this);
    this.editAssignUser = this.editAssignUser.bind(this);
    this.assignUserBlur = this.assignUserBlur.bind(this);
    this.handlePreviousClick = this.handlePreviousClick.bind(this);
    this.handleTrashClick = this.handleTrashClick.bind(this);
    this.cancelTrashClick = this.cancelTrashClick.bind(this);
    this.deleteDoc = this.deleteDoc.bind(this);
    this.toggleUserNotes = this.toggleUserNotes.bind(this);
    this.toggleAddNote = this.toggleAddNote.bind(this);
    this.addNote = this.addNote.bind(this);
    this.editNewNote = this.editNewNote.bind(this);
    this.toggleExcelPaste = this.toggleExcelPaste.bind(this);
    this.pasteExcel = this.pasteExcel.bind(this);
    this.appendExcelData = this.appendExcelData.bind(this);
    this.replaceExcelData = this.replaceExcelData.bind(this);
    this.downloadAttachment = this.downloadAttachment.bind(this);
    this.pullDocFromUser = this.pullDocFromUser.bind(this);
    this.deleteAttachment = this.deleteAttachment.bind(this);
    this.uploadAttachment = this.uploadAttachment.bind(this);
    this.uploadAttachmentSubmit = this.uploadAttachmentSubmit.bind(this);
    this.toggleProperties = this.toggleProperties.bind(this);
    this.toggleIntakeLogs = this.toggleIntakeLogs.bind(this);
    this.loadIntakeLogs = this.loadIntakeLogs.bind(this);
    this.handleStampClick = this.handleStampClick.bind(this);
    this.toggleStamps = this.toggleStamps.bind(this);
    this.editStampRequest = this.editStampRequest.bind(this);
    this.stampImageClick = this.stampImageClick.bind(this);
    this.downloadDocument = this.downloadDocument.bind(this);
    this.downloadRelatedDocumentPacket =
      this.downloadRelatedDocumentPacket.bind(this);
    this.downloadDocumentWithStamps =
      this.downloadDocumentWithStamps.bind(this);
    this.toggleShowMoveAssign = this.toggleShowMoveAssign.bind(this);
    this.editMoveAssignStep = this.editMoveAssignStep.bind(this);
    this.moveAssignUserBlur = this.moveAssignUserBlur.bind(this);
    this.editMoveAssignUser = this.editMoveAssignUser.bind(this);
    this.moveAssignDoc = this.moveAssignDoc.bind(this);
    //this.checkChildExtenders = this.checkChildExtenders.bind(this);
    this.onClickMoveAssignableUser = this.onClickMoveAssignableUser.bind(this);
    this.onClickRemoveMoveAssignUser =
      this.onClickRemoveMoveAssignUser.bind(this);
    this.onRelatedMouseIn = this.onRelatedMouseIn.bind(this);
    this.onRelatedMouseOut = this.onRelatedMouseOut.bind(this);
    this.onRelatedMouseClick = this.onRelatedMouseClick.bind(this);
    this.rotateDocImageLeft = this.rotateDocImageLeft.bind(this);
    this.rotateDocImageRight = this.rotateDocImageRight.bind(this);
    //this.onKeyUp = this.onKeyUp.bind(this);
    this.toggleChangeBusinessProcess =
      this.toggleChangeBusinessProcess.bind(this);
    this.editBps = this.editBps.bind(this);
    this.onChangeTemplateSearchText2 =
      this.onChangeTemplateSearchText2.bind(this);
    this.filterTemplates2 = this.filterTemplates2.bind(this);
    this.onBPChange = this.onBPChange.bind(this);
    this.onClickTemplateSearch2 = this.onClickTemplateSearch2.bind(this);
    this.onBulkChange = this.onBulkChange.bind(this);
    this.suggestTemplateItem = this.suggestTemplateItem.bind(this);
    this.templateSuggestionClick2 = this.templateSuggestionClick2.bind(this);
    this.goToDoc = this.goToDoc.bind(this);
    this.writeGridToClipboard = this.writeGridToClipboard.bind(this);
    this.handleHeaderFieldTextEdit = this.handleHeaderFieldTextEdit.bind(this);
    this.setLineFieldError = this.setLineFieldError.bind(this);
    this.calculateRunningTotal = this.calculateRunningTotal.bind(this);
    this.windowMouseLeave = this.windowMouseLeave.bind(this);
    this.runExtender = this.runExtender.bind(this);
    this.blankRowField = this.blankRowField.bind(this);
    this.blankHeaderField = this.blankHeaderField.bind(this);
    this.getExtenderData = this.getExtenderData.bind(this);
    this.getTableWidth = this.getTableWidth.bind(this);
    this.onRelatedClick = this.onRelatedClick.bind(this);
    this.onBackToOriginalDoc = this.onBackToOriginalDoc.bind(this);
    this.updateRunningTotals = this.updateRunningTotals.bind(this);
    this.cancelReject = this.cancelReject.bind(this);
    this.editRejectNote = this.editRejectNote.bind(this);
    this.confirmReject = this.confirmReject.bind(this);
    this.emailPDF = this.emailPDF.bind(this);
    this.cancelEmailPDF = this.cancelEmailPDF.bind(this);
    this.onEditEmailTo = this.onEditEmailTo.bind(this);
    this.onEditEmailSubject = this.onEditEmailSubject.bind(this);
    this.onEditEmailMessage = this.onEditEmailMessage.bind(this);
    this.validateAndSendEmail = this.validateAndSendEmail.bind(this);
    this.moveBpDocsClick = this.moveBpDocsClick.bind(this);
    this.editSelectedChangeBpTemplate =
      this.editSelectedChangeBpTemplate.bind(this);
    this.inpsectTemplate = this.inpsectTemplate.bind(this);
    this.checkQueueChanges = this.checkQueueChanges.bind(this);
    this.goToActiveDocs = this.goToActiveDocs.bind(this);
    this.showSaveDetails = this.showSaveDetails.bind(this);
    this.toggleShowErrorMessage = this.toggleShowErrorMessage.bind(this);
    this.findDependency = this.findDependency.bind(this);
    this.processExtenderRow = this.processExtenderRow.bind(this);
    this.processExtenderRow2 = this.processExtenderRow2.bind(this);
    this.setCellError = this.setCellError.bind(this);
    this.clearCellError = this.clearCellError.bind(this);
    this.clearChildCells = this.clearChildCells.bind(this);
    this.errorRowField = this.errorRowField.bind(this);
    this.focusFirstField = this.focusFirstField.bind(this);
    this.onDropAttachment = this.onDropAttachment.bind(this);
    this.cachedDocumentExtenderRow = this.cachedDocumentExtenderRow.bind(this);
    this.executeExtenderRows = this.executeExtenderRows.bind(this);
    this.toggleShowAlert = this.toggleShowAlert.bind (this);
    this.setAuditTab = this.setAuditTab.bind(this);
    this.undeleteDocument = this.undeleteDocument.bind(this);
    this.analyzeTemplate = this.analyzeTemplate.bind(this);
    this.onHotKey = this.onHotKey.bind(this);
    this.expandView = this.expandView.bind(this);
    this.hideExpandedView = this.hideExpandedView.bind(this);
    this.onpopstate = this.onpopstate.bind(this);
    this.downloadDocumentAndAttachments = this.downloadDocumentAndAttachments.bind(this);
    this.onMagicScroll = this.onMagicScroll.bind(this);
    this.onAuditChange = this.onAuditChange.bind(this);
    this.toggleAuditVars = this.toggleAuditVars.bind(this);
    this.executeOnDemandPlugin = this.executeOnDemandPlugin.bind(this);
    this.showIntegrationAlertPopup = this.showIntegrationAlertPopup.bind(this);
    this.adknowledgeIntegrationAlert = this.adknowledgeIntegrationAlert.bind(this);
    this.hideIntegrationAlert = this.hideIntegrationAlert.bind(this);
    this.handleRuntimeMenuClick = this.handleRuntimeMenuClick.bind(this);
    this.defaultSuggestionClick = this.defaultSuggestionClick.bind(this);
    this.readerSuggestionClick = this.readerSuggestionClick.bind(this);
    this.createTemplate = this.createTemplate.bind(this);
    this.hideCreateTemplate = this.hideCreateTemplate.bind(this);
    this.createTemplate2 = this.createTemplate2.bind(this);
    this.editNewTemplateName = this.editNewTemplateName.bind(this);
    this.downloadAuditClick = this.downloadAuditClick.bind(this);
    this.onSystemSettingsChange = this.onSystemSettingsChange.bind(this);
    this.routeToTrinFormsClick = this.routeToTrinFormsClick.bind(this);
    this.getTrinFormsUrl = this.getTrinFormsUrl.bind(this);
    this.showSaveError = this.showSaveError.bind(this);
    this.toggleAudit = this.toggleAudit.bind(this);
    this.onClickRowColumnHeader = this.onClickRowColumnHeader.bind(this);
    this.onClickSortByRowId = this.onClickSortByRowId.bind(this);
    this.getCurrentSort = this.getCurrentSort.bind(this);
    this.getSortedRows = this.getSortedRows.bind(this);
    this.toggleIntakeLogRow = this.toggleIntakeLogRow.bind(this);
    this.sendToAICapture = this.sendToAICapture.bind(this);
    this.onClickSendToAICapture = this.onClickSendToAICapture.bind(this);
    this.cancelAICaptureConfirm = this.cancelAICaptureConfirm.bind(this);
  }

  componentDidUpdate() {
    if (this.state.loadExtenderRows){
      //this.executeExtenderRows();
      this.setState({ loadExtenderRows: false });
    }
    //this.checkDocumentUpdate();
    // when you navigate to or from related docs, load necessary document
    if (this.state.relatedDocChange) {
      this.setState({ relatedDocChange: false });
      this.loadDocumentFromDB();
    }
  }

  componentDidMount() {
    DocumentStore.addChangeListener(this.onDocumentChange);
    SearchStore.addChangeListener(this.onSearchUpdate);
    BPStore.addChangeListener(this.onBPChange);
    BulkActionStore.addChangeListener(this.onBulkChange);
    HotKeyStore.addChangeListener(this.onHotKey);
    AuditStore.addChangeListener(this.onAuditChange);
    ReadersStore.addChangeListener(this.onReaderChange);
    DefaultsStore.addChangeListener(this.onDefaultChange);
    SystemSettingsStore.addChangeListener(this.onSystemSettingsChange);
    //var docEditor = document.getElementById('tdDocEditor');
    window.onresize = this.onWindowResize;
    window.onpopstate = this.onpopstate;
    document.onmouseleave = this.windowMouseLeave;
    // window.history.listen((location, action) => {
    // });
    //window.addEventListener('beforeunload', this.beforeUnloadListener);
    GetDocumentZoomSetting();

    this.loadDocumentFromDB();
    this.setState({ isLoading: true });
    var returnUrl = localStorage.getItem('docReturn');
    if (returnUrl) {
      this.setState({ returnUrl: returnUrl });
    }

    GetSystemSettings2();

  }

  componentWillUnmount() {
    DocumentStore.removeChangeListener(this.onDocumentChange);
    SearchStore.removeChangeListener(this.onSearchUpdate);
    BPStore.removeChangeListener(this.onBPChange);
    BulkActionStore.removeChangeListener(this.onBulkChange);
    HotKeyStore.removeChangeListener(this.onHotKey);
    AuditStore.removeChangeListener(this.onAuditChange);
    ReadersStore.removeChangeListener(this.onReaderChange);
    DefaultsStore.removeChangeListener(this.onDefaultChange);
    SystemSettingsStore.removeChangeListener(this.onSystemSettingsChange);
    //var docEditor = document.getElementById('tdDocEditor');
    //window.removeEventListener('beforeunload', this.beforeUnloadListener);

    if (this.state.currentDoc !== undefined) {
      CheckIn(this.state.currentDoc.documentId, this.state.currentDoc);
    }
  }

  //componentWillReceiveProps() {
  //   this.loadDocumentFromDB();
  onSearchUpdate() {
    let lastAction = SearchStore.getLastAction();
    if (lastAction === actionTypes.SearchQuickSearch) {
      let docCount = SearchStore.getDocCount();
      if (docCount === 1) {
        if (this.state.currentDoc !== undefined) {
          CheckIn(this.state.currentDoc.documentId, this.state.currentDoc);
        }
        let docId = SearchStore.getDocList()[0];
        GetDocument(docId.toString());
      }
    }
  }

  loadDocumentFromDB() {
    let loc = window.location.pathname;
    let pathParts = loc.split('/');
    let docId = parseInt(pathParts[pathParts.length - 1], 10);

    let params = new URLSearchParams(window.location.search);
    var related = params.get('related');

    if (related) {
      GetDocument(docId.toString(), related.toString());
    } else {
      GetDocument(docId.toString(), null);
    }
    GetAvailableTemplates(docId.toString());
  }

  onDocumentChange() {
    let lastChange = DocumentStore.lastChange();
    if (lastChange === 'LoadDoc') {
      let doc = DocumentStore.getCurrentDocuent();

      console.log('this is the document....');
      console.log(doc);

      if (doc.canView) {
        console.log('loading');
        document.title = `TrinDocs - Doc:${doc.documentId}`
        let params = new URLSearchParams(window.location.search);
        //var related = params.get('related');
        // if (!related) {
        //   window.history.pushState(null, '', `/Document/${doc.documentId}`);
        // }
        let userCanEdit = doc.canEdit;
        let userCanSubmit = doc.canApprove;
        let userCanSendToReview = doc.canImageReview;
        let userCanAddNotes = doc.canAddNotes;
        let userCanDelete = doc.canDelete;
        let userCanMoveAssign = doc.canMoveAssign;
        let userCanDownload = doc.canDownload;
        GetImages(doc.documentId);
        LoadReaders();
        LoadDefaults();
        // build the entire next-document state and commit it in ONE setState;
        let newState = {
          currentDoc: doc,
          currentImage: undefined,
          loadingImage: true,
          attachmentCount: doc.attachments.length,
          newNote: '',
        };
        if (doc.pinUserNotes) {
          let ivw = window.innerWidth - 280 - 20 - 280;

          newState.showUserNotes = true;
          newState.imageviewerWidth = ivw;
        }
        if (doc.topHeight) {
          let newH = doc.topHeight;
          let navH = document.getElementById('tdAppHeader').clientHeight + 2;
          let menuH = document.getElementById('tdDocumentMenu').clientHeight + 2;
          let rdBar = document.getElementById('relatedDocsBar');
          let rdBarH = 0;
          if(rdBar !== null) rdBarH = rdBar.clientHeight + 1;
          let related = document.getElementById('deRlatedDocs');

          let newTableHeight = window.innerHeight - newH - 239;
          let newB = window.innerHeight - newH - navH - menuH - rdBarH - 10;
          if (related) {
            newB = newB - related.clientHeight;
          }
          if (newB <= 8) newB = 8;
          newState.topHeight = newH;
          newState.bottomHeight = newB;
          newState.imageviewerHeight = newH - 32;
          newState.tableHeight = newTableHeight;
        }
        if (doc.fieldSets.length > 0) {

          newState.currentFieldSet = doc.fieldSets[0];

          let tw = 120;
          tw += 40;
          if (this.state.showChecks) tw += 60;
          doc.fieldSets[0].fieldDefs.forEach((fd) => (tw += fd.colWidth));
          tw += 20;
          //this.setState({tableWidth: tw});

          doc.fieldSets.forEach((fs) => {
            fs.rows.forEach((row) => {
              row.fieldData.forEach((field) => {
                let fieldDef = fs.fieldDefs.find(
                  (f) => f.fieldId === field.fieldId
                );
                field.isNew = false;
                field.isDeleted = false;
                field.fieldDef = fieldDef;
                field.error = '';
              });
            });
          });

          let rd = doc.fieldSets[0].rows;

          let nextRowId = 1;
          rd.forEach((row) => {
            if (row.rowId >= nextRowId) nextRowId = row.rowId + 1;
          });
          let newRow = {
            rowId: nextRowId,
            dbRowId: -1,
            isNew: true,
            isChecked: false,
            isDeleted: false,
            fieldData: [],
          };
          if (doc.fieldSets.length > 0) {
              doc.fieldSets[0].fieldDefs.forEach((fd) => {

                let newField = {
                  fieldId: fd.fieldId,
                  fieldDef: fd,
                  fieldValue: '',
                  displayOrder: fd.displayOrder,
                  fieldDataType: 0,
                  allowedValues: [],
                  directChildDependents: fd.directChildDependents,
                  error: '',
                };
                //
                if (fd.hasExtender) {
                  newField.allowedValues = fd.extender.allowedValues;
                }

                newRow.fieldData.push(newField);

            });

            newRow.extenderDependencies = [...doc.extenderDependencies];
            rd.push(newRow);
            //this.ValidateDocument();
            //this.setState({ rowData: rd, fieldsHaveError: false });
          }

          newState.rowData = rd;
          newState.fieldsHaveError = false;


        }
        //let deps = doc.fieldSets[0].rowDependencies;
        // deps.forEach((dep) => {
        //   ExecuteExtender(
        //     dep.extenderId,
        //     this.getExtenderData(),
        //     '',
        //     dep.fieldId,
        //     doc.fieldSets[0].fieldSetId,
        //     newRow.rowId
        //   );
        // });

        //Set(doc.headerDependencies);
        // header dependency extenders moved into the setState callback below —
        // getExtenderData() reads this.state.currentDoc, so the new document
        // must be committed first

        if(doc.fieldSets.length > 0)
        {

          //.log(rd);
        }

        // execute extenders for rows
        // let i = 0;
        // doc.fieldSets.forEach((fs) => {
        //   fs.rows.forEach((row) => {
        //       this.processExtenderRow(row, fs);
        //       i++;
        //   });
        //   // if (fs.rows.length > 0){
        //   //   let firstRow = fs.rows[0];
        //   //   this.processFirstExtenderRow(firstRow, fs);
        //   // }


        // });


        if (doc.checkedOutStatus === 'ImageReview') {
          userCanEdit = false;
          userCanSubmit = false;
          userCanSendToReview = false;

          newState.lockedByMe = false;
          newState.lockedByOther = false;
        } else if (doc.checkedOutStatus === 'owner') {
          newState.lockedByMe = true;
          newState.lockedByOther = false;
        } else if (doc.checkedOutStatus === 'other') {
          newState.lockedByMe = false;
          newState.lockedByOther = true;
          newState.checkedOutBy = doc.checkedOutUser;
          userCanSubmit = false;
          userCanEdit = false;
          userCanSendToReview = false;
        } else if (doc.checkedOutStatus === 'Queue') {
          newState.lockedByMe = false;
          newState.lockedByOther = false;
          newState.checkedOutBy = 'Nobody';
          userCanSubmit = false;
          userCanEdit = false;
          userCanSendToReview = false;
        }

        //console.log(doc);
        newState.workflowName = doc.workflowName;
        newState.formTypeName = doc.formTypeName;
        newState.documentID = doc.documentId;
        newState.stepName = doc.stepName;
        newState.userCanEdit = userCanEdit;
        newState.userCanSubmit = userCanSubmit;
        newState.userCanSendToReview = userCanSendToReview;
        newState.userCanAddNotes = userCanAddNotes;
        newState.userCanDownload = userCanDownload;
        newState.userCanDelete = userCanDelete;
        newState.userCanMoveAssign = userCanMoveAssign;
        newState.currentDocId = doc.documentId;

        this.setState(newState, () => {
          // runs after the new document state is committed
          if (doc.fieldSets.length > 0 && doc.stepType !== 'End') {
            console.log('Extender rows');
            this.executeExtenderRows();
          }
          if (doc.headerDependencies !== undefined && doc.stepType !== 'End') {
            doc.headerDependencies.forEach((hd) => {
              if (hd.hasExtender) {
                console.log(`Execute extender ${hd.fieldId}`);
                ExecuteExtender(
                  hd.extenderId,
                  this.getExtenderData(),
                  '',
                  hd.fieldId,
                  0,
                  'pageLoad',
                  null,
                  null,
                  doc.documentId
                );
              }
            });
          }
          this.initSnapshot();
          this.focusFirstField();
          this.setState({ isLoading: false, newNote: '', loadExtenderRows: true });
        });
      } else {
        this.setState({
          preventViewing: true,
          documentID: doc.documentId,
          isLoading: false,
          newNote: '',
          loadExtenderRows: true
        });
      }

      if (doc.integrationAlerts.length > 0){
        this.showIntegrationAlertPopup();
      }
    }
    if (lastChange === actionTypes.ImageLoad) {
      try {
        var imageList = DocumentStore.getImages();
        var curImage = undefined;
        if (imageList !== undefined && imageList.length > 0) {
          curImage = imageList[0];
        }
        this.setState({
          images: imageList,
          currentImage: curImage,
          imageCount: imageList.length,
          loadingImage: false,
        });
        if (imageList.length > 1) {
          // load the second image in the background
          FetchImage(this.state.currentDoc.documentId, 2);
        }
      } catch {
        this.setState({
          currentImage: undefined,
          images: [],
          loadingImage: false,
        });
      }
    }
    if (lastChange === actionTypes.ImageFetch) {
      this.setState({ loadingImage: false });
      imageList = DocumentStore.getImages();
      this.setState({
        images: imageList,
        isRotatingLeft: false,
        isRotatingRight: false,
      });

      if (this.state.currentImage !== undefined && curImage !== undefined) {
        if (
          this.state.currentImage.imageBytes === null &&
          this.state.currentImage.pageId === curImage.pageId
        ) {
          curImage = imageList[curImage.pageId - 1];
          this.setState({ currentImage: curImage, loadingImage: false });
        }
      }
    }
    if (lastChange === actionTypes.DocumentSave) {
      this.setState({ isSaving: false }, this.initSnapshot());
      console.log(this.state.currentDoc);
      GetDocumentStatusInfo(this.state.currentDocId);

      GetAssignees(this.state.currentDocId);

      GetRelatedDocs(this.state.currentDocId);

      //GetDocument(this.state.currentDocId);
    }
    if (lastChange === actionTypes.DocumentSubmit) {
      let result = DocumentStore.getSubmitResult();
      console.log(result);
      if (result.status === 'Submitted' || result.status === 'Success'){
        this.initSnapshot();
            this.setState({ isSaving: false, isSubmitting: false }, () =>
          this.handleNextClick(true)
        );
      }
      else{
        this.setState({ isSubmitting: false, isSaving: false });
        if(result.status === 'Alert')
        {
          this.setState({showAlert: true, alertTitle: 'Failed to submit', alertMessage: result.message, alertNextOnClose: true});
        }
      }
      //this.handleNextClick();
    }
    if (lastChange === actionTypes.DocumentToImageReview) {
      this.handleNextClick(true);
    }
    if (lastChange === actionTypes.DocumentDelete) {
      this.setState({ showDeleteConfirm: false });
      this.handleNextClick(true);
      
    }
    if (lastChange === actionTypes.DocumentEndOfList) {
      var link = document.getElementById('backLink');
      link.click();
    }
    if (lastChange === actionTypes.DocumentAddNote) {

      var doc = this.state.currentDoc;
      var newNote = DocumentStore.getNote();
      doc.userNotes.splice(0, 0, newNote);
      this.setState({ currentDoc: doc });
    }

    if (lastChange === actionTypes.DocumentGetAudit) {
      let audit = DocumentStore.getAuditInfo();
      this.setState({ auditInfo: audit, isAuditLoading: false });
    }

    if (lastChange === actionTypes.DocumentGetAvailTemplates) {
      let templates = DocumentStore.getAvailTemplates();
      this.setState({ availableTemplates: templates });
    }
    if (lastChange === actionTypes.DocumentUpdateTemp) {
      let doc = DocumentStore.getCurrentDocuent();
      this.loadDocumentFromDB();
      this.setState({
        currentDoc: doc,
        showTemplateChange: false,
        inProgressAnimation: false,
      });
    }
    if (lastChange === actionTypes.DocumentUpdateTempWDoc) {
      let doc = DocumentStore.getCurrentDocuent();
      this.loadDocumentFromDB();
      this.setState({
        currentDoc: doc,
        showTemplateChange: false,
        inProgressAnimation: false,
      });
    }
    if (lastChange === actionTypes.DocumentUpdateMoveTemp) {
      this.setState({ showTemplateChange: false, inProgressAnimation: false, });
      this.initSnapshot();
      this.setState({ isSaving: false, isSubmitting: false }, () =>
          this.handleNextClick(true)
      );
    }
    if (lastChange === actionTypes.DocumentGetRelatedDocs) {
      let doc = this.state.currentDoc;
      let related = DocumentStore.getRelatedDocs();
      if(related.length > 0)
      {
        doc.hasRelatedDocs = true;
        doc.relatedDocuments = related;
      } else
      {
        doc.hasRelatedDocs = false;
        doc.relatedDocuments = [];
      }
      this.setState({currentDoc: doc});
    }

    if (lastChange === actionTypes.DocumentGetStatusInfo) {
      let doc = this.state.currentDoc;
      let info = DocumentStore.getDocStatus();
      doc.queueAssignments = [...info.assignments];
      let userCanEdit = info.canEdit;
      let userCanSubmit = info.canApprove;
      let userCanSendToReview = info.canImageReview;
      let userCanAddNotes = info.canAddNotes;
      let userCanDelete = info.canDelete;
      let userCanMoveAssign = info.canMoveAssign;
      let userCanDownload = info.userCanDownload;
      doc.checkedOutStatus = info.checkOutStatus;

      this.setState({ currentDoc: doc, queuesDirty: false, isSaving: false });
      this.setState({
        userCanEdit: userCanEdit,
        userCanSubmit: userCanSubmit,
        userCanSendToReview: userCanSendToReview,
        userCanAddNotes: userCanAddNotes,
        userCanDelete: userCanDelete,
        userCanMoveAssign: userCanMoveAssign,
        userCanDownload: userCanDownload,
        currentDocId: doc.documentId,
      });

      if (doc.checkedOutStatus === 'ImageReview') {
        userCanEdit = false;
        userCanSubmit = false;
        userCanSendToReview = false;

        this.setState({
          //userCanSubmit: false,
          //userCanEdit: false,
          lockedByMe: false,
          lockedByOther: false,
          //userCanSendToReview: false,
        });
      } else if (doc.checkedOutStatus === 'owner') {
        //this.setState({ userCanSubmit: true });
        //this.setState({ userCanEdit: true });
        this.setState({
          lockedByMe: true,
          lockedByOther: false,
          //userCanSendToReview: true,
        });
      } else if (doc.checkedOutStatus === 'other') {
        this.setState({
          lockedByMe: false,
          lockedByOther: true,
          checkedOutBy: doc.checkedOutUser,
          //userCanSendToReview: false,
          //userCanSubmit: false,
          //userCanEdit: false,
        });
        userCanSubmit = false;
        userCanEdit = false;
        userCanSendToReview = false;
      } else if (doc.checkedOutStatus === 'Queue') {
        this.setState({
          lockedByMe: false,
          lockedByOther: false,
          checkedOutBy: 'Nobody',
          //userCanSendToReview: false,
          //userCanSubmit: false,
          //userCanEdit: false,
        });
        userCanSubmit = false;
        userCanEdit = false;
        userCanSendToReview = false;
      }
    }
    if (lastChange === actionTypes.DocumentChagneQueue) {
      let doc = DocumentStore.getCurrentDocuent();
      let userCanEdit = doc.canEdit;
      let userCanSubmit = doc.canApprove;
      let userCanSendToReview = doc.canImageReview;
      let userCanDelete = doc.canDelete;
      if (doc.checkedOutStatus === 'ImageReview') {
        userCanEdit = false;
        userCanSubmit = false;
        userCanSendToReview = false;

        this.setState({
          lockedByMe: false,
          lockedByOther: false,
        });
      } else if (doc.checkedOutStatus === 'owner') {
        this.setState({
          lockedByMe: true,
          lockedByOther: false,
        });
      } else if (doc.checkedOutStatus === 'other') {
        this.setState({
          lockedByMe: false,
          lockedByOther: true,
          checkedOutBy: doc.checkedOutUser,
        });
      } else if (doc.checkedOutStatus === 'Queue') {
        this.setState({
          lockedByMe: false,
          lockedByOther: false,
          checkedOutBy: 'Nobody',
        });

        userCanSubmit = false;
        userCanEdit = false;
        userCanSendToReview = false;
        userCanDelete = false;
      }
      this.setState({
        currentDoc: doc,
        userCanSubmit: userCanSubmit,
        userCanEdit: userCanEdit,
        userCanSendToReview: userCanSendToReview,
        userCanDelete: userCanDelete,
      });
    }
    if (lastChange === actionTypes.DocumentExtender) {
      let doc = this.state.currentDoc;
      let extId = DocumentStore.getLastExtenderId();
      let ext = DocumentStore.getExtender(extId);
      let header = doc.headerFields.find(
        (h) => h.hasExtender && h.extender.extenderId === extId
      );

      if (header) {
        // header.fieldValue = ext.defaultValue;
        // header.extenderKey = extId;
        header.extender.allowedValues = ext.allowedValues;
        let dep = this.findDependency(doc.headerDependencies, header.fieldId);

        let matchingKey = ext.allowedValues.find(
          (ex) =>
            //ex.extenderKey === header.extenderKey ||
            // ex.extenderKey === header.fieldValue ||
            ex.textValue.toLowerCase() === header.fieldValue.toLowerCase()
        );
        if (matchingKey === undefined) {
          matchingKey = ext.allowedValues.find(
            (ex) => ex.extenderKey === header.extenderKey
            // ex.extenderKey === header.fieldValue ||
            //ex.textValue === header.fieldValue
          );
        }

        let matchingDefault = undefined;
        if(ext.defaultValue !== null)
        {
          matchingDefault = ext.allowedValues.find(
          (ex) =>
              ex.textValue.toLowerCase() === ext.defaultValue.toLowerCase()
          );
        }

        header.error = '';
        let fieldEdit = false;
        if (header.fieldValue === '') {
          // if only one allowed Value,  go with it
          if (header.extender.allowedValues.length === 1) {
            header.fieldValue = ext.allowedValues[0].textValue;
            header.extenderKey = ext.allowedValues[0].extenderKey;
            fieldEdit = true;
          }
          //  else if there's a default
          else if (ext.defaultValue !== null) {
            matchingKey = ext.allowedValues.find(
              (ex) => ex.ExtenderKey === ext.defaultValue.toString()
            );
            if (matchingKey) {
              header.fieldValue = matchingKey.textValue;
              header.extenderKey = matchingKey.extenderKey;
              fieldEdit = true;
            } else {
              matchingKey = ext.allowedValues.find(
                (ex) => ex.textValue.toUpperCase() === ext.defaultValue.toUpperCase()
              );
              if (matchingKey) {
                header.fieldValue = matchingKey.textValue;
                header.extenderKey = matchingKey.extenderKey;
                fieldEdit = true;
              }
            }
          } else {
            // else just populate first one
            //header.fieldValue = header.extender.allowedValues[0].textValue;
            //header.extenderKey = header.extender.allowedValues[0].extenderKey;
            fieldEdit = true;
          }
        } else {
          // header is not blank
          let matched = false;
          if (matchingKey !== null && matchingKey !== undefined) {
            header.fieldValue = matchingKey.textValue;
            header.extenderKey = matchingKey.extenderKey;
            matched = true;

          } else if(matchingDefault !== null && matchingDefault !== undefined) {
            header.fieldValue = matchingDefault.textValue;
            header.extenderKey = matchingDefault.extenderKey;
            matched = true;

          } else if (
            header.extender.allowedValues.length === 1 &&
            header.extender.allowedValues[0].textValue !== ''
          ) {
            header.fieldValue = header.extender.allowedValues[0].textValue;
            header.extenderKey = header.extender.allowedValues[0].extenderKey;

            matched = true;
          } else {
            header.error = `Unknown value: ${header.fieldValue}`;

          }

          if(matched) {

            let hasRowchildren = false;
            doc.fieldSets.forEach((fs) => {
              fs.headerDependencies.forEach((hd) => {
                if (hd.fieldId === dep.fieldId) {
                  hasRowchildren = true;
                }
              });
              if(hasRowchildren) {
                fs.rows.forEach((row) => {
                  fs.rowDependencies.forEach((rd) => {
                    if (rd.hasExtender) {
                      this.processRowExtender(rd.fieldId, fs, row, doc, ext.exeSource);
                    }
                  });
                });
              }
            });
          }
        }



        // call child extenders
        let eData = this.getExtenderData();
        let u = eData.find((f) => f.fieldId === header.fieldId);
        if (u) {
          u.KeyValue = header.extenderKey;
        }
        if (dep.childNodes !== undefined && dep.childNodes.length > 0) {
          dep.childNodes.forEach((hd) => {
            if (hd.hasExtender) {
              //let d = this.getExtenderData();
              ExecuteExtender(
                hd.extenderId,
                eData,
                '',
                hd.fieldId,
                0,
                ext.exeSource,
                null,
                null,
                doc.documentId

              );
            }
          });
        }

        // call child rows
        doc.fieldSets.forEach((fs) => {
        });
        //if (fieldEdit) {

        //}
      }
      this.setState({ currentDoc: doc });
    }
    if (lastChange === actionTypes.DocumentExtenderRow) {
      let extId = DocumentStore.getLastRowExtenderId();
      let rowId = DocumentStore.getLastRowId();
      let key = DocumentStore.getLastKey();
      let ext = DocumentStore.getRowExtender(extId, key);
      let fieldSetId = DocumentStore.getLastFieldSet();
      let doc = this.state.currentDoc;
      if(ext.key !== undefined)
      {
        let fieldSet = doc.fieldSets.find((fs) => fs.fieldSetId === fieldSetId);
        //let row = fieldSet.rows.find((r) => r.rowId === rowId);


        let pending = _pendingKeys.find(pk => pk.extId === extId && pk.key === ext.key);
        if(pending !== null && pending !== undefined)
        {

          pending.pendingFields.forEach((pf) => {
            let fieldSet = doc.fieldSets.find((fs) => fs.fieldSetId === pf.fieldSetId);
            let rows = fieldSet.rows;
            let row = rows.find((r) => r.rowId === pf.rowId);

            let column = row.fieldData.find(
              (f) => f.fieldDef.fieldId === pf.fieldId
            );
            if (column) {
              let dep = this.findDependency(fieldSet.rowDependencies, column.fieldId);
              column.allowedValues = [...ext.allowedValues];
              if(ext.defaultValue !== undefined && ext.defaultValue !== null)
              {
                column.defaultValue = ext.defaultValue;
              }
              let matchingRowKey = ext.allowedValues.find(
                (ex) =>
                  ex.textValue === column.fieldValue
              );

              if (column.fieldValue === '') {
                // field is currently blank
                if (column.allowedValues.length === 1 && row.isNew === false) {

                  column.fieldValue = column.allowedValues[0].textValue;
                  column.extenderKey = column.allowedValues[0].extenderKey;
                }
                //  else if there's a default
                else if (ext.defaultValue !== undefined && ext.defaultValue !== null && column.allowedValues.length > 0 && row.isNew === false) {

                  matchingRowKey = ext.allowedValues.find(
                    (ex) => ex.ExtenderKey === ext.defaultValue.toString() ||
                    ex.textValue === ext.defaultValue.toString()
                  );
                  if (matchingRowKey) {
                    console.log('set default');
                    column.fieldValue = matchingRowKey.textValue;
                    column.extenderKey = matchingRowKey.extenderKey;
                  }
                } else {
                  // else just populate first one
                  //column.fieldValue = column.allowedValues[0].textValue;
                  //column.extenderKey = column.allowedValues[0].extenderKey;
                  //blankit
                }
              } else {
                // header is not blank
                let matchingRowKey = column.allowedValues.find(
                  (ex) =>
                    (ex.textValue === column.fieldValue)
                );
                if(matchingRowKey === undefined && column.allowedValues.length === 1)
                {
                  // no match, but one result... override
                  column.fieldValue = column.allowedValues[0].textValue;
                  column.extenderKey = column.allowedValues[0].extenderKey;
                  column.error = '';
                  //column.error = `Unknown value "${column.fieldValue}"`;
                } else if(matchingRowKey !== undefined)
                {
                  // we have a matching text value,  make sure the extKey is uptodate
                  column.extenderKey = matchingRowKey.extenderKey;
                  column.error = '';

                }else
                {
                  // we have a garbage value, make it red
                  column.error = `Unknown value "${column.fieldValue}"`;
                }

              }

              if (column.fieldValue !== '' && column.error === '') {
                // call child extenders
                //let eData = this.getExtenderData(row);
                //let ed = this.getExtenderData2(d.fieldId, fieldSet.depMap, fieldSet.fieldSetId, row.fieldData, doc.depMap, doc.headerFields);
                if(dep.childNodes.length > 0) {
                  dep.childNodes.forEach((d) => {
                    if(d.hasExtender) {
                      this.processRowExtender(d.fieldId, fieldSet, row, doc, ext.exeSource)
                    }
                  });

                }

              //   let u = eData.find((f) => f.fieldId === column.fieldId);
              //   if (u) {
              //     u.KeyValue = column.extenderKey;
              //   }
              //   if (dep.childNodes !== undefined && dep.childNodes.length > 0) {
              //     dep.childNodes.forEach((hd) => {
              //       if (hd.hasExtender) {
              //         //let d = this.getExtenderData();

              //         ExecuteExtender(
              //           hd.extenderId,
              //           eData,
              //           '',
              //           hd.fieldId,
              //           fieldSetId,
              //           ext.exeSource,
              //           row.rowId
              //         );
              //       }
              //     });
              //   }
              // }
              }
            }
          });
        }
        _existingKeys.push({
          extId: pending.extId,
          key: pending.key,
          allowedValues: [...ext.allowedValues]
        });
        let idx = _pendingKeys.indexOf(pending);
        _pendingKeys.splice(idx, 1);
      }

      // let fieldSet = doc.fieldSets.find((fs) => fs.fieldSetId === fieldSetId);
      // let rows = fieldSet.rows;
      // let row = rows.find((r) => r.rowId === rowId);


      // let column = row.fieldData.find(
      //   (f) => f.fieldDef.fieldId === ext.fieldId
      // );

      // if (column) {
      //   let dep = this.findDependency(fieldSet.rowDependencies, column.fieldId);
      //   column.allowedValues = [...ext.allowedValues];

      //     if (!column.extenderKey) {
      //       column.extenderKey = '-1';
      //     }

      //     let matchingRowKey = ext.allowedValues.find(
      //       (ex) =>
      //         ex.ExtenderKey === column.extenderKey.toString() ||
      //         ex.ExtenderKey === column.fieldValue ||
      //         ex.textValue === column.fieldValue
      //     );

      //     if (column.fieldValue === '') {
      //       // field is currently blank

      //       if (column.allowedValues.length === 1) {
      //         column.fieldValue = column.allowedValues[0].textValue;
      //         column.extenderKey = column.allowedValues[0].extenderKey;
      //       }
      //       //  else if there's a default
      //       else if (ext.defaultValue !== null) {
      //         matchingRowKey = ext.allowedValues.find(
      //           (ex) => ex.ExtenderKey === ext.defaultValue.toString()
      //         );
      //         if (matchingRowKey) {
      //           column.fieldValue = matchingRowKey.textValue;
      //           column.extenderKey = matchingRowKey.extenderKey;
      //         }
      //       } else {
      //         // else just populate first one
      //         //column.fieldValue = column.allowedValues[0].textValue;
      //         //column.extenderKey = column.allowedValues[0].extenderKey;
      //         //blankit
      //       }
      //     } else {
      //       // header is not blank
      //       if (matchingRowKey !== null && matchingRowKey !== undefined) {
      //         column.fieldValue = matchingRowKey.textValue;
      //         column.extenderKey = matchingRowKey.extenderKey;
      //         column.textValue = matchingRowKey.textValue;
      //         column.error = '';
      //       } else if (
      //         column.allowedValues.length === 1 &&
      //         column.allowedValues[0].textValue
      //       ) {
      //         column.fieldValue = column.allowedValues[0].textValue;
      //         column.textValue = column.allowedValues[0].textValue;
      //         column.extenderKey = column.allowedValues[0].extenderKey;
      //         column.error = '';
      //       } else {
      //         if (ext.exeSource === 'pageLoad') {
      //           this.errorRowField(
      //             fieldSet.fieldSetId,
      //             row.rowId,
      //             column.fieldId
      //           );
      //         } else {
      //           this.blankRowField(
      //             fieldSet.fieldSetId,
      //             row.rowId,
      //             column.fieldId
      //           );
      //         }
      //       }
      //     }
      //     this.setState({ currentDoc: doc });

      //     if (column.fieldValue !== '' && column.error === '') {
      //       // call child extenders
      //       let eData = this.getExtenderData(row);

      //       let u = eData.find((f) => f.fieldId === column.fieldId);
      //       if (u) {
      //         u.KeyValue = column.extenderKey;
      //       }
      //       if (dep.childNodes !== undefined && dep.childNodes.length > 0) {
      //         dep.childNodes.forEach((hd) => {
      //           if (hd.hasExtender) {
      //             //let d = this.getExtenderData();

      //             ExecuteExtender(
      //               hd.extenderId,
      //               eData,
      //               '',
      //               hd.fieldId,
      //               fieldSetId,
      //               ext.exeSource,
      //               row.rowId
      //             );
      //           }
      //         });
      //       }
      //     }

      // }
      this.setState({ currentDoc: doc });
    }
    if (lastChange === actionTypes.DocumentFirstExtenderRow) {
      let extId = DocumentStore.getLastRowExtenderId();
      let rowId = DocumentStore.getLastRowId();
      let key = DocumentStore.getLastKey();
      let ext = DocumentStore.getRowExtender(extId, key);

      let fieldSetId = DocumentStore.getLastFieldSet();
      let doc = this.state.currentDoc;

      let independentExtenders = DocumentStore.getIndependentRowExtenders();
      let independentExtender = independentExtenders.find((fs) => fs.extenderId === extId);

      let fieldSet = doc.fieldSets.find((fs) => fs.fieldSetId === fieldSetId);
      let rows = fieldSet.rows;
      let row = rows.find((r) => r.rowId === rowId);

      if (independentExtender !== undefined){
        let i = 0;
        // for this field set only
        //let fs = doc.fieldSets.find((f) => f.fieldSetId === fieldSetId);
          fieldSet.rows.forEach((r) => {
            i++;
            if (i > 1){
              let col = r.fieldData.find(
                (f) => f.fieldDef.fieldId === ext.fieldId
              );
              col.allowedValues = [...independentExtender.allowedValues];
            }

          });
      }



      if (row.isNew) {
      }
      if (!row.isNew) {
      }
      let column = row.fieldData.find(
        (f) => f.fieldDef.fieldId === ext.fieldId
      );

      if (column) {
        let dep = this.findDependency(fieldSet.rowDependencies, column.fieldId);
        column.allowedValues = [...ext.allowedValues];

        if (!row.isNew) {
          if (!column.extenderKey) {
            column.extenderKey = '-1';
          }

          let matchingRowKey = ext.allowedValues.find(
            (ex) =>
              ex.ExtenderKey === column.extenderKey.toString() ||
              ex.ExtenderKey === column.fieldValue ||
              ex.textValue === column.fieldValue
          );

          if (column.fieldValue === '') {
            // field is currently blank

            if (column.allowedValues.length === 1) {
              column.fieldValue = column.allowedValues[0].textValue;
              column.extenderKey = column.allowedValues[0].extenderKey;
            }
            //  else if there's a default
            else if (ext.defaultValue !== null) {
              matchingRowKey = ext.allowedValues.find(
                (ex) => ex.ExtenderKey === ext.defaultValue.toString()
              );
              if (matchingRowKey) {
                column.fieldValue = matchingRowKey.textValue;
                column.extenderKey = matchingRowKey.extenderKey;
              }
            } else {
              // else just populate first one
              //column.fieldValue = column.allowedValues[0].textValue;
              //column.extenderKey = column.allowedValues[0].extenderKey;
              //blankit
            }
          } else {
            // header is not blank
            if (matchingRowKey !== null && matchingRowKey !== undefined) {
              column.fieldValue = matchingRowKey.textValue;
              column.extenderKey = matchingRowKey.extenderKey;
              column.textValue = matchingRowKey.textValue;
              column.error = '';
            } else if (
              column.allowedValues.length === 1 &&
              column.allowedValues[0].textValue
            ) {
              column.fieldValue = column.allowedValues[0].textValue;
              column.textValue = column.allowedValues[0].textValue;
              column.extenderKey = column.allowedValues[0].extenderKey;
              column.error = '';
            } else {
              if (ext.exeSource === 'pageLoad') {
                this.errorRowField(
                  fieldSet.fieldSetId,
                  row.rowId,
                  column.fieldId
                );
              } else {
                this.blankRowField(
                  fieldSet.fieldSetId,
                  row.rowId,
                  column.fieldId
                );
              }
            }
          }
          this.setState({ currentDoc: doc });

          if (column.fieldValue !== '' && column.error === '') {
            // call child extenders
            let eData = this.getExtenderData(row);



            let u = eData.find((f) => f.fieldId === column.fieldId);
            if (u) {
              u.KeyValue = column.extenderKey;
            }
            if (dep.childNodes !== undefined && dep.childNodes.length > 0) {

              dep.childNodes.forEach((hd) => {
                if (hd.hasExtender) {
                  //let d = this.getExtenderData();
                  let i = 0;
                  fieldSet.rows.forEach((r) => {
                    i++;
                    let r2 = rows.find((r) => r.rowId === i);
                    let eData2 = this.getExtenderData(r2);
                    ExecuteExtender(
                      hd.extenderId,
                      eData2,
                      '',
                      hd.fieldId,
                      fieldSetId,
                      ext.exeSource,
                      i,
                      null,
                      doc.documentId
                    );
                  });
                }

              });
            }
          }
        }
      }
      this.setState({ currentDoc: doc });
    }
    if (lastChange === actionTypes.DocumentPull || lastChange === actionTypes.DocumentUndelete) {
      let pullData = DocumentStore.getPullData();
      let doc = this.state.currentDoc;
      doc.checkedOutUser = pullData.checkOutUser;
      doc.checkedOutStatus = pullData.checkedOutStatus;
      this.setState({
        checkedOutBy: pullData.checkOutUser,
        currentDoc: doc,
        lockedByMe: true,
        lockedByOther: false,
      });
      this.setState({
        userCanEdit: pullData.canEdit,
        userCanSubmit: pullData.canApprove,
        userCanSendToReview: pullData.canImageReview,
        userCanDelete: pullData.canDelete,
        currentDocId: doc.documentId,
      });
    }
    if (lastChange === 'ALTER_ATTCH') {
      let att = DocumentStore.getAttachments();
      let doc = this.state.currentDoc;
      doc.attachments = att;
      this.setState({ currentDoc: doc, attachmentCount: att.length });
    }
    if (lastChange === actionTypes.DocumentAssignUsers) {
      let assUsers = DocumentStore.getMoveAssignUsers();
      this.setState({ moveAssignUsers: assUsers.assignableUsers });
    }
    //Change bp is the only thing that uses Bulk Action
    if (lastChange === actionTypes.BulkAction) {
      // bp will have just changed, reload doc

      this.loadDocumentFromDB();
    }

    if (lastChange === actionTypes.DocumentGetAssignees) {
      let assignees = DocumentStore.getAssignees();
      let doc = this.state.currentDoc;

      doc.assignableUsers = assignees;
      this.setState({ currentDoc: doc });
      GetDocumentStatusInfo(this.state.currentDocId);
    }

    if (lastChange === actionTypes.GetDocumentZoomSetting) {
      let zoom = DocumentStore.getZoomSetting();
      this.setState({ documentZoomSetting: zoom });
    }

    if (lastChange === actionTypes.ExecuteRuntimePlugin) {
      // bp will have just changed, reload doc

      var headers = DocumentStore.getHeaderFields();
      var fieldSets = DocumentStore.getFieldSets();
      var integrationAlerts = DocumentStore.getIntegrationAlerts();

      let doc = this.state.currentDoc;

      doc.headerFields = headers;
      doc.fieldSets = fieldSets;
      doc.integrationAlerts = integrationAlerts;


      var rowData = [];
      fieldSets.forEach(fieldSet => {
        fieldSet.rows.forEach(row => {
          rowData.push(row);
        });

      });


      let rd = [];

      let currFS = null;

      if (fieldSets.length > 0) {

        currFS = fieldSets[0];
        //this.setState({ currentFieldSet: fieldSets[0] });

        let tw = 120;
        tw += 40;
        if (this.state.showChecks) tw += 60;
        fieldSets[0].fieldDefs.forEach((fd) => (tw += fd.colWidth));
        tw += 20;
        //this.setState({tableWidth: tw});

        fieldSets.forEach((fs) => {
          fs.rows.forEach((row) => {
            row.fieldData.forEach((field) => {
              let fieldDef = fs.fieldDefs.find(
                (f) => f.fieldId === field.fieldId
              );
              field.isNew = false;
              field.isDeleted = false;
              field.fieldDef = fieldDef;
              field.error = '';
            });
          });
        });

        rd = fieldSets[0].rows;

        let nextRowId = 1;
        rd.forEach((row) => {
          if (row.rowId >= nextRowId) nextRowId = row.rowId + 1;
        });
        let newRow = {
          rowId: nextRowId,
          dbRowId: -1,
          isNew: true,
          isChecked: false,
          isDeleted: false,
          fieldData: [],
        };
        if (fieldSets.length > 0) {
            fieldSets[0].fieldDefs.forEach((fd) => {

              let newField = {
                fieldId: fd.fieldId,
                fieldDef: fd,
                fieldValue: '',
                displayOrder: fd.displayOrder,
                fieldDataType: 0,
                allowedValues: [],
                directChildDependents: fd.directChildDependents,
                error: '',
              };
              //

              if (fd.hasExtender) {
                newField.allowedValues = fd.extender.allowedValues;
              }

              newRow.fieldData.push(newField);

          });

          newRow.extenderDependencies = [
            ...this.state.currentDoc.extenderDependencies,
          ];

          rd.push(newRow);
          rd.forEach((row) => {
            this.processExtenderRow2(row, currFS);
          });
        }


      }


      this.setState({ currentDoc: doc, isRunningPlugin: false,  isLoading: false, isDirty: true, rowData: rd, currentFieldSet: currFS }, this.reviewSnapshots());


      if (doc.integrationAlerts.length > 0){
        this.showIntegrationAlertPopup();
      }

    }

    if (lastChange === actionTypes.ReadIntegrationAlert) {
      this.setState({ showIntegrationAlert: false });
    }

    if(lastChange === actionTypes.DocumentCreateTemplate)
    {
      let templateId = DocumentStore.getNewTemplate();
      let templateName = DocumentStore.getNewTemplateName();
      console.log(templateId);
      if(templateId === 0)
      {
        // error
        this.setState({newTemplateError: templateName});
      } else {
        let doc = this.state.currentDoc;
        doc.templateId = templateId;
        doc.templateName = templateName;

        let selTemp = {
          templateId: templateId,
          templateName: templateName
        }

        this.setState({showCreateTemplate: false});
        let allTemplates = this.state.availableTemplates;
        allTemplates.push(selTemp);
        let filter = this.state.filteredTemplates;
        filter.push(selTemp);
        console.log(filter);
        this.setState({selectedTemplate: selTemp,
          availableTemplates: allTemplates,
          filteredTemplates: filter
        });
        if(this.state.newTemplateLink === 'TAB')
        {
          window.open('/TemplateEditor/' + templateId);
        } else {
          console.log(templateId);
          this.setState({newTemplateId: templateId}, () => {
            //let returnPath = window.location.pathname + window.location.search;
            //localStorage.setItem('docReturn', returnPath);
            let link = document.getElementById('createTempLink');
            link.click();
            //RequestNav('Template Editor', 'createTempLink');
          });

        }
      }
    }

    if (lastChange === actionTypes.GetDocumentIntakeLogs) {
      let intakeLogs = DocumentStore.getIntakeLogs();
      console.log(intakeLogs);
      this.setState({ intakeLogs: intakeLogs, showIntakeLogs: true });
    }

  }

  onAuditChange() {
    console.log('AuditChange');
    let lastChange = AuditStore.lastChange();
    if (lastChange === actionTypes.AuditUserActivity) {
      console.log('got UserActivity');
      let audit = AuditStore.getUserActivity();
      this.state.currentDoc.userNotes.forEach((note) => {
        let userNoteAudit = {
          action: 'User Note',
          documentId: this.state.currentDoc.documentId,
          eventTime: note.noteDate,
          note: note.noteText,
          performerType: 'User',
          stepId: '',
          userName: note.userName,
        }
        audit.push(userNoteAudit);

      });
      let audit3 = this.state.auditInfo3.concat(audit);
      audit = audit.sort((a,b) => { return new Date(b.eventTime) - new Date(a.eventTime) });
      audit3 = audit3.sort((a,b) => { return new Date(b.eventTime) - new Date(a.eventTime) });
      this.setState({ auditInfo: audit, fetchingUserActivity: false });
      this.setState({ auditInfo3: audit3 });
    }
    if (lastChange === actionTypes.AuditIntegration) {
      console.log('got Plugin Activity');
      let audit = AuditStore.getIntegrationActivity();
      let audit2 = this.state.auditInfo2.concat(audit);
      let audit3 = this.state.auditInfo3.concat(audit);
      audit2 = audit2.sort((a,b) => { return new Date(b.eventTime) - new Date(a.eventTime) });
      audit3 = audit3.sort((a,b) => { return new Date(b.eventTime) - new Date(a.eventTime) });

      this.setState({ auditInfo2: audit2, fetchingIntegrationActivity: false });
      this.setState({ auditInfo3: audit3 });
    }
    if (lastChange === actionTypes.AuditSysNote) {
      console.log('got System Notes');
      let audit = AuditStore.getSystemNotes();
      audit = this.state.auditInfo2.concat(audit);
      let audit3 = this.state.auditInfo3.concat(audit);
      audit = audit.sort((a,b) => { return new Date(b.eventTime) - new Date(a.eventTime) });
      audit3 = audit3.sort((a,b) => { return new Date(b.eventTime) - new Date(a.eventTime) });
      this.setState({ auditInfo2: audit, fetchingSystemNotes: false });
      this.setState({ auditInfo3: audit3 });
    }
    if (lastChange === actionTypes.AuditSystem) {
      console.log('got System Activity');
      let audit = AuditStore.getSystemActivity();
      audit = this.state.auditInfo3.concat(audit);
      audit = audit.sort((a,b) => { return new Date(b.eventTime) - new Date(a.eventTime) });
      this.setState({ auditInfo3: audit });
    }
  }

  onReaderChange() {
    let lastAction = ReadersStore.getLastAction();
    if(lastAction === actionTypes.GetReaders)
    {
      let readers = ReadersStore.getReaders();
      let allReaders = [{readerId: 0, name: 'No Reader'}, ...readers];
      this.setState({allReaders: allReaders});
    }
  }

  onDefaultChange() {
    console.log('default change');
    let lastAction = DefaultsStore.getLastAction();
    if(lastAction === actionTypes.GetDefaults)
    {
      let defaults = DefaultsStore.getDefaults();
      defaults.unshift({defaultsDBId: 0, defaultName: 'No Defaults'});
      this.setState({allDefaults: defaults});
    }
  }

  onSystemSettingsChange() {
    console.log('system settings change');
    let lastAction = SystemSettingsStore.getLastChange();
    console.log(lastAction);
    console.log(actionTypes.SystemGetSettings);
    if(lastAction === actionTypes.SystemGetSettings)
    {
      let settings = SystemSettingsStore.getSystemSettings();
      console.log('SETTINGS ARE HERE!!!!');
      console.log(settings);
      //defaults.push({defaultsDBId: 0, defaultName: 'No Defaults'});
      this.setState({trinFormsBaseUrl: settings.trinFormsUrl });
    }
  }

  onpopstate() {
    let loc = window.location.pathname;
    let pathParts = loc.split('/');
    let docId = parseInt(pathParts[pathParts.length - 1], 10);

    let params = new URLSearchParams(window.location.search);
    var related = params.get('related');
    if(related !== null && this.state.currentDocId !== related)
    {
      console.log('go to other related');
      GetDocument(docId.toString(), related.toString());
    }
    if(related === null && this.state.currentDoc.originalDocId !== this.state.currentDocId && !isNaN(docId))
    {
      console.log('go back to main');
      GetDocument(docId.toString(), null);
    }
  }

  findDependency(deps, fieldId) {

    let res = null;
    deps.forEach((d) => {
      if (d.fieldId === fieldId) {
        res = d;
      }
      if (d.childNodes !== undefined && d.childNodes.length > 0) {
        let n = this.findDependency(d.childNodes, fieldId);
        if (n !== null) res = n;
      }
    });
    return res;
  }

  blankHeaderField(fieldId, clearVals) {
    let doc = this.state.currentDoc;
    let dep = this.findDependency(doc.headerDependencies, fieldId);
    let field = doc.headerFields.find((f) => f.fieldId === fieldId);
    field.extenderKey = '-1';
    field.fieldValue = '';
    field.error = '';
    if (clearVals) {
      field.extender.allowedValues = [];
    }

    if (dep.hasExtender) {
      dep.childNodes.forEach((node) => {
        this.blankHeaderField(node.fieldId, true);
      });
    }
  }

  blankRowField(fieldSetId, rowId, fieldId) {
    let doc = this.state.currentDoc;

    let fieldSet = doc.fieldSets.find((fs) => fs.fieldSetId === fieldSetId);

    let row = fieldSet.rows.find((r) => r.rowId === rowId);
    if (row) {
      let dep = this.findDependency(fieldSet.rowDependencies, fieldId);
      let field = row.fieldData.find((f) => f.fieldId === fieldId);
      if (field) {
        field.extenderKey = '-1';
        field.fieldValue = '';
        field.error = '';

        if (dep) {
          dep.childNodes.forEach((node) => {
            this.blankRowField(fieldSetId, rowId, node.fieldId);
          });
        }
      }
    }
  }

  errorRowField(fieldSetId, rowId, fieldId) {
    let doc = this.state.currentDoc;

    let fieldSet = doc.fieldSets.find((fs) => fs.fieldSetId === fieldSetId);

    let row = fieldSet.rows.find((r) => r.rowId === rowId);
    if (row) {
      let dep = this.findDependency(fieldSet.rowDependencies, fieldId);
      let field = row.fieldData.find((f) => f.fieldId === fieldId);
      if (field) {
        if (field.fieldValue !== '') {
          field.error = `Invalid value: ${field.fieldValue}`;
          field.keyValue = '';
        }

        if (dep) {
          dep.childNodes.forEach((node) => {
            this.errorRowField(fieldSetId, rowId, node.fieldId);
          });
        }
      }
      this.setState({ currentDoc: doc });
    }
  }

  getExtenderData(row) {
    let extenderData = [];
    let doc = this.state.currentDoc;
    doc.headerFields.forEach((head) => {
      if (head.hasExtender) {
        extenderData.push({
          fieldId: head.fieldId,
          KeyValue: head.extenderKey,
        });
      }
    });
    if (row) {
      row.fieldData.forEach((field) => {
        if (field.fieldDef) {
          if (field.fieldDef.hasExtender) {
            extenderData.push({
              fieldId: field.fieldId,
              KeyValue:
                field.extenderKey !== undefined ? field.extenderKey : '',
            });
          }
        }
      });
    }

    return extenderData;
  }

  getExtenderData2(fieldId, rowFieldMap, rowFieldSetId, rowFieldData, docFieldMap, docFieldData) {
    let results = [];
    let dep2 = rowFieldMap.filter(m => m.fieldId === fieldId);
    if(dep2 !== undefined && dep2.length > 0)
    {
      dep2.forEach(d => {
        if(d.depFieldSetId === rowFieldSetId)
        {
          let fd = rowFieldData.find(f => f.fieldId === d.depFieldId);
          if(fd !== undefined)
          {
            results.push({
              fieldId: fd.fieldId,
              value: fd.fieldValue,
              key: fd.extenderKey,
            });

            //  any more dependencies
            let moreDep = rowFieldMap.filter(m => m.fieldId === fd.fieldId);
            moreDep.forEach(d2 => {
              let moreResults = this.getExtenderData2(fd.fieldId, rowFieldMap, rowFieldSetId, rowFieldData, docFieldMap, docFieldData);
              moreResults.forEach(mr => {
                let preExist = results.find(m => m.fieldId === mr.fieldId);
                if(preExist === undefined)
                {
                  results.push(mr);
                }
              });
            });
          }
        } else {

          let fd = docFieldData.find(f => f.fieldId === d.depFieldId);

          if(fd !== undefined)
          {
            //let res = this.getHeaderExtenderData(fd.fieldId, docFieldMap, docFieldData);
            //console.log(res);
             results.push({
               fieldId: fd.fieldId,
               value: fd.fieldValue,
               key: fd.extenderKey,
             });

            // console.log(results);

            // //  any more dependencies
            let moreDep = this.getHeaderExtenderData(fd.fieldId, docFieldMap, docFieldData);
            if(moreDep.length > 0)
              {
                moreDep.forEach(mr => {
                  let preExist = results.find(m => m.fieldId === mr.fieldId);
                  if(preExist === undefined)
                  {
                    results.push(mr);
                  }
                });
              }

          }

        }
      });
    }

    results.sort((a, b) => a.fieldId - b.fieldId);
    return results;
  }

  getHeaderExtenderData(fieldId, docFieldMap, docFieldData)
  {

    let result = [];
    docFieldMap.forEach(fm => {
      if(fm.fieldId === fieldId)
        {

          let fd = docFieldData.find(d => d.fieldId === fm.depFieldId);

          result.push({
            fieldId: fd.fieldId,
            value: fd.fieldValue,
            key: fd.extenderKey,
          });

          let moreDeps = this.getHeaderExtenderData(fm.depFieldId, docFieldMap, docFieldData);
          if(moreDeps.length > 0)
            {
              moreDeps.forEach(mr => {
                let preExist = result.find(m => m.fieldId === mr.fieldId);
                if(preExist === undefined)
                {
                  result.push(mr);
                }
              });
            }
        }
    });

    return result;

  }




  executeExtenderRows(){
    let doc = DocumentStore.getCurrentDocuent();
            // execute extenders for rows
      //let i = 0;
      doc.fieldSets.forEach((fs) => {
        fs.rows.forEach((row) => {
          //if(!row.isNew) {
            this.processExtenderRow2(row, fs);
            //i++;
          //}
        });
        // if (fs.rows.length > 0){
        //   let firstRow = fs.rows[0];
        //   this.processFirstExtenderRow(firstRow, fs);
        // }


      });

  }

  processExtenderRow2(row, fieldSet) {
    if (fieldSet.rowDependencies !== undefined) {
      let doc = this.state.currentDoc;
      let dep = [...fieldSet.rowDependencies];
      dep.forEach((d) => {
        if (d.hasExtender) {

            let ed = this.getExtenderData2(d.fieldId, fieldSet.depMap, fieldSet.fieldSetId, row.fieldData, doc.depMap, doc.headerFields);
            if(ed !== undefined && ed !== null)
            {
              let fullKey = '';
              let extData = [];
              ed.forEach((keyPart) => {
                fullKey = fullKey + `{${keyPart.fieldId}:${keyPart.value}}`;
                extData.push({
                  fieldId: keyPart.fieldId,
                  keyValue: keyPart.key,
                });
              });
              let cache = DocumentStore.getRowExtender(d.extenderId, fullKey);
              if(cache !== undefined)
              {
                let column = row.fieldData.find(
                  (f) => f.fieldId === d.fieldId
                );
                if(column)
                {
                  column.allowedValues = [...cache.allowedValues];
                  let hasMatch = false;
                  if (column.fieldValue === '')
                  {
                    if (column.allowedValues.length === 1 && row.isNew === false)
                    {
                      column.fieldValue = column.allowedValues[0].textValue;
                      column.extenderKey = column.allowedValues[0].extenderKey;
                      column.error = '';
                      hasMatch = true;
                    }
                  }
            else {
              let matchingRowKey = cache.allowedValues.find(
                (ex) =>
                  (ex.textValue === column.fieldValue)
              );
              if(matchingRowKey === undefined && cache.allowedValues.length === 1)
              {
                // no match, but one result... override
                column.fieldValue = column.allowedValues[0].textValue;
                column.extenderKey = column.allowedValues[0].extenderKey;
                column.error = '';
                hasMatch = true;
                //column.error = `Unknown value "${column.fieldValue}"`;
              }  else if(matchingRowKey !== undefined)
              {
                // we have a matching text value,  make sure the extKey is uptodate
                column.extenderKey = matchingRowKey.extenderKey;
                column.error = '';
                hasMatch = true;
              }
              else
              {
                // we have a garbage value, make it red
                column.error = `Unknown value "${column.fieldValue}"`;
              }
            }

            if(hasMatch)
            {
              let dep = this.findDependency(fieldSet.rowDependencies, column.fieldId);
              if(dep.childNodes.length > 0) {
                dep.childNodes.forEach((d) => {
                  if(d.hasExtender) {
                    this.processRowExtender(d.fieldId, fieldSet, row, doc, 'loadDoc')
                  }
                });

              }
            }
                }
              }
              else {
                let existingKey = _existingKeys.find((f) => f.extId === d.extenderId && f.key === fullKey);
                if(existingKey === undefined)
                {
                  // check pending keys
                  let pendingKey = _pendingKeys.find((f) => f.extId === d.extenderId && f.key === fullKey);
                  if(pendingKey === undefined)
                  {
                    // create new pending key
                    _pendingKeys.push({
                      extId: d.extenderId,
                      key: fullKey,
                      pendingFields: [
                        {
                          rowId: row.rowId,
                          fieldId: d.fieldId,
                          fieldSetId: fieldSet.fieldSetId,
                        }
                      ]
                    });
                    console.log(fullKey);
                    ExecuteExtender(
                      d.extenderId,
                      extData,
                      '',
                      d.fieldId,
                      fieldSet.fieldSetId,
                      'pageLoad',
                      row.rowId,
                      fullKey,
                      doc.documentId
                    );
                  } else {
                    pendingKey.pendingFields.push({
                      rowId: row.rowId,
                      fieldId: d.fieldId,
                      fieldSetId: fieldSet.fieldSetId,
                    });
                  }
                } else {
                  // map existing key;
                }
              }

              // locate in existing keys

            }
        }
      });

    }
  }

  processRowExtender(fieldId, fieldSet, row, doc, source) {
    let d = this.findDependency(fieldSet.rowDependencies, fieldId);
    let ed = this.getExtenderData2(fieldId, fieldSet.depMap, fieldSet.fieldSetId, row.fieldData, doc.depMap, doc.headerFields);
    if(ed !== undefined && ed !== null)
    {
      let fullKey = '';
      let extData = [];
      ed.forEach((keyPart) => {
        fullKey = fullKey + `{${keyPart.fieldId}:${keyPart.value}}`;
        extData.push({
          fieldId: keyPart.fieldId,
          keyValue: keyPart.key,
        });
      });
      let existingKey = _existingKeys.find((f) => f.extId === d.extenderId && f.key === fullKey);

      let cache = DocumentStore.getRowExtender(d.extenderId, fullKey);

      if(cache !== undefined)
      {
        if(true)
        {
          let column = row.fieldData.find(
            (f) => f.fieldDef.fieldId === fieldId
          );
          if(column)
          {
            column.allowedValues = [...cache.allowedValues];

            let hasMatch = false;
            if (column.fieldValue === '')
            {
              if (column.allowedValues.length === 1)
              {
                column.fieldValue = column.allowedValues[0].textValue;
                column.extenderKey = column.allowedValues[0].extenderKey;
                column.error = '';
                hasMatch = true;
              }
              else if (cache.defaultValue !== undefined && cache.defaultValue !== null && column.allowedValues.length > 0) {

                let matchingRowKey = cache.allowedValues.find(
                  (ex) => ex.ExtenderKey === cache.defaultValue.toString() ||
                  ex.textValue === cache.defaultValue.toString()
                );
                if (matchingRowKey) {
                  column.fieldValue = matchingRowKey.textValue;
                  column.extenderKey = matchingRowKey.extenderKey;
                }
              }
            }
            else {
              let matchingRowKey = cache.allowedValues.find(
                (ex) =>
                  (ex.textValue === column.fieldValue)
              );
              if(matchingRowKey === undefined && cache.allowedValues.length == 1)
              {
                // no match, but one result... override
                column.fieldValue = column.allowedValues[0].textValue;
                column.extenderKey = column.allowedValues[0].extenderKey;
                column.error = '';
                hasMatch = true;
                //column.error = `Unknown value "${column.fieldValue}"`;
              }  else if(matchingRowKey !== undefined)
              {
                // we have a matching text value,  make sure the extKey is uptodate
                column.extenderKey = matchingRowKey.extenderKey;
                column.error = '';
                hasMatch = true;

              }
              else
              {
                // we have a garbage value, make it red
                column.error = `Unknown value "${column.fieldValue}"`;
              }
            }

            if(hasMatch)
            {
              let dep = this.findDependency(fieldSet.rowDependencies, column.fieldId);
              if(dep.childNodes.length > 0) {
                dep.childNodes.forEach((d) => {
                  if(d.hasExtender) {
                    this.processRowExtender(d.fieldId, fieldSet, row, doc, source)
                  }
                });

              }
            }
          }
        }

      }



      if(cache === undefined)
      {
        // check pending keys
        let pendingKey = _pendingKeys.find((f) => f.extId === d.extenderId && f.key === fullKey);

        if(pendingKey === undefined)
        {
          // create new pending key
          _pendingKeys.push({
            extId: d.extenderId,
            key: fullKey,
            pendingFields: [
              {
                rowId: row.rowId,
                fieldId: d.fieldId,
                fieldSetId: fieldSet.fieldSetId,
              }
            ]
          });

          ExecuteExtender(
            d.extenderId,
            extData,
            '',
            d.fieldId,
            fieldSet.fieldSetId,
            source,
            row.rowId,
            fullKey,
            doc.documentId
          );
        } else {
          pendingKey.pendingFields.push({
            rowId: row.rowId,
            fieldId: d.fieldId,
            fieldSetId: fieldSet.fieldSetId,
          });
        }
      }

      // locate in existing keys

    }
  }

  processExtenderRow(row, fieldSet) {
    console.log('processRow');
    this.state.currentFieldSet.fieldDefs.forEach((fd) => {
      if(fd.hasExtender)
      {
        let sibDependency = false;
          let d = this.state.currentFieldSet.depMap.filter(d2=> d2.fieldId === fd.fieldId);

          if(d.length > 0)
          {
            d.forEach((d2) => {
              let sib = this.state.currentFieldSet.fieldDefs.find(s => s.fieldId === d2.depFieldId);

              if(sib !== undefined)
              {
                sibDependency = true;
              }
            });
          }
          if(!sibDependency)
          {
            this.processRowExtender(fd.fieldId, this.state.currentFieldSet, row, this.state.currentDoc, 'userEdit');
          }
      }
    });
  }
  //   if (fieldSet.rowDependencies !== undefined) {
  //     let dep = [...fieldSet.rowDependencies];
  //     dep.forEach((d) => {
  //       let ed = this.getExtenderData(row);
  //       // if (header) {
  //       //   let u = ed.find((f) => f.fieldId === header.fieldId);
  //       //   if (u) {
  //       //     u.KeyValue = header.extenderKey;
  //       //   }
  //       // }
  //       if (d.hasExtender) {
  //         // the only way it works is to look for the cache here

  //         let cachedValue = this.lookForExtenderCache(d.extenderId, ed);
  //         if (cachedValue.length > 0){
  //           this.cachedDocumentExtenderRow(d.extenderId, row.rowId, fieldSet.fieldSetId, cachedValue);
  //         }
  //         else{
  //           ExecuteExtender(
  //             d.extenderId,
  //             ed,
  //             '',
  //             d.fieldId,
  //             fieldSet.fieldSetId,
  //             'pageLoad',
  //             row.rowId,
  //             null,
  //             this.state.currentDoc.documentId
  //           );
  //         }

  //       }
  //     });
  //   }
  // }


  lookForExtenderCache(extenderId, extenderData){

    let ext = {
      extenderId: extenderId,
      dataSourceValue: null,
      parentFields: [],
    };
      let ext2 = {
      cache: ext
    }
    let parentId = DocumentStore.getParentIdFromCache(ext2);

    if (parentId.length > 0 && parentId[0].cache.parentFields !== undefined){

      for (let i = 0; i < parentId[0].cache.parentFields.length; i++){

        let parentField = parentId[0].cache.parentFields[i];

        let parentValue = extenderData.find((dep) => dep.fieldId === parentField.parentId);

        let pf = {
          parentId: parentId[0].cache.parentFields[i].parentId,
          parentValue: parentValue.KeyValue
        };

        ext2.cache.parentFields.push(pf);
      }


      // if (parentValue !== undefined){
      //   ext2.cache.parentValue = parentValue.KeyValue;
      // }

    }
    else{
    }

    let cachedValue = DocumentStore.getExtenderFromCache(ext2);

    return cachedValue;
  }

  cachedDocumentExtenderRow(extId, rowId, fieldSetId, cachedValue){


    let ext = DocumentStore.getRowExtender(extId);

    ext = cachedValue[0];

    let doc = this.state.currentDoc;

    let fieldSet = doc.fieldSets.find((fs) => fs.fieldSetId === fieldSetId);
    let rows = fieldSet.rows;
    let row = rows.find((r) => r.rowId === rowId);

    let column = row.fieldData.find(
      (f) => f.fieldDef.fieldId === ext.fieldId
    );

    if (column) {
      let dep = this.findDependency(fieldSet.rowDependencies, column.fieldId);
      column.allowedValues = [...ext.allowedValues];

        if (!column.extenderKey) {
          column.extenderKey = '-1';
        }

        let matchingRowKey = ext.allowedValues.find(
          (ex) =>
            ex.ExtenderKey === column.extenderKey.toString() ||
            ex.ExtenderKey === column.fieldValue ||
            ex.textValue === column.fieldValue
        );

        if (column.fieldValue === '') {
          // field is currently blank

          if (column.allowedValues.length === 1) {
            column.fieldValue = column.allowedValues[0].textValue;
            column.extenderKey = column.allowedValues[0].extenderKey;
          }
          //  else if there's a default
          else if (ext.defaultValue !== null) {
            matchingRowKey = ext.allowedValues.find(
              (ex) => ex.ExtenderKey === ext.defaultValue.toString()
            );
            if (matchingRowKey) {
              column.fieldValue = matchingRowKey.textValue;
              column.extenderKey = matchingRowKey.extenderKey;
            }
          } else {
            // else just populate first one
            //column.fieldValue = column.allowedValues[0].textValue;
            //column.extenderKey = column.allowedValues[0].extenderKey;
            //blankit
          }
        } else {
          // header is not blank
          if (matchingRowKey !== null && matchingRowKey !== undefined) {
            column.fieldValue = matchingRowKey.textValue;
            column.extenderKey = matchingRowKey.extenderKey;
            column.textValue = matchingRowKey.textValue;
            column.error = '';
          } else if (
            column.allowedValues.length === 1 &&
            column.allowedValues[0].textValue
          ) {
            column.fieldValue = column.allowedValues[0].textValue;
            column.textValue = column.allowedValues[0].textValue;
            column.extenderKey = column.allowedValues[0].extenderKey;
            column.error = '';
          } else {
            if (ext.exeSource === 'pageLoad') {
              this.errorRowField(
                fieldSet.fieldSetId,
                row.rowId,
                column.fieldId
              );
            } else {
              this.blankRowField(
                fieldSet.fieldSetId,
                row.rowId,
                column.fieldId
              );
            }
          }
        }
        this.setState({ currentDoc: doc });

        if (column.fieldValue !== '' && column.error === '') {
          // call child extenders
          let eData = this.getExtenderData(row);

          let u = eData.find((f) => f.fieldId === column.fieldId);
          if (u) {
            u.KeyValue = column.extenderKey;
          }
          if (dep.childNodes !== undefined && dep.childNodes.length > 0) {
            dep.childNodes.forEach((hd) => {
              if (hd.hasExtender) {
                //let d = this.getExtenderData();


          let cachedValue = this.lookForExtenderCache(hd.extenderId, eData);
          if (cachedValue.length > 0){
            this.cachedDocumentExtenderRow(hd.extenderId, row.rowId, fieldSetId, cachedValue);
          }
          else{
            ExecuteExtender(
              hd.extenderId,
              eData,
              '',
              hd.fieldId,
              fieldSetId,
              ext.exeSource,
              row.rowId,
              null,
              doc.documentId

            );
          }

              }
            });
          }
        }

    }

    this.setState({ currentDoc: doc });
  }

  processFirstExtenderRow(row, fieldSet) {
    console.log('processFirstRow');
      if (fieldSet.rowDependencies !== undefined) {
        let dep = [...fieldSet.rowDependencies];
        dep.forEach((d) => {
          let ed = this.getExtenderData(row);
          if (d.hasExtender) {
            ExecuteExtender3(
              d.extenderId,
              ed,
              '',
              d.fieldId,
              fieldSet.fieldSetId,
              'pageLoad',
              row.rowId
            );
          }
        });
      }

  }

  windowMouseLeave() {
    if (this.state.isDraggingSplitBar) {
      this.setState({ isDraggingSplitBar: false });
      UpdateSetting('doc_image_height', this.state.topHeight.toString());
    }
  }

  onBulkChange() {
    let lastChange = BulkActionStore.getLastChange();
    if (lastChange === actionTypes.DocumentGetAvailTemplatesByBp2) {
      let templates = BulkActionStore.getWorkflowAvailableTemplatesResults();
      this.setState({ availableTemplates2: templates });
      return;
    }
  }

  beforeUnloadListener(event) {
    if (this.state.snapshots.length > 1) {
      event.preventDefault();
      event.returnValue = 'Are you sure you want to exit?';
    }
  }

  getFldFromFldDef(fd) {
    let newField = {
      fieldId: fd.fieldId,
      fieldDef: fd,
      fieldValue: '',
      fieldDataType: 0,
      allowedValues: [],
      directChildDependents: fd.directChildDependents,
      error: '',
    };

    if (fd.hasExtender) {
      newField.allowedValues = fd.extender.allowedValues;
    }
    return newField;
  }

  initSnapshot() {
    let snapshots = [];
    var newSnapshot = { headerFields: [], fieldSets: [] };
    if (this.state.currentDoc !== null && this.state.currentDoc !== undefined) {
      this.state.currentDoc.headerFields.forEach((header) => {
        var snap = {
          fieldId: header.fieldId,
          sysName: header.systemName,
          value: header.fieldValue,
        };
        newSnapshot.headerFields.push(snap);
      });

      let fieldsets = this.state.currentDoc.fieldSets;
      fieldsets.forEach((fs) => {
        let fsSnap = {
          fieldSetId: fs.fieldSetId,
          rowData: [],
        };
        fs.rows.forEach((row) => {
          if (!row.isNew) {
            let fsRow = {
              rowId: row.rowId,
              fields: [],
            };

            row.fieldData.forEach((field) => {
              let fsField = { ...field };
              fsRow.fields.push(fsField);
            });
            fsSnap.rowData.push(fsRow);
          }
        });
        newSnapshot.fieldSets.push(fsSnap);
      });

      snapshots.push(newSnapshot);
      this.setState({ snapshots: snapshots });
      this.updateRunningTotals();
      this.focusFirstField();
    }
  }

  focusFirstField() {
    let headers = this.state.currentDoc.headerFields;
    let head = headers[0];

    try {
      let fieldTag = '';
      if (head.hasExtender) {
        if (head.extender.type === 4) {
          fieldTag = `${head.fieldId}_dropdown`;
        }
        if (head.extender.type === 1) {
          fieldTag = `autoCompleteExtender_${head.fieldId}`;
        }
        if (head.extender.type == 2) {
          fieldTag = `fieldEdit_${head.fieldId}`;
        }
      } else {
        fieldTag = `fieldEdit_${head.fieldId}`;
      }
      //fieldTag = 'documentButton';

      document.getElementById(fieldTag).focus();
    } catch {}
  }

  generateSnapshot() {
    var newSnapshot = { headerFields: [], fieldSets: [] };
    if (this.state.currentDoc !== null && this.state.currentDoc !== undefined) {
      this.state.currentDoc.headerFields.forEach((header) => {
        var snap = {
          fieldId: header.fieldId,
          sysName: header.systemName,
          value: header.fieldValue,
        };
        newSnapshot.headerFields.push(snap);
      });

      let fieldsets = this.state.currentDoc.fieldSets;
      fieldsets.forEach((fs) => {
        let fsSnap = {
          fieldSetId: fs.fieldSetId,
          rowData: [],
        };
        fs.rows.forEach((row) => {
          if (!row.isNew) {
            let fsRow = {
              rowId: row.rowId,
              fields: [],
            };

            row.fieldData.forEach((field) => {
              let fsField = { ...field };
              fsRow.fields.push(fsField);
            });
            fsSnap.rowData.push(fsRow);
          }
        });
        newSnapshot.fieldSets.push(fsSnap);
      });
      let currentSnapshots = this.state.snapshots;
      currentSnapshots.push(newSnapshot);
      this.setState({ snapshots: currentSnapshots });
    }
    this.updateRunningTotals();
  }

  handleApproveClick() {
    console.log('handleApprove');
    let valid = this.ValidateDocument();
    if (valid) {
      console.log('docValid');
      SubmitDocument('APPROVE', this.state.currentDoc);
      this.setState({ isSubmitting: true });
    } else {
      this.setState({ showErrorMessage: true });
    }
  }

  handleRejectClick() {
    if (!this.state.currentDoc.forceRejectReason) {
      SubmitDocument('REJECT', this.state.currentDoc);
    } else {
      this.setState({ showReasonForReject: true });
    }
  }

  handleImageNav(imageId) {
    var imageList = DocumentStore.getImages();
    if (imageList.length >= imageId) {
      var curImage = imageList[imageId - 1];
      if (curImage.imageBytes !== null) {
        this.setState({ currentImage: curImage });
      } else {
        FetchImage(this.state.currentDoc.documentId, imageId);
        this.setState({ loadingImage: true });
      }

      // check for previous and next page
      if (imageList.length >= imageId + 1) {
        var nextImage = imageList[imageId];
        if (nextImage.imageBytes === null) {
          FetchImage(this.state.currentDoc.documentId, imageId + 1);
        }
      }

      if (imageId - 1 > 0) {
        var previousImage = imageList[imageId - 2];
        if (previousImage.imageBytes === null) {
          FetchImage(this.state.currentDoc.documentId, imageId - 1);
        }
      }
    }
  }

  handleSaveClick() {
    let valid = this.ValidateDocument();
    let hasQueueChanges = this.checkQueueChanges();
    if (valid || hasQueueChanges) {
      this.setState({ isSaving: true });
      console.log(this.state.currentDoc);
      SaveDocument(this.state.currentDoc.documentId, this.state.currentDoc, this.showSaveError);
    } else {
      PostAlert('error', 'Unable to save document.  See errors');
      if (!valid) {
        this.setState({ showErrorMessage: true });
      }
    }
  }

  showSaveError(errorText) {
    console.log(`ERROR - ${errorText}`);

    let errors = [];
    errors.push(errorText);
    this.setState({errorMessages: errors});
    this.setState({ showErrorMessage: true });


  }

  handlePreviousClick() {
    let docIds = SearchStore.getDocList();
    let docId = this.state.documentID;
    if(this.state.currentDoc.hasRelatedDocs && this.state.currentDoc.originalDocId !== 0)
      {
        docId = this.state.currentDoc.originalDocId;
      }
    if (docIds !== undefined) {
      if (docIds.includes(docId)) {
        let indexOfCurrent = docIds.indexOf(docId);
        let nextIndex = indexOfCurrent - 1;
        if (nextIndex >= 0) {
          //this.goToDoc(docIds[nextIndex]);
          this.setState({ isLoading: true });
          GetNextDocument(docId, docIds[nextIndex]);
          customHistory.push(`/Document/${docIds[nextIndex]}`);

          //moving to next doc, move all scrollable elements back to top
          var coolScroll = document.getElementsByClassName('coolScroll');
          for (var i = 0; i < coolScroll.length; i++) {
            coolScroll[i].scrollTop = 0;
          }
          var coolScroll2 = document.getElementsByClassName('coolScroll2');
          for (var i2 = 0; i2 < coolScroll2.length; i2++) {
            coolScroll2[i2].scrollTop = 0;
          }
          var dgr = document.getElementsByClassName('document-grid-rows');
          for (var i3 = 0; i3 < dgr.length; i3++) {
            dgr[i3].scrollTop = 0;
          }

          return;
        } else {
          // reached the end of list
          let link = document.getElementById('backLink');
          link.click();
          return;
        }
      }
    }
    let link = document.getElementById('backLink');
    link.click();
    //GetPreviousDocument(this.state.currentDoc);
  }

  handleNextClick(remove) {
    let docIds = SearchStore.getDocList();
    let docId = this.state.documentID;
    if(this.state.currentDoc.hasRelatedDocs && this.state.currentDoc.originalDocId !== 0)
      {
        docId = this.state.currentDoc.originalDocId;
      }
    let lastSearch = SearchStore.getLastSearch();
    if (docIds !== undefined) {
      if (docIds.includes(docId)) {
        let indexOfCurrent = docIds.indexOf(docId);
        let nextIndex = indexOfCurrent + 1;
        if (docIds.length > nextIndex) {
          let previousDocId = this.state.documentID;
          //this.goToDoc(docIds[nextIndex]);
          this.setState({ isLoading: true });
          GetNextDocument(docId, docIds[nextIndex]);
          customHistory.push(`/Document/${docIds[nextIndex]}`);
          console.log(remove);
          if(remove)
          {
            SearchStore.removeDocFromList(previousDocId);
          }
          //moving to next doc, move all scrollable elements back to top
          var coolScroll = document.getElementsByClassName('coolScroll');
          for (var i = 0; i < coolScroll.length; i++) {
            coolScroll[i].scrollTop = 0;
          }
          var coolScroll2 = document.getElementsByClassName('coolScroll2');
          for (var i2 = 0; i2 < coolScroll2.length; i2++) {
            coolScroll2[i2].scrollTop = 0;
          }
          var dgr = document.getElementsByClassName('document-grid-rows');
          for (var i3 = 0; i3 < dgr.length; i3++) {
            dgr[i3].scrollTop = 0;
          }

          return;
        } else {
          // reached the end of list
          let link = document.getElementById('backLink');
          link.click();
          return;
        }
      }
    }

    if ((docIds === undefined || docIds.length === 0) && !this.state.returnUrl){
      this.setState({ returnUrl: '/ActiveDocuments' });
    }
    let link = document.getElementById('backLink');
    link.click();
  }

  goToDoc(docId) {
    let returnPath = window.location.pathname + window.location.search;
    localStorage.setItem('docReturn', returnPath);
    this.setState({ goToDocId: docId }, () => {
      let docLink = document.getElementById('docLink');
      docLink.click();
    });
  }

  handleAttachmentClick(e) {
    // toggle attachment menu
    let showMenu = !this.state.showAttachmentMenu;
    this.setState({
      showAttachmentMenu: showMenu,
      showPdfMenu: false,
      showSnagMenu: false,
    });
    e.stopPropagation();
  }

  handleTrashClick() {
    this.setState({ showDeleteConfirm: true });
  }

  cancelTrashClick() {
    this.setState({ showDeleteConfirm: false });
  }

  deleteDoc() {
    DeleteDocument(this.state.currentDoc);
  }

  handlePdfClick(e) {
    let showMenu = !this.state.showPdfMenu;
    this.setState({ showPdfMenu: showMenu, showAttachmentMenu: false });
    e.stopPropagation();
  }

  handleRuntimeMenuClick(e) {
    let showMenu = !this.state.showRuntimeMenu;
    this.setState({ showRuntimeMenu: showMenu });
    e.stopPropagation();
  }

  getCookie(name) {
  const cookies = document.cookie.split(";");

  for (let cookie of cookies) {
      const [key, value] = cookie.trim().split("=");
      if (key === name) {
          return decodeURIComponent(value);
      }
  }

  return null;
}

  routeToTrinFormsClick() {

    let u = this.getTrinFormsUrl();
    let link = document.getElementById('trinFormsLink');


        let token = this.getCookie("td6Token");

        if (token === null){
            token = window.localStorage.getItem('td6Token');
        }
        const enCodedtoken = encodeURIComponent(token);

        var url = this.getTrinFormsUrl();

        const redirectUrl = `${url}?token=${enCodedtoken}`;

        if (link) {
          link.setAttribute('href', redirectUrl);
          link.click();
        }

  }

  getTrinFormsUrl() {

    var lastCharacterOfUrl = this.state.trinFormsBaseUrl.charAt(this.state.trinFormsBaseUrl.length - 1);
    let tfUrl = this.state.trinFormsBaseUrl;
    if (lastCharacterOfUrl === '/'){

      tfUrl = this.state.trinFormsBaseUrl + 'api/Auth/GoToForm/' + this.state.currentDoc.trinFormsId;
      //window.location.href = tfUrl;
    }
    else{
      tfUrl = this.state.trinFormsBaseUrl + '/api/Auth/GoToForm/' + this.state.currentDoc.trinFormsId;
      //window.location.href = tfUrl;

    }

    console.log('tfUrl is below');
    console.log(tfUrl);


    //this.setState({ trinFormsCompleteUrl: tfUrl });
    return tfUrl;
  }

  handleImageRevClick() {
    SendDocumentToImageReview(this.state.currentDoc);
  }

  
toggleIntakeLogRow = (index) => {
  console.log(index);
  console.log(this.state.expandedIntakeLogRows);

  let expandedRows = [...this.state.expandedIntakeLogRows];

  if (expandedRows.includes(index)) {
    // collapse
    expandedRows = expandedRows.filter(i => i !== index);
  } else {
    // expand
    expandedRows.push(index);
  }

  this.setState({ expandedIntakeLogRows: expandedRows });
};


  handleDocumentClick() {
    this.setState({
      showPdfMenu: false,
      showAttachmentMenu: false,
      showSnagMenu: false,
      showDocumentMenu: false,
      showStampMenu: false,
    });
  }

  toggleSnagMenu(e) {
    let showMenu = !this.state.showSnagMenu;
    this.setState({
      showPdfMenu: false,
      showSnagMenu: showMenu,
      showAttachmentMenu: false,
      showStampMenu: false,
    });
    e.stopPropagation();
  }

  executeOnDemandPlugin(pluginData) {

    console.log(pluginData);
    this.setState({
      isRunningPlugin: true,
      showRuntimeMenu: false
    });

    ExecuteRuntimePlugin(this.state.currentDocId, pluginData.workerId);
  }

  onClickSendToAICapture() {
    //let settings = SystemSettingsStore.getSystemSettings();
    // if (settings.displayAICapturePopup) {
    //   this.setState({ showAICaptureConfirm: true });
    // } else {
    //   this.sendToAICapture();
    // }
    this.sendToAICapture();
  }

  cancelAICaptureConfirm() {
    this.setState({ showAICaptureConfirm: false });
  }

  sendToAICapture() {
    this.setState({ showAICaptureConfirm: false });
    let aiCaptureStep = this.state.currentDoc.destinations.find((h) => h.stepType === "AICapture");

    MoveAssignDocument(
      this.state.currentDoc.documentId,
      aiCaptureStep.stepId,
      [],
      this.state.currentDoc
    );
  }

  onMouseMove(e) {
    if (this.state.isDraggingSplitBar) {
      let navH = document.getElementById('tdAppHeader').clientHeight + 2;
      let menuH = document.getElementById('tdDocumentMenu').clientHeight + 2;
      let newH = e.clientY - this.state.topHeightOnDragStart;
      let rdBar = document.getElementById('relatedDocsBar');
      let rdBarH = 0;
      if(rdBar !== null) rdBarH = rdBar.clientHeight + 1;
      let newB = window.innerHeight - newH - navH - menuH - rdBarH - 10;
      console.log(navH);
      console.log(menuH);
      console.log(newH);
      console.log(newB);
      console.log(window.innerHeight);
      let related = document.getElementById('deRlatedDocs');
      if (related) {
        newB = newB - related.clientHeight;
      }

      if (newB > 45) {

        let newTableHeight = window.innerHeight - newH - 239;
        this.setState({
          topHeight: newH,
          bottomHeight: newB,
          imageviewerHeight: newH - 32,
          tableHeight: newTableHeight,
        });
      }
    }
  }

  onMouseUp(e) {
    if (this.state.isDraggingSplitBar) {
      this.setState({ isDraggingSplitBar: false });
      UpdateSetting('doc_image_height', this.state.topHeight.toString());
    }
  }

  onHotKey() {
    let key=HotKeyStore.getLastKey();

    if(key === 'F2')
    {
      if( this.state.userCanSubmit &&
        !this.state.isSaving &&
        !this.state.fieldsHaveError &&
        !this.state.isSubmitting &&
        !this.state.isLoading
      )
      {
        this.handleApproveClick();
      }
    }
    if(key === 'F4')
    {
      // reject
      if( this.state.userCanSubmit &&
        !this.state.isSaving &&
        !this.state.fieldsHaveError &&
        !this.state.isSubmitting &&
        !this.state.isLoading
      )
      {
      this.handleRejectClick();
      }
    }
    if(key === 'F8')
    {
      // save

      if(!(this.state.isSaving ||
        ((this.state.fieldsHaveError ||
          this.state.snapshots.length === 1 ||
          !this.state.userCanEdit) &&
          //!this.state.userCanMoveAssign &&
          !this.state.queuesDirty)))
      {
        this.handleSaveClick();
      }
    }
  }

  // onKeyUp(e) {
  //   // approve document when hitting F2
  //   if (e.keyCode === 113) {
  //     this.handleApproveClick();
  //     e.preventDefault();
  //   }
  // }

  onSplitBarMouseDown(e) {
    this.setState({
      isDraggingSplitBar: true,
      topHeightOnDragStart: e.clientY - this.state.topHeight,
    });
  }

  onWindowResize(e) {
    //setViewWidth
    let ivw = window.innerWidth - 280 - 20;
    let navH = document.getElementById('tdAppHeader').clientHeight + 2;
    let menuH = document.getElementById('tdDocumentMenu').clientHeight + 2;
    let rdBar = document.getElementById('relatedDocsBar');
    let rdBarH = 0;
    if(rdBar !== null) rdBarH = rdBar.clientHeight + 1;
    let newH = this.state.topHeight;
    if (this.state.showUserNotes) ivw = ivw - 280;
    this.setState({ imageviewerWidth: ivw });
    this.setState({ tableWidth: window.innerWidth });
    //this.setState({tableHeight: window.innerHeight - this.state.imageViewerHeight - 500});
    this.setState({
      tableHeight: window.innerHeight - this.state.topHeight - 240,
    });
    let newB = window.innerHeight - newH - navH - menuH - rdBarH - 10;
    console.log(newB);
    let related = document.getElementById('deRlatedDocs');
    if (related) {
      newB = newB - related.clientHeight;
    }
    if (newB > 8) {
      //let newTableHeight = window.innerHeight - newH - 239;
      this.setState({
        bottomHeight: newB,
      });
    }
  }

  handleHeaderFieldTextEdit(editText, fieldId, extenderId) {
    let doc = this.state.currentDoc;
    let header = doc.headerFields.find((h) => h.fieldId === fieldId);
    if (header) {
      header.fieldValue = editText;
      if (extenderId !== null) {
        header.extenderKey = extenderId;
      }
    }

    this.setState({ currentDoc: doc }, this.reviewSnapshots());
  }
  handleHeaderFieldEdit(editText, fieldId, extenderKey, extenderId) {
    //find the header field.
    console.log('handleHeaderFIeldEdit');
    let doc = this.state.currentDoc;
    let header = doc.headerFields.find((h) => h.fieldId === fieldId);
    if (header && !header.hasExtender) {
      header.fieldValue = editText.trim();
    }
    let dep = this.findDependency(doc.headerDependencies, header.fieldId);
    if (editText === '' && dep.hasExtender) {
      this.blankHeaderField(fieldId, false);
    } else {
      if (dep.childNodes !== undefined && dep.childNodes.length > 0) {
        dep.childNodes.forEach((hd) => {
          if (hd.hasExtender) {
            let d = this.getExtenderData();
            let u = d.find((f) => f.fieldId === header.fieldId);
            if (u) {
              u.KeyValue = extenderKey;
            }
            ExecuteExtender(
              hd.extenderId,
              d,
              '',
              hd.fieldId,
              0,
              'userEdit',
              null,
              null,
              doc.documentId
            );
          }
        });
      }
    }

    if (dep.hasExtender) {
      if (header) {
        header.fieldValue = editText.trim();
        header.extenderKey = extenderKey;
      }

      // dispatch will handle header fields,  what about row fields...
      let hasRowchildren = false;
      doc.fieldSets.forEach((fs) => {
        fs.headerDependencies.forEach((hd) => {
          if (hd.fieldId === dep.fieldId) {
            hasRowchildren = true;
          }
        });
        if (hasRowchildren) {
          fs.rows.forEach((row) => {
            fs.rowDependencies.forEach((rd) => {
              if (rd.hasExtender) {
                this.processRowExtender(rd.fieldId, fs, row, doc, 'userEdit');
              }
            });
          });
        }
        // field Ids to check for...
      });
    }

    this.setState({ currentDoc: doc }, this.reviewSnapshots());
  }

  runExtender(extenderId, rowId, fieldSetId) {
    let doc = this.state.currentDoc;

    let extenderData = [];
    doc.headerFields.forEach((head) => {
      if (head.hasExtender) {
        extenderData.push({
          fieldId: head.fieldId,
          KeyValue: head.extenderKey.toString(),
        });
      }
    });
    console.log('run');
    ExecuteExtender(extenderId, extenderData, '', 0, fieldSetId, rowId, null, doc.documentId);
  }

  handleTableFieldEdit(editText, rowId, fieldId, extenderKey, fieldSetId) {

    let doc = this.state.currentDoc;
    let rows = this.state.rowData;
    let row = rows.find((r) => r.rowId === rowId);
    console.log('CellUpdate');
    if (row) {
      let field = row.fieldData.find((f) => f.fieldId === fieldId);

      let fieldSet = doc.fieldSets.find((fs) => fs.fieldSetId === fieldSetId);
      let dep = this.findDependency(fieldSet.rowDependencies, fieldId);

      if(editText !== field.fieldValue || extenderKey !== field.extenderKey)
      {

        if (field) {
          field.fieldValue = editText;
          field.keyValue = extenderKey;
          field.extenderKey = extenderKey;
          field.textValue = editText;
          field.error = '';
          this.setState({ rowData: rows }, this.reviewSnapshots());
        }
        let extenderId = -1;

        if (dep !== null && dep.childNodes !== undefined && dep.childNodes.length > 0) {
          dep.childNodes.forEach((hd) => {
            if (hd.hasExtender) {
              this.processRowExtender(hd.fieldId, fieldSet, row, doc, 'userEdit');
            }
          });
        }
      }
    }
  }

  reviewSnapshots() {
    console.log('review snapshot');
    let doc = this.state.currentDoc;

    let snapshots = this.state.snapshots;
    if (snapshots.length === 0) {
      this.generateSnapshot();
    }

    let changeCount = 0;

    let latestSnapshot = snapshots[snapshots.length - 1];
    doc.headerFields.forEach((header) => {
      var hsnap = latestSnapshot.headerFields.find(
        (snap) => snap.fieldId === header.fieldId
      );
      if (hsnap) {
        if (header.fieldValue !== hsnap.value) {
          changeCount++;
        }
      }
    });
    let rows = this.state.rowData;
    let fsSnap = latestSnapshot.fieldSets.find(
      (fs) => fs.fieldSetId === this.state.currentFieldSet.fieldSetId
    );
    if (fsSnap) {
      rows.forEach((row) => {
        if (!row.isNew) {
          let fsRow = fsSnap.rowData.find((r) => r.rowId === row.rowId);
          if (fsRow) {
            row.fieldData.forEach((field) => {
              let fsField = fsRow.fields.find(
                (f) => f.fieldId === field.fieldId
              );
              if (fsField) {
                if (fsField.fieldValue !== field.fieldValue) {
                  changeCount++;
                }
              }
            });
          } else {
            changeCount++;
          }
        }
      });

      if(rows.length !== fsSnap.rowData.length && changeCount === 0)
        {
          changeCount++;
        }
    }
    if (snapshots.length === 1 && changeCount > 0) {
      this.generateSnapshot();
    } else if (snapshots.length > 1) {
      let snapChanges = 0;
      let previousSnapshot = snapshots[snapshots.length - 2];
      doc.headerFields.forEach((header) => {
        var hsnap = previousSnapshot.headerFields.find(
          (snap) => snap.fieldId === header.fieldId
        );
        if (hsnap) {
          if (header.fieldValue !== hsnap.value) {
            snapChanges++;
          }
        }
      });
      let rows = this.state.rowData;
      let fsSnap = previousSnapshot.fieldSets.find(
        (fs) => fs.fieldSetId === this.state.currentFieldSet.fieldSetId
      );
      if (fsSnap) {
        rows.forEach((row) => {
          if (!row.isNew) {
            let fsRow = fsSnap.rowData.find((r) => r.rowId === row.rowId);
            row.fieldData.forEach((field) => {
              if (!fsRow && field.fieldValue !== '') {
                snapChanges++;
              }
              if (fsRow) {
                let fsField = fsRow.fields.find(
                  (f) => f.fieldId === field.fieldId
                );
                if (fsField) {
                  if (fsField.fieldValue !== field.fieldValue) {
                    snapChanges++;
                  }
                }
              }
            });

            // if(fsRow){
            //    row.fieldData.forEach(field => {
            //       let fsField = fsRow.fields.find(f => f.fieldId === field.fieldId);
            //       if(fsField)
            //       {
            //          if(fsField.fieldValue !== field.fieldValue){
            //             snapChanges++;
            //          }
            //       }
            //    });
            // } else {
            //    snapChanges++;
            // }
          }
        });
      }
      if (snapChanges === 1) {
        // update current snapshot
        this.updateCurrentSnapshot();
      } else if (snapChanges >= 2) {
        this.generateSnapshot();
      }
      // possible scenarios for destroying snapshots
      else if (snapChanges === 0) {
        snapshots.pop();
        this.setState({ snapshots: snapshots });
      }
    }
  }

  updateCurrentSnapshot() {
    console.log('update snapshot');
    var newSnapshot = { headerFields: [], fieldSets: [] };
    if (this.state.currentDoc !== null && this.state.currentDoc !== undefined) {
      this.state.currentDoc.headerFields.forEach((header) => {
        var snap = {
          fieldId: header.fieldId,
          sysName: header.systemName,
          value: header.fieldValue,
        };
        newSnapshot.headerFields.push(snap);
      });

      let fieldsets = this.state.currentDoc.fieldSets;
      fieldsets.forEach((fs) => {
        let fsSnap = {
          fieldSetId: fs.fieldSetId,
          rowData: [],
        };
        fs.rows.forEach((row) => {
          if (!row.isNew) {
            let fsRow = {
              rowId: row.rowId,
              fields: [],
            };
            row.fieldData.forEach((field) => {
              let fsField = { ...field };

              fsRow.fields.push(fsField);
            });
            fsSnap.rowData.push(fsRow);
          }
        });
        newSnapshot.fieldSets.push(fsSnap);
      });
      let currentSnapshots = this.state.snapshots;
      currentSnapshots.pop();
      currentSnapshots.push(newSnapshot);
      this.setState({ snapshots: currentSnapshots });
    }
  }

  undoLatestChange() {
    let snapshots = this.state.snapshots;
    let doc = this.state.currentDoc;
    if (snapshots.length > 1) {
      snapshots.pop();
      let newSnap = snapshots[snapshots.length - 1];
      //header fields
      doc.headerFields.forEach((header) => {
        var snap = newSnap.headerFields.find(
          (f) => f.fieldId === header.fieldId
        );
        if (snap) {
          header.fieldValue = snap.value;
        }
      });
      doc.fieldSets.forEach((fs) => {
        let fsSnap = newSnap.fieldSets.find(
          (f) => fs.fieldSetId === f.fieldSetId
        );
        if (fsSnap) {
          fsSnap.rowData.forEach((rowSnap) => {
            let editRow = fs.rows.find((r) => r.rowId === rowSnap.rowId);
            if (editRow) {
              //if (!editRow.isNew) {
                // check field
                editRow.isNew = false;
                editRow.fieldData.forEach((field) => {
                  let snapField = rowSnap.fields.find(
                    (f) => f.fieldId === field.fieldId
                  );
                  if (snapField) {
                    field.fieldValue = snapField.fieldValue;
                  }
                });
              //}
            } else {
              // add the row
              let newRow = {
                rowId: rowSnap.rowId,
                isDeleted: false,
                fieldData: [],
              };
              rowSnap.fields.forEach((field) => {
                newRow.fieldData.push({ ...field });
              });
              //fs.rows.push(newRow);
              let idx = 0;
              fs.rows.forEach((row) => {
                if (!row.isNew && row.rowId < newRow.rowId) {
                  idx++;
                }
              });
              fs.rows.splice(idx, 0, newRow);
            }

            // add new row
            let newRow = fs.rows.find((f) => f.isNew === true);
            if(!newRow) {
              newRow = {
                rowId: fs.rows.length + 1,
                dbRowId: -1,
                isNew: true,
                isChecked: false,
                isDeleted: false,
                fieldData: [],
              };

                fs.fieldDefs.forEach((fd) => {

                  let newField = {
                    fieldId: fd.fieldId,
                    fieldDef: fd,
                    fieldValue: '',
                    displayOrder: fd.displayOrder,
                    fieldDataType: 0,
                    allowedValues: [],
                    directChildDependents: fd.directChildDependents,
                    error: '',
                  };
                  //
                  if (fd.hasExtender) {
                    newField.allowedValues = fd.extender.allowedValues;
                  }

                  newRow.fieldData.push(newField);

              });

              fs.rows.push(newRow);
            }

          });

          let copyOfRows = [...fs.rows];

          fs.rows.forEach((row) => {
            let rowSnap2 = fsSnap.rowData.find((r) => r.rowId === row.rowId);
            if (!rowSnap2 && !row.isNew) {
              // delete
              let idx = copyOfRows.indexOf(row);
              copyOfRows.splice(idx, 1);
            }
          });

          fs.rows = [...copyOfRows];

          let rowIdx = 1;
          fs.rows.forEach((row) => {
            row.rowId = rowIdx;
            rowIdx++;
          });
        }
      });


      let currentFs = doc.fieldSets.find(
        (f) => f.fieldSetId === this.state.currentFieldSet.fieldSetId
      );
      //this.setState({ currentFieldSet: fs, rowData: fs.rows });


      this.setState({ currentDoc: doc, snapshots: snapshots, currentFieldSet: currentFs, rowData: currentFs.rows });
    }
  }

  onMoveCell(dir) {
    if (dir === 'next') {
      let rowId = this.state.currentEdit.rowId;
      let colId = this.state.currentEdit.orderId;
      let element = document.getElementById(`edit_${rowId}_${colId+1}`);
      if (element) {
        element.focus();
        if (element.tagName !== 'SELECT') {
          element.select();
        }
      } else {
        element = document.getElementById(`edit_${rowId+1}_1`);
        if (element) {
          element.focus();
          if (element.tagName !== 'SELECT') {
            element.select();
          }
        }


      }
    }

    if (dir === 'down') {
      let rowId = this.state.currentEdit.rowId;
      let nextRow = this.state.rowData.find((r) => r.rowId === rowId + 1);
      if (nextRow) {
        let fieldId = this.state.currentEdit.orderId;
        let element = document.getElementById(
          `edit_${nextRow.rowId}_${fieldId}`
        );
        if (element) {
          element.focus();

          if (element.tagName !== 'SELECT') {
            element.select();
          }
        }
      }
    }
    if (dir === 'left') {
      let rowId = this.state.currentEdit.rowId;
      let colId = this.state.currentEdit.orderId;

      let element = document.getElementById(`edit_${rowId}_${colId - 1}`);
      if (element) {
        element.focus();
        if (element.tagName !== 'SELECT') {
          element.select();
        }
      }
    }
    if (dir === 'right') {
      let rowId = this.state.currentEdit.rowId;
      let colId = this.state.currentEdit.orderId;

      let element = document.getElementById(`edit_${rowId}_${colId+1}`);
      if (element) {
        element.focus();
        if (element.tagName !== 'SELECT') {
          element.select();
        }
      } else {
        element = document.getElementById(`edit_${rowId+1}_1`);
        if (element) {
          element.focus();
          if (element.tagName !== 'SELECT') {
            element.select();
          }
        }


      }
    }

    if (dir === 'up') {
      let rowId = this.state.currentEdit.rowId;
      let nextRow = this.state.rowData.find((r) => r.rowId === rowId - 1);
      if (nextRow) {
        let fieldId = this.state.currentEdit.orderId;
        let element = document.getElementById(
          `edit_${nextRow.rowId}_${fieldId}`
        );
        if (element) {
          element.focus();
          if (element.tagName !== 'SELECT') {
            element.select();
          }
        }
      }
    }

    //let input = document.getElementById(
  }

  onCellClick(rowId, colId, orderId) {
    this.setState({ currentEdit: { rowId, colId, orderId } });
    let rows = this.state.rowData;
    let thisRow = rows.find((r) => r.rowId === rowId);
    if (thisRow && thisRow.isNew) {
      thisRow.isNew = false;
      let nextRowId = 1;
      //
      rows.forEach((row) => {
        if (row.rowId >= nextRowId) nextRowId = row.rowId + 1;
      });
      let newRow = {
        rowId: nextRowId,
        dbRowId: -1,
        isChecked: false,
        isNew: true,
        isDeleted: false,
        fieldData: [],
        error: '',
      };
      //let x = this.state.currentDoc;
      newRow.extenderDependencies = [
        ...this.state.currentDoc.extenderDependencies,
      ];
      this.state.currentFieldSet.fieldDefs.forEach((fd) => {

        let newField = {
          fieldId: fd.fieldId,
          fieldDef: fd,
          fieldValue: '',
          extenderId: '',
          displayOrder: fd.displayOrder,
          fieldDataType: 0,
          allowedValues: [],
          directChildDependents: fd.directChildDependents,
          error: '',
        };
        newRow.fieldData.push(newField);
      });

      // do not process extenders for new rows
      this.processExtenderRow2(newRow, this.state.currentFieldSet);


    const lastElement = rows[rows.length - 1];

    this.processExtenderRow2(lastElement, this.state.currentFieldSet);

      rows.push(newRow);
      this.setState({ rowData: rows }, this.reviewSnapshots());
    }
  }

  // checkChildExtenders(row, column) {
  //   column.directChildDependents.forEach((ed) => {
  //     var fieldSetId = -1;
  //     let doc = this.state.currentDoc;
  //     let fieldSets = doc.fieldSets;

  //     fieldSets.forEach((fs) => {
  //       var check = fs.fieldDefs.find((y) => y.fieldId === ed.fieldId);
  //       if (check !== null && check !== undefined) {
  //         fieldSetId = fs.fieldSetId;
  //       }
  //     });

  //     //let fs = doc.fieldSets.find((f) => f.fieldSetId === fieldSetId);

  //     var snap = this.GetValueSnapShot2(
  //       false,
  //       row.rowId,
  //       fieldSetId,
  //       ed.fieldId
  //     );

  //     let extenderData = [];
  //     let temp = snap.find((x) => x.fieldId === column.fieldId);

  //     //let v = row.fieldData.find((x) => x.fieldId === column.fieldId);
  //     //let ext = v.allowedValues.find((x) => x.textValue === temp.fieldValue);

  //     //let doc = this.state.currentDoc;
  //     extenderData.push({
  //       fieldId: column.fieldId,
  //       KeyValue: temp.extenderKey,
  //     });
  //     column.textValue = '';

  //     ExecuteExtender(
  //       ed.extenderId,
  //       extenderData,
  //       '',
  //       ed.fieldId,
  //       snap,
  //       row.rowId
  //     );
  //     //}
  //     //}
  //   });
  // }

  // createNewRow(fieldId, text) {
  //   let currentRows = this.state.rowData;

  //   let rowData = {
  //     rowId: 1,
  //     fieldData: [],
  //   };

  //   this.state.currentFieldSet.fieldDefs.forEach((fd) => {
  //     var newFd = {
  //       fieldDef: fd,
  //       fieldId: fd.fieldId,
  //       value: '',
  //       directChildDependents: fd.directChildDependents,
  //       error: '',
  //     };
  //     if (newFd.fieldId === fieldId) newFd.value = text;
  //   });

  //   currentRows.push(rowData);
  //   this.setState({ rowData: currentRows });
  // }

  startDraggingColumn(e, colIndex) {
    if (colIndex > 0) {
      isDraggingColumn = true;
      startColX = e.clientX;

      let colInfo = this.state.currentFieldSet.fieldDefs.find(
        (c) => c.fieldId === colIndex
      );

      dragColIndex = colIndex;
      if (colInfo) {
        startColWidth = colInfo.colWidth;
      }

      document.addEventListener('mousemove', this.DragColumnSize);
      document.addEventListener('mouseup', this.stopDraggingColSize);
    }
  }

  DragColumnSize(e) {
    if (isDraggingColumn) {
      var delta = e.clientX - startColX;
      if (startColWidth + delta > 20) {
        let info = this.state.currentFieldSet;
        let colInfo = info.fieldDefs.find((c) => c.fieldId === dragColIndex);
        colInfo.colWidth = startColWidth + delta;

        this.setState({ currentFieldSet: info });
      }
    }
  }

  stopDraggingColSize() {
    if (isDraggingColumn) {
      isDraggingColumn = false;

      // set user settings
      var settings = {
        showChecks: this.state.showChecks,

        fieldSettings: [],
      };

      this.state.currentDoc.fieldSets.forEach((fs) => {
        fs.fieldDefs.forEach((fd) => {
          let newFS = {
            fieldId: fd.fieldId,
            colWidth: fd.colWidth,
            display: fd.display,
          };
          settings.fieldSettings.push(newFS);
        });
      });

      document.removeEventListener('mousemove', this.DragColumnSize);
      document.removeEventListener('mouseup', this.stopDraggingColSize);

      UpdateUserFieldSettings(this.state.currentDoc.formTypeId, settings);
    }
  }

  toggleShowAllColumns(e) {
    let cfs = this.state.currentFieldSet;
    let showAll = this.state.showAllColumns;
    showAll = !showAll;
    cfs.fieldDefs.forEach((fd) => {
      fd.display = showAll;
    });
    this.setState({ showAllColumns: showAll, currentFeildSet: cfs });

    // set user settings
    var settings = {
      showChecks: this.state.showChecks,

      fieldSettings: [],
    };

    this.state.currentDoc.fieldSets.forEach((fs) => {
      fs.fieldDefs.forEach((fd) => {
        let newFS = {
          fieldId: fd.fieldId,
          colWidth: fd.colWidth,
          display: fd.display,
        };
        settings.fieldSettings.push(newFS);
      });
    });

    UpdateUserFieldSettings(this.state.currentDoc.formTypeId, settings);
  }

  toggleColumnDisplay(e, fieldId) {
    let cfs = this.state.currentFieldSet;
    let fieldDef = cfs.fieldDefs.find((f) => f.fieldId === fieldId);
    if (fieldDef) {
      fieldDef.display = e.target.checked;
    }
    this.setState({ currentFieldSet: cfs });

    // set user settings
    var settings = {
      showChecks: this.state.showChecks,

      fieldSettings: [],
    };

    this.state.currentDoc.fieldSets.forEach((fs) => {
      fs.fieldDefs.forEach((fd) => {
        let newFS = {
          fieldId: fd.fieldId,
          colWidth: fd.colWidth,
          display: fd.display,
        };
        settings.fieldSettings.push(newFS);
      });
    });

    UpdateUserFieldSettings(this.state.currentDoc.formTypeId, settings);
  }

  setRowCheck(e, rowId) {
    let rows = this.state.rowData;
    let row = rows.find((r) => r.rowId === rowId);
    if (row) {
      row.isChecked = e.target.checked;
    }
    this.setState({ rowData: rows });
  }

  setAllRowCheck(e) {
    let check = e.target.checked;
    this.setState({ allRowCheck: check });

    let rows = this.state.rowData;
    rows.forEach((row) => {
      if (!row.isNew) {
        row.isChecked = check;
      }
    });
    this.setState({ rowData: rows });
  }

  toggleChecks(e) {
    this.setState({ showChecks: e.target.checked });
  }

  toggleShowTools() {
    let show = this.state.showTools;
    this.setState({ showTools: !show });
  }

  writeGridToClipboard() {
    const type = 'text/plain';
    let blobData = '';

    let rowData = this.state.rowData;
    rowData.forEach((rd) => {
      if (rd.isNew !== true) {
        let fieldData = rd.fieldData;
        fieldData.forEach((fd) => {
          blobData += `${fd.fieldValue}\t`;
        });
        blobData += '\n';
      }
    });
    const blob = new Blob([blobData], {
      type,
    });
    const data = [new window.ClipboardItem({ [type]: blob })];
    navigator.clipboard.write(data);
    PostAlert('success', 'Grid lines written to clipboard');
  }

  convertDate(dateString) {
    let d = new Date(dateString);
    let h = d.getHours();
    let mrdn = 'AM';
    if (h === 12) {
      mrdn = 'PM';
    }
    if (h > 12) {
      h = h - 12;
      mrdn = 'PM';
    }
    let min = d.getMinutes();
    if (d.getMinutes() < 10) {
      min = '0' + d.getMinutes();
    }
    return `${
      d.getMonth() + 1
    }/${d.getDate()}/${d.getFullYear()} ${h}:${min} ${mrdn}`;
  }

  toggleFieldSet(fs) {
    let nr = fs.rows.find((r) => r.isNew === true);

    if (!nr) {
      console.log('newRow');
      let maxRowId = 1;
      fs.rows.forEach((r) => {
        if (r.rowId >= maxRowId) {
          maxRowId++;
        }
      });
      let newRow = {
        rowId: maxRowId,
        dbRowId: -1,
        isNew: true,
        isChecked: false,
        isDeleted: false,
        fieldData: [],
      };
      newRow.extenderDependencies = [
        ...this.state.currentDoc.extenderDependencies,
      ];
      fs.fieldDefs.forEach((fd) => {
        let newField = {
          fieldId: fd.fieldId,
          fieldDef: fd,
          fieldValue: '',
          fieldDataType: 0,
          allowedValues: [],
          directChildDependents: fd.directChildDependents,
          error: '',
        };
        newRow.fieldData.push(newField);
      });
      this.processExtenderRow2(newRow, fs);

      //   if (fd.hasExtender) {
      //     let sibDependency = false;
      //     let d = fs.depMap.filter(d2=> d2.fieldId === fd.fieldId);
      //     if(d.length > 0)
      //     {
      //       d.forEach((d2) => {
      //         let sib = fs.fieldDefs.find(s => s.fieldId === d2.depFieldId);

      //         if(sib !== undefined)
      //         {
      //           sibDependency = true;
      //         }
      //       });
      //     }
      //     if(!sibDependency)
      //     {
      //       this.processRowExtender(fd.fieldId, fs, newRow, this.state.currentDoc, 'userEdit');
      //     }

      //   }

      // });
      console.log(newRow);
      fs.rows.push(newRow);
    }

    //needed to add this so the first row of secondary field sets populate extender values
    // fs.rows.forEach((row) => {
    //     this.processExtenderRow(row, fs);
    // });

    this.setState({ currentFieldSet: fs, rowData: fs.rows });
  }

  toggleColumnEdit() {
    let ce = this.state.showColumnEdit;
    this.setState({ showColumnEdit: !ce, showAllColumns: false });
  }

  deleteRow(rowId) {
    let rows = this.state.rowData;

    //this.setState({ rowData: rows }, () => this.generateSnapshot());

    //rows = this.state.rowData;

    let rowToDelete = rows.find((r) => r.rowId === rowId);
    let idx = rows.indexOf(rowToDelete);
    rows.splice(idx, 1);

    let newRowId = 1;
    rows.forEach((r) => {
      r.rowId = newRowId;
      newRowId++;
    });

    /*
    let rowIdx = 1;
    rows.forEach((row) => {
      row.rowId = rowIdx;
      rowIdx++;
    });
    */
    this.updateRunningTotals();
    this.setState({ rowData: rows }, () => {
      this.generateSnapshot();
      this.updateRunningTotals();
    });
  }

  deleteRows() {
    let rows = this.state.rowData;
    let rowsToDelete = [];
    rows.forEach((row) => {
      if (row.isChecked) {
        rowsToDelete.push(row);
      }
    });

    rowsToDelete.forEach((row) => {
      let idx = rows.indexOf(row);
      rows.splice(idx, 1);
    });

    let rowIdx = 1;
    rows.forEach((row) => {
      row.rowId = rowIdx;
      rowIdx++;
    });

    this.setState({ rowData: rows }, () => {
      this.generateSnapshot();
      this.updateRunningTotals();
    });
  }

  toggleDocMenu(e) {
    let showMenu = this.state.showDocumentMenu;
    this.setState({ showDocumentMenu: !showMenu });
    e.stopPropagation();
  }

  hideDocMenu() {
    this.setState({ showDocumentMenu: false });
  }

  toggleShowAudit() {
    let audit = this.state.showAudit;
    this.setState({ showAudit: !audit });
    if (!audit) {
      this.setState({
        fetchingUserActivity: true,
        fetchingIntegrationActivity: true,
        fetchingSystemActivity: true,
        fetchingSystemNotes: true,
        auditInfo: [],
        auditInfo2: [],
        auditInfo3: [],
      });
      GetDocumentUserActivity(this.state.currentDoc);
      GetDocumentIntegrationActivity(this.state.currentDoc);
      GetDocumentSystemActivity(this.state.currentDoc);
      GetDocumentSystemNotes(this.state.currentDoc);
    }
  }

  switchAuditView(newView) {
    this.setState({ currentAuditView: newView });
  }

  toggleTemplateChange() {
    let stc = this.state.showTemplateChange;
    if (!stc) {
      this.filterTemplates('');
    }
    console.log('toggleTemplate');
    let defaultSuggest = 0;
    if(this.state.currentDoc.templateId !== null) {
      defaultSuggest = this.state.currentDoc.templateId;

      if(defaultSuggest === -1) defaultSuggest = 0;
      let selTemplate = this.state.availableTemplates.find(f => f.templateId === defaultSuggest);
      if(selTemplate !== null && defaultSuggest !== -1)
      {
        this.setState({selectedTemplate: selTemplate});
      }
    }
    console.log(defaultSuggest);
    let defaultReader = this.state.currentDoc.readerId;
    let defaultDefault = this.state.currentDoc.defaultId;
    this.setState({ suggestedTemplateId: defaultSuggest, suggestedReaderId: defaultReader, suggestedDefaultId: defaultDefault, showTemplateChange: !stc });


  }

  filterTemplates(searchText) {
    if (searchText === '') {
      this.setState({ filteredTemplates: [...this.state.availableTemplates] });
    } else {
      let newList = [];
      this.state.availableTemplates.forEach((temp) => {
        if (
          temp.templateName.toLowerCase().includes(searchText.toLowerCase())
        ) {
          newList.push(temp);
        }
      });
      console.log(newList);
      this.setState({ filteredTemplates: newList });
      if (newList.length > 0) {
        this.setState({ suggestedTemplateId: newList[0] });
      }
    }
  }

  suggestTemplateItem(tempOption) {
    this.setState({ suggestedTemplateId: tempOption });
  }

  readerSuggestionClick(e) {
    let st = this.state.allReaders.find((t) => t.readerId === e);
    if (st) {
      this.setState({
        suggestedReaderId: e,
      });
    }
  }

  defaultSuggestionClick(e) {
    let st = this.state.allDefaults.find((t) => t.defaultsDBId === e);

    if (st) {
      this.setState({
        suggestedDefaultId: e,
      });
      console.log(e);
    }
  }

  templateSuggestionClick(e) {
    let st = this.state.filteredTemplates.find((t) => t.templateId === e);
    if (st) {
      this.setState({
        selectedTemplate: st, suggestedTemplateId: e
      });
      console.log(st);
    }
  }

  onChangeTemplateSearchText(e) {
    this.setState({ templateSearchText: e.target.value });
    this.filterTemplates(e.target.value);
    // do the search filtering thingy...
  }

  onClickTemplateSearch() {
    if (this.state.selectedTemplate.templateId > 0) {
      this.setState({
        selectedTemplate: {
          templateId: -1,
          templateName: 'Template...',
        },
        templateSearchText: '',
      });
      this.filterTemplates('');
    }
  }

  onClickTemplateChange(changeId) {

    if(changeId === 1){
      UpdateTemplate(
        this.state.currentDoc.documentId,
        this.state.suggestedTemplateId,
        this.state.suggestedReaderId,
        this.state.suggestedDefaultId,
        false,
        false,
      );
    }
    if(changeId === 2){
      UpdateTemplate(
        this.state.currentDoc.documentId,
        this.state.suggestedTemplateId,
        this.state.suggestedReaderId,
        this.state.suggestedDefaultId,
        true,
        false,
      );
    }
    if(changeId === 3){
      UpdateTemplate(
        this.state.currentDoc.documentId,
        this.state.suggestedTemplateId,
        this.state.suggestedReaderId,
        this.state.suggestedDefaultId,
        true,
        true
      );
    }
    this.setState({ inProgressAnimation: true });
  }

  toggleApplyTemplate(e) {
    this.setState({ applyTemplate: e.target.checked });
  }

  setFieldError(fieldId, errorMessage) {
    console.log('setFieldError');
    let doc = this.state.currentDoc;
    if(doc.canEdit)
    {
      let f = doc.headerFields.find((fi) => fi.fieldId === fieldId);
      f.error = errorMessage;
      if (errorMessage === '') {
        this.setState({ currentDoc: doc, fieldsHaveError: false });
      } else {
        this.setState({ currentDoc: doc, fieldsHaveError: true });
      }
    }
  }

  updateRunningTotals() {
    let fs = this.state.currentFieldSet;
    fs.fieldDefs.forEach((fd) => {
      if (fd.showTotal === true) {
        let dec = fd.decimalPlaces ?? 0;
        this.calculateRunningTotal(dec, fd.fieldId, fs.fieldSetId);
      }
    });
  }

  calculateRunningTotal(numDecimalPlaces, fieldId, fieldSetId) {
    //var y = document.getElementById(`${fieldId}_runningTotal`);
    //document.getElementById(`${fieldId}_runningTotal`).innerHTML = '( 0.00 )';
    //var x = document.querySelector(`${fieldId}_runningTotal`).innerHTML;

    //let y2 = document.getElementById(`${fieldId}_runningTotal`).innerHTML;
    let doc = this.state.currentDoc;
    let fieldSet = doc.fieldSets.find((fs) => fs.fieldSetId === fieldSetId);

    var total = 0;
    for (var i = 0; i < fieldSet.rows.length; i++) {
      let row = fieldSet.rows[i];
      var field = row.fieldData.find((field) => field.fieldId === fieldId);
      if (field.fieldValue !== '') {
        var fieldValNoComma = field.fieldValue.replace(/,/g, '');
        var flt = parseFloat(fieldValNoComma);
        if (!isNaN(flt)) {
          total = total + flt;
        }
      }
    }
    if (numDecimalPlaces === null || numDecimalPlaces === undefined) {
      numDecimalPlaces = 2;
    }
    let el = document.getElementById(`${fieldId}_runningTotal`);
    if(el !== null && el !== undefined){
      let totalStr = total.toFixed(numDecimalPlaces);
      let reg = new RegExp('^-0\.[0]*$');
      let match = reg.exec(totalStr);
      if(match !== null) totalStr = totalStr.replace('-', '');
      el.innerHTML =
        '( ' + totalStr + ' )';
    }
  }
  setLineFieldError(fieldId, errorMessage, fieldSetId, rowNo) {
    let doc = this.state.currentDoc;
    //let f2 = doc.headerFields.find((fi) => fi.fieldId === fieldId);
    let fsToError = doc.fieldSets.find((fs) => fs.fieldSetId === fieldSetId);
    let rowToError = fsToError.rows.find((row) => row.rowId === rowNo);

    if (rowToError === undefined || rowToError.isNew === true){
      return;
    }

    let f = rowToError.fieldData.find((field) => field.fieldId === fieldId);

    f.error = errorMessage;
    if (errorMessage === '') {
      this.setState({ currentDoc: doc, fieldsHaveError: false });
    } else {
      this.setState({ currentDoc: doc, fieldsHaveError: true });
    }
  }

  generateDocFields() {
    //let temp = this.state.currentDoc;
  }

  ValidateDocument() {
    let incompleteExtenders = 0;
    //this.showSaveDetails();
    let doc = this.state.currentDoc;
    let validDoc = true;
    let fieldError = false;
    let validationErrors = [];
    console.log('validate');
    doc.headerFields.forEach((field) => {
      let newError = false;
      if (field.hasExtender) {
        var exists = field.extender.allowedValues.some(
          (x) => x.textValue === field.fieldValue
        );
        if (
          exists === false &&
          field.fieldValue !== null &&
          field.fieldValue !== ''
        ) {
          //PostAlert('error', 'UHOH');

          let errMsg = `Value not allowed by extender.  Field: '${field.displayName}' Value: '${field.fieldValue}' `;
          validationErrors.push(errMsg);

          field.error =
            'Value not allowed by extender {' + field.fieldValue + '}';

          validDoc = false;
          fieldError = true;
          newError = true;
        } else if (field.fieldValue === null) {
          field.fieldValue = '';
          field.extenderKey = '-1';
        } else {
          //PostAlert('error', 'UHOH');
          field.error = '';

          fieldError = false;
        }
      } else {
        //doesnt have extender
      }

      if (field.isRequired) {
        if (field.fieldValue === '') {
          let errMsg = `Field is required.  Field: '${field.displayName}' `;
          validationErrors.push(errMsg);

          field.error = 'Field is required';
          validDoc = false;
          fieldError = true;
          newError = true;
        }
      }

      if (!newError && field.fieldType === 1) {
        if (field.fieldValue !== '') {
          let indexOfDecimal = field.fieldValue.indexOf('.');
          if (indexOfDecimal > -1) {
            let currentDigits = field.fieldValue.length - indexOfDecimal - 1;
            if (currentDigits < field.decimalPlaces) {
              while (currentDigits < field.decimalPlaces) {
                field.fieldValue = field.fieldValue + '0';
                currentDigits = field.fieldValue.length - indexOfDecimal - 1;
              }

            }
          } else {
            if(field.decimalPlaces > 0)
            {
              field.fieldValue = field.fieldValue + '.';
              for (let i = 0; i < this.props.decimalPlaces; i++) {
                field.fieldValue = field.fieldValue + '0';
              }
            }
          }
          let re = new RegExp('^-?[0-9]*$');
          if (field.decimalPlaces > 0) {
            re = new RegExp(
              `^-?[0-9]*\\.[0-9]{${field.decimalPlaces.toString()}}$`
            );
          }
          if (!re.test(field.fieldValue)) {
            let errMsg = `Field must be numeric.  Field: '${field.displayName}'  Value: '${field.fieldValue}'  `;
            validationErrors.push(errMsg);

            field.error = 'Field must be numeric';
            validDoc = false;
            fieldError = true;
            newError = true;
          }
        }
      }

      if (!newError && field.fieldType === 2) {
        if (field.fieldValue !== '') {

          // fix short handed dates
          let reFullDate = new RegExp('^[0-9]{2}/[0-9]{2}/[0-9]{4}');
          let reShortDate = new RegExp('^[0-9]{1,2}/[0-9]{1,2}/[0-9]{4}');
          if(!reFullDate.test(field.fieldValue) && reShortDate.test(field.fieldValue) && (field.format === 'dd/mm/yyyy' || field.format === 'mm/dd/yyyy'))
          {
            let dateParts = field.fieldValue.split('/');
            if(dateParts[0].length === 1) dateParts[0] = '0' + dateParts[0];
            if(dateParts[1].length === 1) dateParts[1] = '0' + dateParts[1];
            field.fieldValue = dateParts[0] + '/' + dateParts[1] + '/' + dateParts[2];
          }

          if (field.format === 'dd/mm/yyyy') {
            let re = new RegExp('^[0-9]{2}/[0-9]{2}/[0-9]{4}');
            if (!re.test(field.fieldValue)) {
              let errMsg = `Field must in date format.  Field: '${field.displayName}'  Value: '${field.fieldValue}'  `;
              validationErrors.push(errMsg);

              field.error = 'Field must in date format';
              validDoc = false;
              fieldError = true;
              newError = true;
            }
          }
          if (field.format === 'mm/dd/yyyy') {
            let re = new RegExp('^[0-9]{2}/[0-9]{2}/[0-9]{4}');
            if (!re.test(field.fieldValue)) {
              let errMsg = `Field must in date format.  Field: '${field.displayName}'  Value: '${field.fieldValue}'  `;
              validationErrors.push(errMsg);
              field.error = 'Field must be date format';
              validDoc = false;
              fieldError = true;
              newError = true;
            }
          }
          if (field.format === 'mm-dd-yyyy') {
            let re = new RegExp('^[0-9]{2}-[0-9]{2}-[0-9]{4}');
            if (!re.test(field.fieldValue)) {
              let errMsg = `Field must in date format.  Field: '${field.displayName}'  Value: '${field.fieldValue}'  `;

              validationErrors.push(errMsg);

              field.error = 'Field must be numeric';
              validDoc = false;
              fieldError = true;
              newError = true;
            }
          }
        }
      }

      if (!fieldError) {
        field.error = '';
      }
    });


    let extendersNotLoaded = [];
    let totalExtenderCount = 0;
    //now lets do lines
    doc.fieldSets.forEach((fieldSet) => {
      //let rows = fieldSet.rows;
      for (var i = 0; i < fieldSet.rows.length; i++) {
        let row = fieldSet.rows[i];
        let fields = row.fieldData;
        let pendingExtenders = 0;
        fields.forEach((field) => {
          //let fieldError = false;
          let dep = this.findDependency(
            fieldSet.rowDependencies,
            field.fieldId
          );
          if (dep !== null && dep.hasExtender) {
            totalExtenderCount++;
            let exists = field.allowedValues.some(
              (x) => x.textValue.toUpperCase === field.fieldValue.toUpperCase
            );
            if (field.error.length > 0) {

              let errMsg = `Row value not allowed by extender. ${field.error}  Field: '${field.fieldDef.colName}' Row: '${row.rowId}' `;
              validationErrors.push(errMsg);
              validDoc = false;
            } else if (
              exists === false &&
              field.fieldValue !== null &&
              field.fieldValue !== '' &&
              field.displayName === undefined
            ) {

              // this is to get % of extenders processed
              extendersNotLoaded.push(i);
              validDoc = false;
              //field.error ='Field has no values';
              fieldError = true;
            }
            else if (
              exists === false &&
              field.fieldValue !== null &&
              field.fieldValue !== ''
            ) {
              //PostAlert('error', 'UHOH');
              let errMsg = `Row value not allowed by extender.  Field: '${field.displayName}' Value: '${field.fieldValue}' Row: '${row.rowId}' `;
              validationErrors.push(errMsg);
              validDoc = false;
              field.error =
                'Value not allowed by extender {' + field.fieldValue + '}';
              validDoc = false;
              fieldError = true;
            }

            else {
              //PostAlert('error', 'UHOH');
              // field.error = '';
              // fieldError = false;
            }
          }
        });
        if(pendingExtenders>0) incompleteExtenders++;
      }
    });

    // instead of giving generic error, give error that tells how many have processed
    if (extendersNotLoaded.length > 0){
      let finished = totalExtenderCount - extendersNotLoaded.length;
      let percent = Math.round((finished/totalExtenderCount)*100);
      validationErrors.push('Line values are still loading. ' + percent + '% complete. Please wait a moment and try again.');
    }
    if (validationErrors.length > 0) {
      this.setState({ errorMessages: validationErrors });
    }
    return validDoc;
  }

  checkQueueChanges() {
    return this.state.queuesDirty;
  }

  GetValueSnapShot(isHeaderValue, rowNo, currentFieldSetId, currentFieldId) {
    let doc = this.state.currentDoc;

    let fieldSnap = [];
    doc.headerFields.forEach((field) => {
      var obj = {
        fieldId: field.fieldId,
        fieldValue: field.fieldValue,
        isHeaderField: true,
        extenderKey: field.extenderKey,
        hasExtender: field.hasExtender,
        fieldSetId: -1,
        rowNo: -1,
      };

      if (currentFieldSetId === null || currentFieldSetId === undefined) {
        obj.fieldSetId = -1;
      }
      if (obj.extenderKey === undefined || obj.extenderKey === null) {
        obj.extenderKey = '';
      }

      if (obj.extenderKey === '' && field.hasExtender) {
        //lets try and find extender keys
        var ext = field.extender.allowedValues.find(
          (x) => x.textValue === field.fieldValue
        );
        if (ext !== null && ext !== undefined) {
          obj.extenderKey = ext.extenderKey;
        }
      }

      fieldSnap.push(obj);
    });

    if (!isHeaderValue) {
      if (currentFieldSetId === null && currentFieldId !== null) {
        //var x = 1;
        let fieldSets = doc.fieldSets;

        fieldSets.forEach((fs) => {
          var check = fs.fieldDefs.find((y) => y.fieldId === currentFieldId);
          if (check !== null && check !== undefined) {
            currentFieldSetId = fs.fieldSetId;
          }
        });
      }

      let fs = doc.fieldSets.find((f) => f.fieldSetId === currentFieldSetId);

      if (
        fs !== undefined &&
        fs !== null &&
        fs.rows !== undefined &&
        fs.rows !== null
      ) {
        let row = fs.rows.find((r) => r.rowId === rowNo);
        if (row !== null) {
          row.fieldData.forEach((rowField) => {
            let matchingFfs = fs.fieldDefs.find(
              (x) => x.fieldId === rowField.fieldId
            );
            var obj = {
              fieldId: rowField.fieldId,
              fieldValue: rowField.fieldValue,
              isHeaderField: false,
              extenderKey: rowField.keyValue,
              hasExtender: matchingFfs.hasExtender,
              fieldSetId: currentFieldSetId,
              rowNo: rowNo,
            };
            if (obj.extenderKey === undefined || obj.extenderKey === null) {
              obj.extenderKey = '';
            }

            if (obj.extenderKey === '' && rowField.hasExtender) {
              //lets try and find extender keys
              var ext = rowField.allowedValues.find(
                (x) => x.textValue === rowField.fieldValue
              );
              if (ext !== null && ext !== undefined) {
                obj.extenderKey = ext.extenderKey;
              }
            }

            fieldSnap.push(obj);
          });
        }
      }
      //row.fieldData.forEach((rowField) => {
      //let matchingFfs = fs.fieldDefs.find(x=> x.fieldId==rowField.fieldId);
      //});
    }

    return fieldSnap;
  }

  GetValueSnapShot2(isHeaderValue, rowNo, currentFieldSetId, currentFieldId) {
    let doc = this.state.currentDoc;

    let fieldSnap = [];
    doc.headerFields.forEach((field) => {
      var obj = {
        fieldId: field.fieldId,
        fieldValue: field.fieldValue,
        isHeaderField: true,
        extenderKey: field.extenderKey,
        hasExtender: field.hasExtender,
        fieldSetId: -1,
        rowNo: -1,
      };

      if (obj.fieldValue === null) {
        obj.fieldValue = '';
      }

      if (currentFieldSetId === null || currentFieldSetId === undefined) {
        obj.fieldSetId = -1;
      }
      if (obj.extenderKey === undefined || obj.extenderKey === null) {
        obj.extenderKey = '';
      }

      if (obj.extenderKey === '' && field.hasExtender) {
        //lets try and find extender keys
        var ext = field.extender.allowedValues.find(
          (x) => x.textValue === field.fieldValue
        );
        if (ext !== null && ext !== undefined) {
          obj.extenderKey = ext.extenderKey;
        }
      }

      fieldSnap.push(obj);
    });

    if (!isHeaderValue) {
      if (currentFieldSetId === null && currentFieldId !== null) {
        //var x = 1;
        let fieldSets = doc.fieldSets;

        fieldSets.forEach((fs) => {
          var check = fs.fieldDefs.find((y) => y.fieldId === currentFieldId);
          if (check !== null && check !== undefined) {
            currentFieldSetId = fs.fieldSetId;
          }
        });
      }

      let fs = doc.fieldSets.find((f) => f.fieldSetId === currentFieldSetId);

      if (
        fs !== undefined &&
        fs !== null &&
        fs.rows !== undefined &&
        fs.rows !== null
      ) {
        let row = fs.rows.find((r) => r.rowId === rowNo);
        if (row !== null) {
          row.fieldData.forEach((rowField) => {
            let matchingFfs = fs.fieldDefs.find(
              (x) => x.fieldId === rowField.fieldId
            );
            if (matchingFfs) {
              var obj = {
                fieldId: rowField.fieldId,
                fieldValue: rowField.fieldValue,
                isHeaderField: false,
                extenderKey: rowField.keyValue,
                hasExtender: matchingFfs.hasExtender,
                fieldSetId: currentFieldSetId,
                rowNo: rowNo,
              };
              if (obj.extenderKey === undefined || obj.extenderKey === null) {
                obj.extenderKey = '';
              }

              if (obj.extenderKey === '' && rowField.hasExtender) {
                //lets try and find extender keys
                var ext = rowField.allowedValues.find(
                  (x) => x.textValue === rowField.fieldValue
                );
                if (ext !== null && ext !== undefined) {
                  obj.extenderKey = ext.extenderKey;
                }
              }

              fieldSnap.push(obj);
            }
          });
        }
      }
    }
    //row.fieldData.forEach((rowField) => {
    //let matchingFfs = fs.fieldDefs.find(x=> x.fieldId==rowField.fieldId);
    //});

    return fieldSnap;
  }

  closeAllList() {
    var x = document.getElementsByClassName('autocomplete-items');
    for (var i = 0; i < x.length; i++) {
      x[i].parentNode.removeChild(x[i]);
    }
  }

  removeAssignment(userId) {
    let doc = this.state.currentDoc;
    let assignment = doc.queueAssignments.find((a) => a.userId === userId);
    if (assignment) {
      if (assignment.assignStatus === 'NEW') {
        let idx = doc.queueAssignments.indexOf(assignment);
        doc.queueAssignments.splice(idx, 1);
      } else {
        assignment.assignStatus = 'DELETE';
      }
      let dirty = false;
      doc.queueAssignments.forEach((q) => {
        if (q.assignStatus === 'NEW') dirty = true;
        if (q.assignStatus === 'DELETE') dirty = true;
      });
      this.setState({ currentDoc: doc, queuesDirty: dirty });
    }
    //ChangeQueueAssignment(userId, doc.documentId, doc.workflowStepId, 'REMOVE');
  }

  editAssignUser(e) {
    var x = document.getElementsByClassName('docAssignUserItem');
    for (var i = 0; i < x.length; i++) {
      x[i].parentNode.removeChild(x[i]);
    }

    let doc = this.state.currentDoc;
    let auto = document.getElementById('docContainerAssignUserText');

    let val = e.target.value;
    let a = document.createElement('DIV');
    a.setAttribute('id', 'autocomplete-list');
    a.setAttribute('class', 'docAssignUserItem');

    a.setAttribute('style', 'max-height: 200px; overflow: auto');
    auto.appendChild(a);
    for (let i = 0; i < doc.assignableUsers.length; i++) {
      if (
        doc.assignableUsers[i].userName
          .substring(0, val.length)
          .toUpperCase() === val.toUpperCase() ||
        doc.assignableUsers[i].fullName
          .substring(0, val.length)
          .toUpperCase() === val.toUpperCase()
      ) {
        let b = document.createElement('DIV');
        b.setAttribute('class', 'docAssignItem');
        b.innerHTML =
          '<div><strong tabIndex="-1">' +
          doc.assignableUsers[i].fullName +
          '</strong></div>';
        b.innerHTML +=
          '<div class="docAssignSubHeader">' +
          doc.assignableUsers[i].userName +
          '</div>';
        b.addEventListener('mousedown', (e) =>
          this.onClickAssignableUser(e, doc.assignableUsers[i])
        );
        a.appendChild(b);
      }
    }

    //this.props.updateValue(e.target.value, this.props.fieldId, this.props.systemName);
    this.setState({ userSearch: e.target.value });
  }

  editMoveAssignUser(e) {
    var x = document.getElementsByClassName('moveAssignUserItem');
    for (var i = 0; i < x.length; i++) {
      x[i].parentNode.removeChild(x[i]);
    }

    let auto = document.getElementById('moveContainerAssignUserText');

    let val = e.target.value;
    let a = document.createElement('DIV');
    a.setAttribute('id', 'autocomplete-list');
    a.setAttribute('class', 'moveAssignUserItem');

    a.setAttribute('style', 'max-height: 260px; overflow: auto');
    auto.appendChild(a);
    for (let i = 0; i < this.state.moveAssignUsers.length; i++) {
      if (
        this.state.moveAssignUsers[i].userName
          .substring(0, val.length)
          .toUpperCase() === val.toUpperCase() ||
        this.state.moveAssignUsers[i].fullName
          .substring(0, val.length)
          .toUpperCase() === val.toUpperCase()
      ) {
        let b = document.createElement('DIV');
        b.setAttribute('class', 'docAssignItem');
        b.innerHTML =
          '<div><strong tabIndex="-1">' +
          this.state.moveAssignUsers[i].fullName +
          '</strong></div>';
        b.innerHTML +=
          '<div class="docAssignSubHeader">' +
          this.state.moveAssignUsers[i].userName +
          '</div>';
        b.addEventListener('mousedown', (e) =>
          this.onClickMoveAssignableUser(e, this.state.moveAssignUsers[i])
        );
        a.appendChild(b);
      }
    }
    this.setState({ moveAssignUserSearch: e.target.value });
  }

  onClickMoveAssignableUser(e, user) {
    let assignedUsers = this.state.moveAssignSelectedUsers;
    let idx = assignedUsers.indexOf(user);
    if (idx === -1) {
      assignedUsers.push(user);
      this.setState({ moveAssignSelectedUsers: assignedUsers });
    }
  }

  onClickRemoveMoveAssignUser(e, user) {
    let assignedUsers = this.state.moveAssignSelectedUsers;
    let idx = assignedUsers.indexOf(user);
    assignedUsers.splice(idx, 1);
    this.setState({ moveAssignSelectedUsers: assignedUsers });
  }

  assignUserBlur() {
    var x = document.getElementsByClassName('docAssignUserItem');
    for (var i = 0; i < x.length; i++) {
      x[i].parentNode.removeChild(x[i]);
    }
    this.setState({ userSearch: '' });
  }

  moveAssignUserBlur() {
    var x = document.getElementsByClassName('moveAssignUserItem');
    for (var i = 0; i < x.length; i++) {
      x[i].parentNode.removeChild(x[i]);
    }
    this.setState({ moveAssignUserSearch: '' });
  }

  onClickAssignableUser(e, au) {
    let doc = this.state.currentDoc;
    let newAssignment = {
      userId: au.userId,
      assignStatus: 'NEW',
      userName: au.userName,
      canUnassign: true,
    };
    doc.queueAssignments.push(newAssignment);
    this.setState({ currentDoc: doc, queuesDirty: true });
    //ChangeQueueAssignment(au.userId, doc.documentId, doc.workflowStepId, 'ADD');
  }

  toggleUserNotes() {
    let sun = this.state.showUserNotes;
    if (sun) {
      let ivw = window.innerWidth - 280 - 20;
      this.setState({
        showUserNotes: false,
        showAddNote: false,
        imageviewerWidth: ivw,
      });
      UpdateSetting('pin_user_notes', 'false');
    } else {
      let ivw = window.innerWidth - 280 - 20 - 280;
      this.setState({
        showUserNotes: true,
        showAddNote: true,
        imageviewerWidth: ivw,
      });
      UpdateSetting('pin_user_notes', 'true');
    }
  }

  toggleAddNote() {
    let addNote = this.state.showAddNote;
    this.setState({ showAddNote: !addNote });
  }

  addNote() {
    AddNote(this.state.newNote, this.state.currentDoc.documentId);
    this.setState({ newNote: '' });
  }

  cancelReject() {
    this.setState({ showReasonForReject: false, rejectReasonNote: '' });
  }

  confirmReject() {
    AddNote(this.state.rejectReasonNote, this.state.currentDoc.documentId);
    SubmitDocument('REJECT', this.state.currentDoc);
    this.setState({ showReasonForReject: false, rejectReasonNote: '' });
  }

  editNewNote(e) {
    this.setState({ newNote: e.target.value });
  }

  editRejectNote(e) {
    this.setState({ rejectReasonNote: e.target.value });
  }

  convertDate2(strDate) {
    //console.log(strDate);
    if (strDate === null) {
      return '';
    }
    let strDate2 = strDate.toString();
    if (!strDate2.endsWith('Z')) {
      strDate2 = strDate2 + 'Z';
    }
    let date = new Date(strDate2);
    let d1 = date.getDate();
    let day = d1.toString();
    let m1 = date.getMonth();
    m1 = m1 + 1;
    let mon = m1.toString();
    let year = date.getFullYear().toString();
    let h1 = date.getHours();
    //console.log(h1);
    let mer = 'AM';
    if(h1 > 11) {
      mer = 'PM';
    }
    if(h1 === 24) {
      mer = 'AM';
    }
    if (h1 > 12) {
      h1 = h1 - 12;
    }
    if (h1 === 0) {
      h1 = 12;
    }

    let h = h1.toString();
    let m = date.getUTCMinutes().toString();
    if (m.length === 1) {
      m = '0' + m;
    }

    let fulldtime =
      mon + '/' + day + '/' + year + ' ' + h + ':' + m + ' ' + mer;
    return fulldtime;
  }

  // Excel paste
  toggleExcelPaste() {
    let excelOpen = this.state.showExcelPaste;
    this.setState({ showExcelPaste: !excelOpen, excelData: [] });
  }

  pasteExcel(e) {
    if (e.target.value.length > 1) {
      navigator.clipboard.readText().then((clipText) => {
        let currentRowId = 1;
        let currentString = '';
        let wordStart = 0;
        let currentCell = 1;
        let excelData = [];
        let currentRow = { rowId: currentRowId, cells: [] };

        for (var i = 0; i < clipText.length; i++) {
          let charId = clipText.charCodeAt(i);
          if (charId === 9) {
            // tab
            currentString = clipText.substring(wordStart, i);
            wordStart = i + 1;

            currentRow.cells.push({
              cellId: currentCell,
              value: currentString,
            });
            currentCell++;
          } else if (charId === 13) {
            // new line
            currentString = clipText.substring(wordStart, i);
            wordStart = i + 1;

            currentRow.cells.push({
              cellId: currentCell,
              value: currentString,
            });
            currentCell = 1;
            excelData.push({ rowId: currentRowId, rowData: currentRow });
            currentRowId++;
            currentRow = { rowId: currentRowId, cells: [] };
          }
        }
        this.setState({ excelData: excelData });
      });
    }
  }

  replaceExcelData() {
    let rows = this.state.rowData;
    //let lastRow = this.state.rowData[this.state.rowData.length - 1];

    let excelData = this.state.excelData;
    let nextRowId = 0;
    let fieldSet = this.state.currentFieldSet;
    let maxRow = {
      rowId: 1,
      fieldData: [],
    };

    let newRow = {};
    let rowsToRemove = [];
    rows.forEach((row) => {
      if(!row.isNew) { rowsToRemove.push(row); }
      else newRow = row;
    });
    rowsToRemove.forEach((row) => {
      let idx = rows.indexOf(row);
      rows.splice(idx, 1);
    });
    if (nextRowId === 0) nextRowId = 1;
    let rowIndex = rows.indexOf(maxRow);

    excelData.forEach((ed) => {
      let newRow = {
        rowId: nextRowId,
        dbRowId: -1,
        isChecked: false,
        isNew: false,
        isDeleted: false,
        fieldData: [],
      };
      let cellIndex = 0;
      this.state.currentFieldSet.fieldDefs.forEach((fd) => {
        let newField = {
          fieldId: fd.fieldId,
          fieldDef: fd,
          fieldValue: '',
          fieldDataType: 0,
          allowedValues: [],
          directChildDependents: fd.directChildDependents,
          error: '',
        };
        // if (fd.hasExtender) {
        //   //newField.allowedValues = fd.extender.allowedValues;
        //   if (fd.extender.allowedValues.length === 0){
        //     let rowData = lastRow.fieldData.find((r) => r.fieldId === fd.fieldId);
        //     newField.allowedValues = rowData.allowedValues;
        //     fd.extender.allowedValues = rowData.allowedValues;
        //   }
        //   else{
        //     newField.allowedValues = fd.extender.allowedValues;
        //   }
        // }


        if (ed.rowData.cells.length > cellIndex) {
          newField.fieldValue = ed.rowData.cells[cellIndex].value.replace(
            /\n/g,
            ''
          );
        }
        cellIndex++;

        newRow.fieldData.push(newField);
      });
      nextRowId++;
      rowIndex++;
      rows.splice(rowIndex, 0, newRow);
      this.processExtenderRow(newRow, fieldSet);

      //rows.push(newRow);
    });
    newRow.rowId = nextRowId;

    // need to do this so the blank row does not have the same id as any of the rows that were replaced
    // lastRow.rowId = rows.length + 1;
    // rows.push(lastRow);

    // let currentDocFieldSet = this.state.currentDoc.fieldSets.find(
    //   (fs) => fs.fieldSetId === this.state.currentFieldSet.fieldSetId
    // );

    // currentDocFieldSet.rows = rows;
    console.log(rows);
    this.setState(
      { rowData: rows, showExcelPaste: false },
      this.reviewSnapshots()
    );

  }

  appendExcelData() {
    let rows = this.state.rowData;
    let excelData = this.state.excelData;
    let nextRowId = 0;
    let fieldSet = this.state.currentFieldSet;
    let maxRow = {
      rowId: 1,
      fieldData: [],
    };

    let newRow = {};
    rows.forEach((row) => {
      if (row.rowId >= nextRowId && row.isNew !== true) {
        nextRowId = row.rowId + 1;
        maxRow = row;
      }
      if (row.isNew === true) {
        newRow = row;
      }
    });
    if (nextRowId === 0) nextRowId = 1;
    let rowIndex = rows.indexOf(maxRow);

    excelData.forEach((ed) => {
      let newRow = {
        rowId: nextRowId,
        dbRowId: -1,
        isChecked: false,
        isNew: false,
        isDeleted: false,
        fieldData: [],
      };
      let cellIndex = 0;
      this.state.currentFieldSet.fieldDefs.forEach((fd) => {
        let newField = {
          fieldId: fd.fieldId,
          fieldDef: fd,
          fieldValue: '',
          fieldDataType: 0,
          allowedValues: [],
          directChildDependents: fd.directChildDependents,
          error: '',
        };
        // if (fd.hasExtender) {
        //   newField.allowedValues = fd.extender.allowedValues;
        // }
        if (ed.rowData.cells.length > cellIndex) {
          newField.fieldValue = ed.rowData.cells[cellIndex].value.replace(
            /\n/g,
            ''
          );
        }
        cellIndex++;

        newRow.fieldData.push(newField);
      });
      nextRowId++;
      rowIndex++;
      rows.splice(rowIndex, 0, newRow);
      this.processExtenderRow(newRow, fieldSet);

      //rows.push(newRow);
    });
    newRow.rowId = nextRowId;

    this.setState(
      { rowData: rows, showExcelPaste: false },
      this.reviewSnapshots()
    );
    // this.state.currentFieldSet.fieldDefs.forEach(fd => {
    //    var newFd = {
    //       fieldDef: fd,
    //       fieldId: fd.fieldId,
    //       value: '',
    //    }
    //    if(newFd.fieldId === fieldId) newFd.value = text;

    // });

    // currentRows.push(rowData);
    // this.setState({rowData: currentRows});
  }

  toggleCheck(rowId) {
    let rows = this.state.rowData;
    let checkRow = rows.find((r) => r.rowId === rowId);
    if (checkRow) {
      if (checkRow.auditCheck === undefined) {
        checkRow.auditCheck = true;
      } else {
        checkRow.auditCheck = !checkRow.auditCheck;
      }
    }
    this.setState({ rowData: rows });
  }

  downloadAttachment(attchId, fileName) {
    DownloadAttachment(this.state.currentDoc.documentId, attchId, fileName);
  }

  deleteAttachment(attchId) {
    DeleteAttachment(this.state.currentDoc.documentId, attchId);
  }

  pullDocFromUser() {
    PullDocument(this.state.currentDoc.documentId);
  }

  uploadAttachment() {
    let input = document.getElementById('acctchUploadInput');
    input.value = '';
    document.getElementById('acctchUploadInput').click();
  }

  uploadAttachmentSubmit(e) {
    let input = document.getElementById('acctchUploadInput');
    if (input.files.length > 0) {
      UploadAttachment(
        input.files[0],
        input.files[0].fileName,
        this.state.currentDoc.documentId
      );
    }
  }

  onDropAttachment(files) {
    UploadAttachment(
      files[0], files[0].path, this.state.currentDoc.documentId
    )
  }

  toggleProperties() {
    let p = this.state.showProperties;
    this.setState({ showProperties: !p });
  }

  loadIntakeLogs() {
    GetDocumentIntakeLogs(this.state.documentID);
  }

  toggleIntakeLogs() {
    let p = this.state.showIntakeLogs;
    this.setState({ showIntakeLogs: !p });
  }

  toggleAudit(audit) {
    if(audit.isOpen) {
      audit.isOpen = false;
    } else {
      audit.isOpen = true;
    }
    this.setState({intakeLogs: this.state.intakeLogs});
  }

  handleStampClick(e) {
    let menu = this.state.showStampMenu;
    this.setState({ showStampMenu: !menu });
    e.stopPropagation();
  }

  toggleStamps() {
    let s = this.state.showStampScreen;
    let req = this.state.stampRequest;
    let doc = this.state.currentDoc;
    if (!s) {
      let stampIndex = 1;
      req.stamps = [];
      doc.stampGroups.forEach((sg) => {
        let stamp = {
          stampId: stampIndex,
          stampDesc: sg.groupName,
          x: -1,
          y: -1,
        };
        req.stamps.push(stamp);
        stampIndex++;
      });
    }
    this.setState({ showStampScreen: !s, stampRequest: req });
  }

  showSaveDetails() {
    console.log('Save Details');
    console.log(`isSaving: ${this.state.isSaving}`);
    console.log(`fieldsHaveError: ${this.state.fieldsHaveError}`);
    console.log(`snapshots: ${this.state.snapshots.length}`);
    console.log(`userCanEdit: ${this.state.userCanEdit}`);
    console.log(`userCanMoveAssign ${this.state.userCanMoveAssign}`);
    console.log(`queuesDirty: ${this.state.queuesDirty}`);
  }

  editStampRequest(e, stampValue) {
    let req = this.state.stampRequest;
    switch (stampValue) {
      case 'docId':
        req.showDocId = e.target.checked;
        break;
      case 'userName':
        req.showUserName = e.target.checked;
        break;
      case 'date':
        req.showDate = e.target.checked;
        break;
      case 'time':
        req.showTime = e.target.checked;
        break;
      case 'size':
        req.size = parseInt(e.target.value);
        if (req.size === 1) req.sizeDesc = 'Small';
        if (req.size === 2) req.sizeDesc = 'Medium';
        if (req.size === 3) req.sizeDesc = 'Large';
        break;
      case 'transparency':
        req.useTransparency = e.target.checked;
        break;
      default:
        break;
    }
    this.setState({ stampValue: req });
  }

  stampImageClick(e) {
    let lastStamp = this.state.lastStampPos;
    let req = this.state.stampRequest;
    let nextStamp = lastStamp + 1;
    if (nextStamp >= req.stamps.length) {
      nextStamp = 0;
    }
    let s = req.stamps[nextStamp];
    let z = document.getElementById('stampPositionArea');
    let rect = z.getBoundingClientRect();

    let x = e.clientX - e.target.x;
    let y = e.clientY - e.target.y;
    let imageMax = Math.max(
      this.state.images[0].imageWidth,
      this.state.images[0].imageHeight
    );
    // let r =
    //   Math.max(
    //     this.state.images[0].imageWidth,
    //     this.state.images[0].imageHeight
    //   ) / 300;
    s.x = (x * imageMax) / 300;
    s.y = (y * imageMax) / 300;
    s.x = ((e.clientX - rect.x) * imageMax) / 300;
    s.y = ((e.clientY - rect.y) * imageMax) / 300;
    this.setState({ lastStampPos: nextStamp, stampRequest: req });
  }

  downloadDocument() {
    let doc = this.state.currentDoc;
    DownloadPDF(doc.documentId, doc.originalFileName);
  }

  downloadRelatedDocumentPacket() {
    let doc = this.state.currentDoc;
    let docIds = doc.relatedDocuments.map((a) => a.documentId);

    let originalDocId = doc.originalDocId;
    if (originalDocId === 0) {
      originalDocId = doc.documentId;
    }

    DownloadRelatedDocumentPacket(originalDocId, docIds);
  }

  convertUTCDateToLocalDate(date) {
    var newDate = new Date(date.getTime()+date.getTimezoneOffset()*60*1000);

    var offset = date.getTimezoneOffset() / 60;
    var hours = date.getHours();

    newDate.setHours(hours - offset);

    return newDate;
}

  downloadDocumentWithStamps() {
    let doc = this.state.currentDoc;
    let sc = this.state.stampRequest;
    sc.stamps.forEach((st) => {
      st.groupName = st.stampDesc;
      st.stamps = [];
      st.x = Math.round(st.x);
      st.y = Math.round(st.y);
      let sr = doc.stampGroups.find((f) => f.groupName === st.stampDesc);
      if (sr) {
        st.groupStatus = sr.groupStatus;
        sr.stamps.forEach((s) => {
          var sDate = new Date(s.stampTime);
          console.log(sDate);
          var sDate2 = this.convertDate2(sDate);
          console.log(sDate2);
          console.log(sDate.toString());
          s.stampLocalTime = sDate2;
          console.log(s);
          st.stamps.push(s);
        });
      }
    });
    DownloadPDFWithStamps(doc.documentId, doc.originalFileName, sc);
  }

  downloadDocumentAndAttachments() {
    let doc = this.state.currentDoc;

    let originalDocId = doc.originalDocId;
    if (originalDocId === 0) {
      originalDocId = doc.documentId;
    }
    let originalFileName = `TrinDocs Document and Attachments for Document ${doc.documentId}.zip`;
    DownloadPDFWithAttachments(doc.documentId, originalFileName);
  }

  toggleShowMoveAssign() {
    let moveAssign = this.state.showMoveAssign;
    this.setState({
      showMoveAssign: !moveAssign,
      moveAssignStepId: -1,
      moveAssignSelectedUsers: [],
    });
  }

  editMoveAssignStep(e) {
    this.setState({ moveAssignStepId: parseInt(e.target.value) });
    let doc = this.state.currentDoc;
    FetchAssignableUsers(
      parseInt(e.target.value, 10),
      this.state.currentDoc.businessProcessId,
      doc.documentId,
    );
  }

  moveAssignDoc() {
    let uids = [];
    this.state.moveAssignSelectedUsers.forEach((u) => uids.push(u.userId));
    MoveAssignDocument(
      this.state.currentDoc.documentId,
      this.state.moveAssignStepId,
      uids,
      this.state.currentDoc
    );
    this.toggleShowMoveAssign();
  }

  onRelatedMouseIn(e, relatedDoc) {
    let rect = e.target.getBoundingClientRect();
    let info = this.state.relatedInfo;
    info.show = true;
    info.left = Math.round(rect.x) + Math.round(rect.width) - 170;
    info.field = relatedDoc.field;
    info.formType = relatedDoc.formType;
    this.setState({ relatedInfo: info });
  }

  onRelatedMouseOut(e) {
    let info = this.state.relatedInfo;
    info.show = false;
    this.setState({ relatedInfo: info });
  }

  onRelatedMouseClick(e) {}

  onRelatedClick(e, doc) {
    if(e.ctrlKey)
    {
      window.open('/Document/' + doc.documentId);
    } else {
      let relatedDocLink = document.getElementById(
        'relatedDocLink' + doc.documentId
      );
      this.setState({ relatedDocChange: true });
      relatedDocLink.click();
    }
  }

  onBackToOriginalDoc() {
    if(this.state.currentDoc.originalDocId !== 0)
    {
      let originalDocLink = document.getElementById('originalDocLink');
      this.setState({ relatedDocChange: true });
      originalDocLink.click();
    }
  }

  rotateDocImageLeft() {
    RotateImage(
      this.state.currentDoc.documentId,
      this.state.currentImage.pageId,
      270,
      this.state.currentImage.imageBytes
    );
    this.setState({ isRotatingLeft: true });
  }

  rotateDocImageRight() {
    RotateImage(
      this.state.currentDoc.documentId,
      this.state.currentImage.pageId,
      90,
      this.state.currentImage.imageBytes
    );
    this.setState({ isRotatingRight: true });
  }

  toggleChangeBusinessProcess() {
    if (this.state.availableBps.length === 0) {
      GetBPList();
    }
    let show = this.state.showChangeBusinessProcess;
    this.setState({ showChangeBusinessProcess: !show });
    this.setState({ templateSearchText2: '' });
  }

  editBps(e) {
    let selectedVal = parseInt(e.target.value, 10);
    this.setState({ selectedBpId2: selectedVal });

    GetAvailableTemplatesByBp2(selectedVal);
  }

  editSelectedChangeBpTemplate(e) {
    let selectedVal = parseInt(e.target.value, 10);
    this.setState({ selectedChangeBpTemplate: selectedVal });

    //GetAvailableTemplatesByBp2(selectedVal);
  }

  onBPChange() {
    let lastChange = BPStore.getLastChange();
    if (lastChange === actionTypes.BPGetList) {
      let bps = BPStore.getBPList();
      this.setState({
        availableBps: bps,
      });
    }
  }

  onChangeTemplateSearchText2(e) {
    this.setState({ templateSearchText2: e.target.value });
    this.filterTemplates2(e.target.value);
  }

  filterTemplates2(searchText) {
    if (searchText === '') {
      this.setState({
        filteredTemplates2: [...this.state.availableTemplates2],
      });
    } else {
      let newList = [];
      this.state.availableTemplates2.forEach((temp) => {
        if (
          temp.templateName.toLowerCase().includes(searchText.toLowerCase())
        ) {
          newList.push(temp);
        }
      });
      this.setState({ filteredTemplates2: newList });
      if (newList.length > 0) {
        this.setState({ suggestedTemplateId2: newList[0] });
      }
    }
  }

  onClickTemplateSearch2() {
    if (this.state.selectedTemplate2.templateId > 0) {
      this.setState({
        selectedTemplate2: {
          templateId: -1,
          templateName: 'Template...',
        },
        templateSearchText2: '',
      });
      this.filterTemplates2('');
    }
  }

  templateSuggestionClick2(tempOption) {
    this.setState({
      selectedTemplate2: tempOption,
      templateSearchText2: tempOption.templateName,
    });
  }

  getTableWidth() {
    let defs = this.state.currentFieldSet.fieldDefs;
    if (defs === undefined) return 0;
    let w = 160;
    defs.forEach((d) => {
      w += d.colWidth;
    });
    return w;
  }

  // Returns the active sort { rowSortField, rowSortDir } for the currently displayed
  // FieldSet, defaulting to no sort if none has been set yet.
  getCurrentSort() {
    const sort = this.state.fieldSetSortState[this.state.currentFieldSet.fieldSetId];
    return sort ?? { rowSortField: null, rowSortDir: 'asc' };
  }

  // Called when a column header cell is clicked. Toggles asc/desc if the same column is clicked again
  // otherwise switches to the new column starting asc.
  // Sort is stored per FieldSet so navigating between FieldSets preserves each one's sort.
  onClickRowColumnHeader(fieldId) {
    const { rowSortField, rowSortDir } = this.getCurrentSort();
    const fsId = this.state.currentFieldSet.fieldSetId;
    const newDir = rowSortField === fieldId
      ? (rowSortDir === 'asc' ? 'desc' : 'asc')
      : 'asc';
    this.setState((prev) => ({
      fieldSetSortState: {
        ...prev.fieldSetSortState,
        [fsId]: { rowSortField: fieldId, rowSortDir: newDir },
      },
    }));
  }

  // Called by the line-ID sort button next to the tools icon.
  // If a custom sort is active, resets to natural (DB) order.
  // If already in natural order, sorts descending by row ID.
  onClickSortByRowId() {
    const { rowSortField } = this.getCurrentSort();
    const fsId = this.state.currentFieldSet.fieldSetId;
    const newSort = rowSortField === null
      ? { rowSortField: 'rowId', rowSortDir: 'desc' }
      : { rowSortField: null, rowSortDir: 'asc' };
    this.setState((prev) => ({
      fieldSetSortState: { ...prev.fieldSetSortState, [fsId]: newSort },
    }));
  }

  getSortedRows() {
    // Returns a sorted copy of rowData for display purposes only.
    // rowData itself is never modified, so save operations and DB order are unaffected.
    // Sort state persists per FieldSet when navigating between them,
    // but resets to natural order on page reload.
    const { rowData } = this.state;
    const { rowSortField, rowSortDir } = this.getCurrentSort();

    // Unsaved new row (isNew) is always pinned to the bottom of the list,
    // regardless of the active sort. Separate it before sorting.
    const newRows = rowData.filter((r) => r.isNew);

    // If no sort is active, return rowData as-is (natural DB order).
    if (!rowSortField) return rowData;

    const sortableRows = rowData.filter((r) => !r.isNew);
    const sorted = [...sortableRows].sort((a, b) => {
      // first attempt to sort rows by row id, if sorting by rows
      if (rowSortField === 'rowId') {
        return rowSortDir === 'asc' ? a.rowId - b.rowId : b.rowId - a.rowId;
      }

      // get cols and vals
      const aCol = a.fieldData.find((f) => f.fieldId === rowSortField);
      const bCol = b.fieldData.find((f) => f.fieldId === rowSortField);
      const aVal = aCol ? (aCol.fieldValue ?? '') : '';
      const bVal = bCol ? (bCol.fieldValue ?? '') : '';

      // Attempt numeric comparison first so that values like "10" sort after "9"
      const aNum = parseFloat(aVal);
      const bNum = parseFloat(bVal);
      if (!isNaN(aNum) && !isNaN(bNum)) {
        return rowSortDir === 'asc' ? aNum - bNum : bNum - aNum;
      }

      // string comparison for text fields if not numberic
      const cmp = String(aVal).localeCompare(String(bVal));
      return rowSortDir === 'asc' ? cmp : -cmp;
    });

    // Re-append the pinned new rows at the end after sorting
    return [...sorted, ...newRows];
  }

  emailPDF() {
    let doc = this.state.currentDoc;
    let defaultSubject = `Please see the attached TrinDocs document, TrinDocs ID # ${doc.documentId.toString()}`;
    this.setState({
      showEmailPDF: true,
      emailTo: '',
      emailSubject: defaultSubject,
      emailMessage: '',
    });
  }

  moveBpDocsClick() {
    var selectedDocs = [];

    selectedDocs.push(this.state.currentDocId);
    ChangeBusinessProcesses(
      selectedDocs,
      this.state.selectedChangeBpTemplate,
      this.state.applyTemplate2,
      this.state.selectedBpId2
    );
    this.setState({ showChangeBusinessProcess: false });
  }

  cancelEmailPDF() {
    this.setState({ showEmailPDF: false });
  }

  onEditEmailTo(e) {
    this.setState({ emailTo: e.target.value });
  }

  onEditEmailSubject(e) {
    this.setState({ emailSubject: e.target.value });
  }

  onEditEmailMessage(e) {
    this.setState({ emailMessage: e.target.value });
  }

  validateAndSendEmail() {
    let emailAddress = this.state.emailTo;
    if (/^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,6})+/.test(emailAddress)) {
      SendEmail(
        this.state.emailTo,
        this.state.emailSubject,
        this.state.emailMessage,
        this.state.currentDoc.documentId
      );
      this.setState({ showEmailPDF: false });
    } else {
    }
  }

  inpsectTemplate() {
    RequestNav('Template Editor', 'inspectTempLink');
  }

  goToActiveDocs() {
    let link = document.getElementById('actdocLink');
    link.click();
  }

  toggleShowErrorMessage() {
    this.setState({ showErrorMessage: false });
  }

  clearCellError(rowId, colId)
  {
    let fs1 = this.state.currentFieldSet;
    let doc = this.state.currentDoc;
    let fs2 = doc.fieldSets.find((fs) => fs.fieldSetId === fs1.fieldSetId);

    // find row
    let r = parseInt(rowId, 10);
    let c = parseInt(colId, 10);
    let row = fs2.rows.find((rw) => rw.rowId === r);

    let col = row.fieldData.find((fd) => fd.fieldId === c);
    col.error = '';
    //this.errorRowField(fs1.fieldSetId, r, c);
  }

  setCellError(rowId, colId, errorMsg) {

    let fs1 = this.state.currentFieldSet;
    let doc = this.state.currentDoc;
    let fs2 = doc.fieldSets.find((fs) => fs.fieldSetId === fs1.fieldSetId);

    // find row
    let r = parseInt(rowId, 10);
    let c = parseInt(colId, 10);
    let row = fs2.rows.find((rw) => rw.rowId === r);
    console.log(row);
    console.log(c);
    let col = row.fieldData.find((fd) => fd.fieldId === c);
    console.log(col);
    col.error = errorMsg;
    this.errorRowField(fs1.fieldSetId, r, c);
  }

  clearChildCells(row, cell) {}

  toggleShowAlert()
  {
    let alert = this.state.showAlert;
    this.setState({showAlert: !alert});
    if(this.state.alertNextOnClose)
    {
      this.loadDocumentFromDB();
    }
  }

  setAuditTab(tab)
  {
    this.setState({currentAuditView: tab});
  }

  undeleteDocument() {
    UndeleteDocument(this.state.currentDocId);
  }

  onMagicScroll() {
    if (useMagic) {
      let magic = document.getElementById('magicScroll');
      let main = document.getElementById('mainRowGrid');
      main.scrollTop =
        (magic.scrollTop * main.scrollHeight) / magic.scrollHeight;
    } else {
      useMagic = true;
    }
  }

  onMainScroll(e) {
    let main = document.getElementById('mainRowGrid');
    let magic = document.getElementById('magicScroll');

    let top = main.scrollTop + e.deltaY;
    if (top < 0) top = 0;
    if (top > main.scrollHeight) top = main.scrollHeight;

    magic.scrollTop = top;

    useMagic = false;
  }



  analyzeTemplate(e) {
    if(e.ctrlKey) {
      window.open('/TemplateEditor/'+ this.state.currentDoc.templateId + '/' + this.state.currentDoc.documentId);
    } else {
      let returnPath = window.location.pathname + window.location.search;
      localStorage.setItem('docReturn', returnPath);
      RequestNav('Template Editor', 'inspectTempLink');
      //docLink.click();
      // this.setState({ goToDocId: docId }, () => {
      //   let docLink = document.getElementById('docLink');
      //   docLink.click();
      // });
    }
  }

  expandView(fieldText, displayName) {
    this.setState({showExpandedView: true, expandedViewText: fieldText, expandedViewTitle: displayName})
  }

  showIntegrationAlertPopup() {
    this.setState({showIntegrationAlert: true})
  }

  adknowledgeIntegrationAlert()
  {
    ReadIntegrationAlerts(this.state.currentDoc.documentId);
  }

  hideIntegrationAlert()
  {
    this.setState({showIntegrationAlert: false});
  }

  hideExpandedView()
  {
    this.setState({showExpandedView: false});
  }

  toggleAuditVars(e, auditArg)
  {
    console.log(e);
    console.log(auditArg);
    if(auditArg === 'views')
      {
        this.setState({showAuditViews: e.target.checked})
      }
    if(auditArg === 'userNotes')
      {
        this.setState({showAuditUserNotes: e.target.checked})
      }
    if(auditArg === 'systemNotes')
      {
        this.setState({showAuditSystemNotes: e.target.checked})
      }
    if(auditArg === 'system')
      {
        this.setState({showAuditSystemActivity: e.target.checked})
      }

  }

  createTemplate() {
    console.log('createTemplate');
    this.setState({showCreateTemplate: true, newTemplateError: ''}, () => {
      let inp = document.getElementById('createTemplateName');
      if(inp)
      {
        inp.focus();
      }

    });
  }

  createTemplate2(e) {
    console.log('createTemplate2');
    if(e.ctrlKey)
    {
      console.log('Tab');
      this.setState({newTemplateLink: 'TAB'});
    } else {
      console.log('Direct');
      this.setState({newTemplateLink: 'DIRECT'});
    }

    CreateTemplateForDocument(this.state.currentDoc.documentId, this.state.newTemplateName);
  }

  hideCreateTemplate()
  {
    this.setState({showCreateTemplate: false});
  }

  editNewTemplateName(e)
  {

    this.setState({newTemplateName: e.target.value});
  }

  downloadAuditClick()
  {
    let auditQuery = {
      documentId: this.state.currentDoc.documentId,
      showUserActivity: false,
      showUserViews: false,
      showUserNotes: false,
      showIntgActivity: false,
      showSystemNotes: false,
      showWorkflowActivity: false,
    }
    if(this.state.currentAuditView === 'full' || this.state.currentAuditView === 'user')
    {
      auditQuery.showUserActivity = true;
    }
    if(this.state.currentAuditView === 'full' || this.state.currentAuditView === 'auto')
    {
      auditQuery.showIntgActivity = true;
    }
    if(this.state.showAuditViews) auditQuery.showUserViews = true;
    if(this.state.showAuditUserNotes) auditQuery.showUserNotes = true;
    if(this.state.showAuditSystemNotes && this.state.currentAuditView !== 'user') auditQuery.showSystemNotes = true;
    if(this.state.showAuditSystemActivity) auditQuery.showWorkflowActivity = true;


    DownloadDocAudit(auditQuery);
    console.log('Audit Download');
  }

  render() {
    const { rowSortField, rowSortDir } = this.getCurrentSort();
    return (
      <div
        id='tdDocEditor' // full document editor
        className='container-fluid d-flex flex-column'
        style={{ height: '100%', padding: '0px' }}
        onClick={this.handleDocumentClick}
        onMouseMove={this.onMouseMove}
        onMouseUp={this.onMouseUp}

      >

        {this.state.isLoading && (
          <div className='de-loadingScreen'>
            <div style={{ marginRight: '8px' }}>
              <i className='fa-solid fa-spinner fa-2x fa-spin' />
            </div>
            <h4>Loading Document</h4>
          </div>
        )}
        {this.state.isRunningPlugin && (
          <div className='de-runningScreen'>
            <div style={{ marginRight: '8px' }}>
              <i className='fa-solid fa-spinner fa-2x fa-spin' />
            </div>
            <h4>Running Plugin</h4>
          </div>
        )}
        <Prompt isDirty={this.state.snapshots.length > 1} />
        {this.state.currentDoc !== undefined &&
          (this.state.currentDoc.hasRelatedDocs ||
            this.state.currentDoc.originalDocId !== 0) && (
            <div //Related Files
              id="relatedDocsBar"
              style={{
                backgroundColor: '#E9E9E9',

                borderBottom: 'solid 1px #B2BABB',
                borderTop: 'solid 1px #B2BABB',
              }}
            >

              <Link
                id='originalDocLink'
                to={'/Document/' + this.state.currentDoc.originalDocId}
                style={{ display: 'none' }}
              ></Link>

              <ul
                className='relatedDocsList'
                style={{ width: window.innerWidth }}
              >
                <li
                  className={
                    this.state.currentDoc.originalDocId === 0
                      ? 'relatedHeader'
                      : 'relatedLabel'
                  }
                  onClick={(e) => this.onBackToOriginalDoc()}
                >
                  {/* className='relatedHeader' */}
                  Document:
                  {this.state.currentDoc.originalDocId !== 0 && (
                    <span>{this.state.currentDoc.originalDocId}</span>
                  )}
                  {this.state.currentDoc.originalDocId === 0 && (
                    <span>{this.state.currentDoc.documentId}</span>
                  )}
                </li>

                <li className='relatedLabel'>Related{':'}</li>

                {this.state.currentDoc.relatedDocuments.map((relatedDoc) => (
                  <li
                    key={relatedDoc.documentId}
                    className={
                      this.state.currentDoc.documentId === relatedDoc.documentId
                        ? 'relatedHeader'
                        : 'relatedLabel'
                    }
                    onMouseEnter={(e) => this.onRelatedMouseIn(e, relatedDoc)}
                    onMouseLeave={this.onRelatedMouseOut}
                    onClick={(e) => this.onRelatedClick(e, relatedDoc)}
                  >
                    <Link
                      id={'relatedDocLink' + relatedDoc.documentId}
                      to={
                        this.state.currentDoc.originalDocId === 0
                          ? '/Document/' +
                            this.state.currentDocId +
                            '?related=' +
                            relatedDoc.documentId
                          : '/Document/' +
                            this.state.currentDoc.originalDocId +
                            '?related=' +
                            relatedDoc.documentId
                      }
                      style={{ display: 'none' }}
                    ></Link>
                    {/* className='relatedLink' */}
                    {relatedDoc.documentId}
                  </li>
                ))}
              </ul>
            </div>
          )}
        <div //menu bar
          className='d-flex flex-wrap justify-content-between'
          style={{
            width: '100%',
            backgroundColor: '#E9E9E9',
            borderBottom: 'solid 1px #B2BABB',
            borderTop: 'solid 1px #B2BABB',
          }}
          id='tdDocumentMenu'
        >
          <div>
            <Link id='backLink' to={this.state.returnUrl} />
            <ActionButton
              iconClass='thumbs-up'
              iconColor='#38C158'
              toolTip='Approve'
              isDisabled={
                !this.state.userCanSubmit ||
                this.state.isSaving ||
                //this.state.fieldsHaveError ||
                this.state.isSubmitting ||
                this.state.isLoading
              }
              waiting={this.state.isSubmitting}
              showBadge={false}
              badgeValue=''
              onClick={this.handleApproveClick}
            />
            <ActionButton
              iconClass='thumbs-down'
              iconColor='#DF3E3E'
              toolTip='Reject'
              isDisabled={
                !this.state.userCanSubmit ||
                this.state.isSaving ||
                //this.state.fieldsHaveError ||
                this.state.isSubmitting ||
                this.state.isLoading
              }
              waiting={this.state.isSubmitting}
              showBadge={false}
              badgeValue=''
              onClick={this.handleRejectClick}
            />
            <ActionButton
              iconClass={this.state.isSaving ? 'saving' : 'save'}
              iconColor='#138D75'
              toolTip='Save'
              isDisabled={
                this.state.isSaving ||
                ((this.state.fieldsHaveError ||
                  this.state.snapshots.length === 1 ||
                  !this.state.userCanEdit) &&
                  //!this.state.userCanMoveAssign &&
                  !this.state.queuesDirty)
              }
              showBadge={false}
              badgeValue=''
              onClick={this.handleSaveClick}
            />
            <ActionButton
              iconClass='undo'
              iconColor='#8D78EE'
              toolTip='Undo'
              isDisabled={
                this.state.snapshots.length === 1 || this.state.isSaving
              }
              showBadge={false}
              badgeValue=''
              onClick={this.undoLatestChange}
            />
            <ActionButton
              iconClass='arrow-left'
              iconColor='#2172D3'
              toolTip='Get Previous Document'
              isDisabled={false}
              showBadge={false}
              badgeValue=''
              onClick={this.handlePreviousClick}
            />
            <ActionButton
              iconClass='arrow-right'
              iconColor='#2172D3'
              toolTip='Get Next Document'
              isDisabled={false}
              showBadge={false}
              badgeValue=''
              onClick={() => this.handleNextClick(false)}
            />

            <div className='dropdown float-start'>
              <ActionButton
                iconClass='paperclip'
                iconColor='#4B4B4B'
                toolTip='Attachments'
                isDisabled={!this.state.userCanAddNotes || this.state.isSaving}
                showBadge={true}
                badgeValue={this.state.attachmentCount.toString()}
                onClick={this.handleAttachmentClick}
              />
              {this.state.showAttachmentMenu && (
                <div className='dropdown-content'>
                  <div>
                    <strong>Attachments</strong>
                  </div>

                  {this.state.currentDoc.attachments.map((attch) => (
                    <div
                      className='attchMenu-attachment'
                      key={attch.attachmentId}
                    >
                      <div className='attchMenu-filename'>
                        <i className='fa-regular fa-file-alt' />{' '}
                        {attch.originalFileName}
                      </div>
                      <div className='attchMenu-attachBy'>
                        Attached by: {attch.uploadBy}
                      </div>
                      <div className='attchMenu-downloadDelete'>
                        <span
                          style={{
                            color: '#198754',
                            cursor: 'pointer',
                            marginRight: '8px',
                          }}
                          onClick={() =>
                            this.downloadAttachment(
                              attch.attachmentId,
                              attch.originalFileName
                            )
                          }
                        >
                          <i className='fa-solid fa-download' /> Download
                        </span>
                        {'   '}
                        <span
                          style={{ color: '#dc3545', cursor: 'pointer' }}
                          onClick={() =>
                            this.deleteAttachment(attch.attachmentId)
                          }
                        >
                          <i className='fa-solid fa-times' /> Delete
                        </span>
                      </div>
                    </div>
                  ))}
                  <hr />

                    <Dropzone
                    multiple={true}
                    onDrop={this.onDropAttachment}


                    >
                      {({ getRootProps, getInputProps }) => (
                        <div {...getRootProps({ className: '' })}>
                          <input {...getInputProps()} />
                          <div style={{margin: '0px', cursor: 'pointer'}}>
                            <i className='fa-solid fa-download' /> Upload new
                            Attachment
                          </div>
                        </div>)}
                    </Dropzone>

                </div>
              )}
            </div>
            <ActionButton
              iconClass='trash-alt'
              iconColor='#EC4B4B'
              toolTip='Delete Document'
              isDisabled={!this.state.userCanDelete}
              showBadge={false}
              badgeValue=''
              onClick={this.handleTrashClick}
            />

            <div className='dropdown float-start'>
              {/* Can download if user has permission to step and download permissions 
                  OR
                  has Search All Steps permission
                  
                  This is calculated on the document load backend and final result is returned in userCanDownload*/}
              <ActionButton
                iconClass='pdf'
                iconColor='#0DA6A6'
                toolTip='Download or Email PDF'
                isDisabled={!this.state.userCanDownload}
                showBadge={false}
                badgeValue=''
                onClick={this.handlePdfClick}
              />
              {this.state.showPdfMenu && (
                <div className='dropdown-content'>
                  <div
                    className='dropdown-menuitem'
                    onClick={this.downloadDocument}
                  >
                    <i
                      className='fa-solid fa-download'
                      style={{
                        color: '#38C158',
                        marginRight: '8px',
                      }}
                    />{' '}
                    Download PDF
                  </div>
                  {this.state.currentDoc.stampGroups.length > 0 && (
                    <div
                      className='dropdown-menuitem'
                      onClick={this.toggleStamps}
                    >
                      <i
                        className='fa-solid fa-download'
                        style={{
                          color: '#38C158',
                          marginRight: '8px',
                        }}
                      />{' '}
                      Download PDF with Stamps
                    </div>
                  )}
                  {this.state.currentDoc.attachments.length > 0 && (
                    <div className='dropdown-menuitem'
                        title='Download PDF and Attachments'
                        onClick={this.downloadDocumentAndAttachments}>
                      <i
                        className='fa-solid fa-download'
                        style={{
                          color: '#38C158',
                          marginRight: '8px',
                        }}
                      />{' '}
                      Download PDF and Attachments
                    </div>
                  )}
                  {this.state.currentDoc.relatedDocuments.length > 0 && (
                    <div
                      className='dropdown-menuitem'
                      onClick={this.downloadRelatedDocumentPacket}
                    >
                      <i
                        className='fa-solid fa-download'
                        style={{
                          color: '#38C158',
                          marginRight: '8px',
                        }}
                      />{' '}
                      Download related document packet
                    </div>
                  )}
                  <div className='dropdown-menuitem' onClick={this.emailPDF}>
                    <i
                      className='fa-solid fa-envelope'
                      style={{ marginRight: '8px' }}
                    />{' '}
                    E-Mail PDF
                  </div>
                </div>
              )}
            </div>

            <ActionButton
              iconClass='file'
              iconColor='#AE4BCF'
              toolTip='Send to image review'
              isDisabled={
                !this.state.userCanSendToReview || this.state.isSaving
              }
              showBadge={false}
              badgeValue=''
              onClick={this.handleImageRevClick}
            />

            {/* {this.state.currentDoc !== undefined && this.state.currentDoc.hasRuntimePlugin === true && (
                  <ActionButton
                    className='float-end mt-2'
                    style={{
                      padding: '7px 12px',
                      margin: '7px 0px 7px 7px',
                      fontSize: '14px',
                      backgroundColor: '#FFCF51',
                      color: 'black',
                      borderRadius: '12px',
                    }}
                    title='Execute runtime plugin'
                    onClick={this.executeRuntimePlugin}
                    isDisabled={
                      this.state.isSaving ||
                      this.state.snapshots.length > 1 ||
                      ((this.state.fieldsHaveError ||

                        !this.state.userCanEdit) &&
                        //!this.state.userCanMoveAssign &&
                        !this.state.queuesDirty)
                    }

                    iconClass={this.state.isSaving ? 'saving' : 'person-running'}
                    iconColor='#FFCF51'
                    forground= '#000'

                    toolTip={
                      (this.state.currentDoc.runtimePluginDescription !== undefined || this.state.currentDoc.runtimePluginDescription !== '')
                        ? this.state.currentDoc.runtimePluginDescription
                        : 'Execute runtime plugin'
                    }

                    showBadge={false}
                    badgeValue=''
                  />

                )} */}

            {this.state.currentDoc !== undefined && this.state.currentDoc.hasRuntimePlugin === true && (
              <div className='dropdown float-start'>
                  <ActionButton
                    className='float-end mt-2'
                    style={{
                      padding: '7px 12px',
                      margin: '7px 0px 7px 7px',
                      fontSize: '14px',
                      backgroundColor: '#FFCF51',
                      color: 'black',
                      borderRadius: '12px',
                    }}
                    title='Execute OnDemand plugin'
                    onClick={this.handleRuntimeMenuClick}
                    isDisabled={
                      this.state.isSaving ||
                      this.state.snapshots.length > 1 ||
                      ((this.state.fieldsHaveError ||

                        !this.state.userCanEdit) &&
                        //!this.state.userCanMoveAssign &&
                        !this.state.queuesDirty)
                    }

                    iconClass={this.state.isSaving ? 'saving' : 'play'}
                    iconColor='#ffc32dff'
                    forground= '#ffffffff'

                    toolTip={
                      (this.state.currentDoc.runtimePluginDescription !== undefined || this.state.currentDoc.runtimePluginDescription !== '')
                        ? this.state.currentDoc.runtimePluginDescription
                        : 'Execute runtime plugin'
                    }

                    showBadge={false}
                    badgeValue=''
                  />
                {this.state.showRuntimeMenu && (
                  <div className='dropdown-content'>
                    {this.state.currentDoc.onDemandPlugins.map((onDemandPlugin) => (
                        <div
                            className='dropdown-menuitem'
                            onClick={() => this.executeOnDemandPlugin(onDemandPlugin)}
                          >
                            {onDemandPlugin.icon === 'receipt' && (
                              <i
                                  className='fa-solid fa-receipt'
                                  style={{
                                    color: '#38C158',
                                    marginRight: '8px',
                                  }}
                                />
                            )}
                            {onDemandPlugin.icon === 'file-invoice-dollar' && (
                              <i
                                  className='fa-solid fa-file-invoice-dollar'
                                  style={{
                                    color: '#38C158',
                                    marginRight: '8px',
                                  }}
                                />
                            )}
                            {onDemandPlugin.icon === 'play' && (
                              <i
                                  className='fa-solid fa-play'
                                  style={{
                                    color: '#38C158',
                                    marginRight: '8px',
                                  }}
                                />
                            )}
                            {onDemandPlugin.icon === 'repeat' && (
                              <i
                                  className='fa-solid fa-repeat'
                                  style={{
                                    color: '#38C158',
                                    marginRight: '8px',
                                  }}
                                />
                            )}
                            {onDemandPlugin.icon === 'rotate-left' && (
                              <i
                                  className='fa-solid fa-rotate-left'
                                  style={{
                                    color: '#38C158',
                                    marginRight: '8px',
                                  }}
                                />
                            )}
                            {onDemandPlugin.icon === 'clone' && (
                              <i
                                  className='fa-solid fa-clone'
                                  style={{
                                    color: '#38C158',
                                    marginRight: '8px',
                                  }}
                                />
                            )}
                            {onDemandPlugin.icon === 'dollar-sign' && (
                              <i
                                  className='fa-solid fa-dollar-sign'
                                  style={{
                                    color: '#38C158',
                                    marginRight: '8px',
                                  }}
                                />
                            )}
                            {onDemandPlugin.icon === 'money-bills' && (
                              <i
                                  className='fa-solid fa-money-bills'
                                  style={{
                                    color: '#38C158',
                                    marginRight: '8px',
                                  }}
                                />
                            )}
                            {onDemandPlugin.icon === 'money-check-dollar' && (
                              <i
                                  className='fa-solid fa-money-check-dollar'
                                  style={{
                                    color: '#38C158',
                                    marginRight: '8px',
                                  }}
                                />
                            )}
                            {onDemandPlugin.icon === 'money-bill-transfer' && (
                              <i
                                  className='fa-solid fa-money-bill-transfer'
                                  style={{
                                    color: '#38C158',
                                    marginRight: '8px',
                                  }}
                                />
                            )}
                            {onDemandPlugin.icon === 'square-check' && (
                              <i
                                  className='fa-solid fa-square-check'
                                  style={{
                                    color: '#38C158',
                                    marginRight: '8px',
                                  }}
                                />
                            )}
                            {onDemandPlugin.icon === 'user-check' && (
                              <i
                                  className='fa-solid fa-user-check'
                                  style={{
                                    color: '#38C158',
                                    marginRight: '8px',
                                  }}
                                />
                            )}
                            {onDemandPlugin.icon === 'file-circle-check' && (
                              <i
                                  className='fa-solid fa-file-circle-check'
                                  style={{
                                    color: '#38C158',
                                    marginRight: '8px',
                                  }}
                                />
                            )}

                            {' '}
                            {onDemandPlugin.pluginName}
                      </div>
                    ))}


                  </div>
                )}
              </div>
            )}

            {this.state.currentDoc !== undefined && (
              <div className='dropdown float-start'>
                  <ActionButton
                    className='float-end mt-2'
                    style={{
                      padding: '7px 12px',
                      margin: '7px 0px 7px 7px',
                      fontSize: '14px',
                      backgroundColor: '#171c3a',
                      color: 'black',
                      borderRadius: '12px',
                    }}
                    title='Send to AI Capture'
                    onClick={this.onClickSendToAICapture}
                    isDisabled={
                      this.state.isSaving ||
                      this.state.snapshots.length > 1 ||
                      this.state.currentDoc.canUseAICapture !== true ||
                      ((this.state.fieldsHaveError ||

                        !this.state.userCanMoveAssign) &&
                        //!this.state.userCanMoveAssign &&
                        !this.state.queuesDirty)
                    }

                    iconClass={this.state.isSaving ? 'saving' : 'microchip-ai'}
                    iconColor='#ff009d'
                    forground= 'white'
                    toolTip={'Send to AI Capture'}
                    showBadge={false}
                    badgeValue=''
                  />
   
              </div>
            )}

            {this.state.currentDoc !== undefined && this.state.currentDoc.trinFormsId !== null && (
              <div className='dropdown float-start'>
                <a
                  id='trinFormsLink'
                  style={{ display: 'none' }}
                  href={this.state.trinFormsBaseUrl + '/Form/View/' + this.state.currentDoc.trinFormsId}
                  //href={this.state.trinFormsCompleteUrl}
                  //target='_blank'
                ></a>
                  <ActionButton
                    className='float-end mt-2'
                    style={{
                      padding: '7px 12px',
                      margin: '7px 0px 7px 7px',
                      fontSize: '14px',
                      backgroundColor: '#FFCF51',
                      color: 'black',
                      borderRadius: '12px',
                    }}
                    title='Execute OnDemand plugin'
                    onClick={this.routeToTrinFormsClick}

                    isDisabled={this.state.trinFormsBaseUrl === "" ? true : false }

                    toolTip='Go to this Form in TrinForms'

                    iconClass={this.state.isSaving ? 'saving' : 'link'}
                    iconColor='#3cb4c2'
                    forground= '#000'
                  />

              </div>
            )}

            {this.state.currentDoc !== undefined &&
              this.state.currentDoc.showStamps && (
                <div className='dropdown float-start'>
                  <button
                    className='btn float-start'
                    style={{
                      marginTop: '6px',
                      marginBottom: '6px',
                      position: 'relative',
                      marginLeft: '6px',
                      backgroundColor: '#DC754B',
                      color: '#FFF',
                    }}
                    title='Stamps'
                    disabled={this.state.hasStamps}
                    onClick={this.handleStampClick}
                  >
                    <i className='fa-solid fa-stamp' />{' '}
                    {this.state.currentDoc !== undefined && (
                      <>
                        {this.state.currentDoc.stampGroups.map((sg) => (
                          <span
                            className='badge rounded-pill bg-secondary'
                            key={sg.groupName}
                          >
                            {sg.groupStatus === 'APPROVED' && (
                              <i
                                className='fa-solid fa-check-circle'
                                style={{ color: '#4EF63A' }}
                              />
                            )}
                            {sg.groupStatus === 'REJECTED' && (
                              <i className='fa-solid fa-times-circle' />
                            )}
                            {sg.groupStatus === 'PENDING' && (
                              <i className='fa-solid fa-minus-circle' />
                            )}{' '}
                            {sg.stamps.length}
                          </span>
                        ))}
                      </>
                    )}
                  </button>

                  {this.state.showStampMenu && (
                    <div
                      className='dropdown-content'
                      style={{ width: '330px' }}
                    >
                      {this.state.currentDoc.stampGroups.map((sgroup) => (
                        <div className='stampMenu-stamp' key={sgroup.groupName}>
                          <div className='stampMenu-groupName'>
                            <i className='fa-solid fa-stamp' />{' '}
                            {sgroup.groupName}
                          </div>
                          {sgroup.stamps.map((stamp) => (
                            <div
                              key={stamp.userName}
                              className={
                                stamp.stampType === 'APPROVE'
                                  ? 'stampMenu-stampLineApprove'
                                  : stamp.stampType === 'REJECT'
                                  ? 'stampMenu-stampLineReject'
                                  : 'stampMenu-stampLinePending'
                              }
                            >
                              {stamp.stampType === 'APPROVE' && (
                                <i className='fa-solid fa-thumbs-up' />
                              )}
                              {stamp.stampType === 'REJECT' && (
                                <i className='fa-solid fa-thumbs-down' />
                              )}
                              {stamp.stampType === 'PENDING' && (
                                <i className='fa-solid fa-minus-circle' />
                              )}{' '}
                              {stamp.userName} -{' '}
                              {stamp.stampTime !== null &&
                                this.convertDate2(stamp.stampTime)}
                              {stamp.stampTime === null && <span>Pending</span>}
                            </div>
                          ))}
                        </div>
                      ))}
                    </div>
                  )}
                </div>
              )}
            {this.state.currentDoc &&
              this.state.currentDoc.queueAssignments.map((queue) => (
                <div
                  key={queue.userId}
                  className={`float-start mt-2
                           ${
                             queue.assignStatus === 'PENDING'
                               ? 'queueAssignOther'
                               : ''
                           }
                           ${
                             queue.assignStatus === 'APPROVED'
                               ? 'queueAssignApproved'
                               : ''
                           }
                           ${
                             queue.assignStatus === 'NEW'
                               ? 'queueAssignNew'
                               : ''
                           }
                           ${
                             queue.assignStatus === 'DELETE'
                               ? 'queueAssignDelete'
                               : ''
                           }
                           ${queue.assignStatus === 'ME' ? 'queueAssignMe' : ''}
                        `}
                >
                  {' '}
                  {queue.assignStatus !== 'APPROVED' && (
                    <i className='fa-solid fa-user' />
                  )}
                  {queue.assignStatus === 'APPROVED' && (
                    <i
                      className='fa-solid fa-check'
                      style={{ color: '#20B219' }}
                    />
                  )}{' '}
                  {queue.userName}{' '}
                  {queue.canUnassign && (
                    <i
                      style={{ cursor: 'pointer' }}
                      onClick={() => this.removeAssignment(queue.userId)}
                      className='fa-solid fa-times'
                    />
                  )}
                </div>
              ))}
            {this.state.currentDoc &&
              (this.state.currentDoc.canAssign ||
                this.state.currentDoc.licenseLevel > 3) && (
                <div
                  id='docContainerAssignUserText'
                  className='float-start autocomplete2'
                >
                  <input
                    type='text'
                    style={{ margin: '7px 0px 7px 7px' }}
                    className='form-control'
                    placeholder='Assign User...'
                    onFocus={this.editAssignUser}
                    value={this.state.userSearch}
                    onBlur={this.assignUserBlur}
                    onChange={this.editAssignUser}
                  ></input>
                </div>
              )}
          </div>

          <div>
            <div className='dropdown float-end'>
              <button
                id='documentButton'
                className='btn btn-primary'
                style={{ margin: '7px 10px 7px 7px' }}
                onClick={this.toggleDocMenu}
              >
                Document: {this.state.documentID}{' '}
                <i className='fa-solid fa-caret-down' />
              </button>
              {this.state.showDocumentMenu && (
                <div className='document-menu-dropdown'>
                  <div className='row'>
                    <div
                      className='col-6'
                      style={{ borderRight: 'solid 1px #BBBBBB' }}
                    >
                      <div className='docMenu-heading-1'>Form Type</div>
                      <div className='docMenu-value-1'>
                        {this.state.currentDoc.formTypeName}
                      </div>
                      <hr />
                      <div className='docMenu-heading-1'>Template</div>
                      <div className='docMenu-value-1'>
                        {this.state.currentDoc !== undefined &&
                          this.state.currentDoc.templateName}
                      </div>
                      <hr />
                      <div className='docMenu-heading-1'>Workflow</div>
                      <div className='docMenu-value-1'>
                        {this.state.workflowName}
                      </div>
                      <hr />
                      <div className='docMenu-heading-1'>Step</div>
                      <div className='docMenu-value-1'>
                        {this.state.stepName}
                      </div>
                      <hr />
                      <div className='docMenu-heading-1'>Checked out by</div>
                      <div className='docMenu-value-1'>
                        {this.state.currentDoc !== undefined &&
                          this.state.currentDoc.checkedOutUser}
                      </div>
                    </div>
                    <div className='col-6'>
                      <div className='docMenu-heading-1'>Info</div>
                      <div
                        className='docMenu-menuItem'
                        onClick={this.toggleShowAudit}
                      >
                        <i className='fa-solid fa-shield-alt' /> Audit
                        Trail
                      </div>
                      <div
                        className='docMenu-menuItem'
                        onClick={this.toggleProperties}
                      >
                        <i className='fa-regular fa-file-alt' />{' '}
                        Properties
                      </div>
                      {/* ML OCR Commented out */}
                      <div
                        className='docMenu-menuItem'
                        onClick={this.loadIntakeLogs}
                      >
                        <i className='fa-regular fa-book' />{' '}
                        Intake Logs
                      </div>
                      {this.state.userCanMoveAssign && (
                        <div>
                          <div className='docMenu-heading-1'>Edit</div>
                          <div
                            className='docMenu-menuItem'
                            onClick={this.toggleShowMoveAssign}
                          >
                            <i className='fa-regular fa-file-alt' /> Move
                            &amp; Assign
                          </div>
                          <div
                            className='docMenu-menuItem'
                            onClick={this.toggleChangeBusinessProcess}
                          >
                            <i className='fa-solid fa-shield-alt' />{' '}
                            Change Business Process
                          </div>
                          <div
                            className='docMenu-menuItem'
                            onClick={this.toggleTemplateChange}
                          >
                            <i className='fa-regular fa-file-alt' />{' '}
                            Change Read Settings
                          </div>
                          {this.state.currentDoc !== undefined &&
                          this.state.currentDoc.templateName !== 'None' && this.state.currentDoc.templateName !== 'No Template' &&
                          <div
                            className='docMenu-menuItem'
                            onClick={(e) => this.analyzeTemplate(e)}
                          >
                            <i className='fa-solid fa-puzzle-piece' />{' '}
                            Analyze Template
                          </div>
                          }
                          {this.state.currentDoc !== undefined &&
                          (this.state.currentDoc.templateName === 'None' || this.state.currentDoc.templateName === 'No Template') &&
                          <div
                            className='docMenu-menuItem'
                            onClick={(e) => this.createTemplate(e)}
                          >
                            <i className='fa-solid fa-puzzle-piece' />{' '}
                            Create Template
                          </div>
                          }
                          {/*{this.state.currentDoc.templateName !== 'None' && (
                            <div
                              className='docMenu-menuItem'
                              onClick={this.inpsectTemplate}
                            >
                              <i className='fa-regular fa-file-alt' />{' '}
                              Inspect Template
                            </div>
                          )}
                          <div
                            className='docMenu-menuItem'
                            onClick={this.createTempFromDoc}
                          >
                            <i className='fa-regular fa-file-alt' />{' '}
                            Create Template from Document
                          </div>*/}
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              )}
            </div>
            <button
              className='btn float-end '
              style={{
                margin: '7px 0px 7px 7px',
                position: 'relative',
                marginLeft: '6px',
                backgroundColor: '#4C969B',
                color: '#FFF',
              }}
              onClick={this.toggleUserNotes}
              title='User Notes'
            >
              <i className='fa-regular fa-file-alt' />{' '}
              {this.state.currentDoc !== undefined &&
                this.state.currentDoc.userNotes.length > 0 && (
                  <span
                    className='badge rounded-pill'
                    style={{ color: '#000', backgroundColor: '#81CBD0' }}
                  >
                    {this.state.currentDoc.userNotes.length}
                  </span>
                )}
            </button>
            <div className='dropdown float-end'>
              {this.state.currentDoc !== undefined &&
                this.state.currentDoc.checkedOutStatus === 'Integration-Ready' &&
                   (
                  <div
                    className='float-end mt-2'
                    style={{
                      padding: '7px 12px',
                      margin: '7px 0px 7px 7px',
                      fontSize: '14px',
                      backgroundColor: '#909090',
                      color: '#E3E3E3',
                      borderRadius: '12px',
                    }}
                    title='Automated step'
                  >
                    <i className='fa-solid fa-gear' />
                  </div>
                )}
              {this.state.lockedByMe && (
                <div
                  className='float-end mt-2'
                  style={{
                    padding: '7px 12px',
                    margin: '7px 0px 7px 7px',
                    fontSize: '14px',
                    backgroundColor: '#27AE60',
                    color: '#FFF',
                    borderRadius: '12px',
                  }}
                  title='Locked by me'
                >
                  <i className='fa-solid fa-lock' />
                </div>
              )}
              {this.state.currentDoc !== undefined &&
                this.state.currentDoc.checkedOutStatus === 'Deleted' && (
                  <div
                    className='float-end mt-2'
                    style={{
                      padding: '7px 12px',
                      margin: '7px 0px 7px 7px',
                      fontSize: '13px',
                      backgroundColor: 'rgb(236, 75, 75)',
                      color: '#fff',
                      borderRadius: '12px',
                      cursor: 'pointer',
                    }}
                    onClick={this.toggleSnagMenu}
                  >
                    <i className='fa-solid fa-trash' /> Deleted{' '}
                  </div>
                )}
              {this.state.lockedByOther && (
                <div
                  className='float-end mt-2'
                  style={{
                    padding: '7px 12px',
                    margin: '7px 0px 7px 7px',
                    fontSize: '13px',
                    backgroundColor: '#F1C40F',
                    color: '#212F3D',
                    borderRadius: '12px',
                    cursor: 'pointer',
                  }}
                  onClick={this.toggleSnagMenu}
                >
                  <i className='fa-solid fa-user-lock' />{' '}
                  {this.state.checkedOutBy}{' '}
                </div>
              )}
              {this.state.currentDoc !== undefined &&
                this.state.currentDoc !== null &&
                this.state.currentDoc.checkedOutStatus === 'ImageReview' && (
                  <div
                    className='float-end'
                    style={{
                      padding: '7px 12px',
                      margin: '7px 0px 7px 7px',
                      fontSize: '12px',
                      backgroundColor: '#AE4BCF',
                      color: '#FFF',
                      borderRadius: '12px',
                      cursor: 'pointer',
                    }}
                  >
                    <i className='fa-solid fa-lock' /> Image Review{' '}
                  </div>
                )}
              {this.state.currentDoc !== undefined &&
                this.state.currentDoc !== null &&
                this.state.currentDoc.checkedOutStatus === 'Queue' && (
                  <div
                    className='float-end'
                    style={{
                      padding: '7px 12px',
                      margin: '9px 2px 7px 7px',
                      fontSize: '13px',
                      backgroundColor: '#42B3C1',
                      color: '#FFF',
                      borderRadius: '12px',
                      cursor: 'pointer',
                    }}
                  >
                    <i className='fa-solid fa-list-check' />{' '}
                  </div>
                )}
              {this.state.showSnagMenu && (
                <div className='dropdown-content'>
                  {this.state.lockedByOther && <div
                    className='dropdown-menuitem'
                    onClick={this.pullDocFromUser}
                  >
                    <i
                      style={{
                        color: '#196F3D',
                        marginRight: '8px',
                      }}
                      className='fa-solid fa-unlock-alt'
                    />
                    Pull from {this.state.checkedOutBy}
                  </div>}
                  { this.state.currentDoc.checkedOutStatus === 'Deleted' &&
                  <div
                    className='dropdown-menuitem'
                    onClick={this.undeleteDocument}
                  >
                    <i
                      style={{
                        color: '#196F3D',
                        marginRight: '8px',
                      }}
                      className='fa-solid fa-trash-can-arrow-up'
                    />
                    Undelete
                  </div>}
                </div>
              )}

            </div>
            {!this.state.automatedTask && (
              <div className='float-end'>
                <p className='h6' style={{ margin: '15px 10px 7px 7px' }}>
                  <strong>Step:</strong> {this.state.stepName}
                </p>
              </div>
            )}
            {this.state.automatedTask && (
              <div
                className='float-end'
                style={{
                  padding: '7px 12px',
                  margin: '7px 0px 7px 7px',
                  fontSize: '12px',
                  backgroundColor: '#CCD1D1',
                  color: '#000',
                  borderRadius: '12px',
                }}
              >
                <i className='fa-solid fa-cog' /> <strong>Step:</strong>{' '}
                {this.state.stepName}{' '}
              </div>
            )}
            <div className='float-end'>
              <p className='h6' style={{ margin: '15px 10px 7px 7px' }}>
                <strong>Workflow:</strong> {this.state.workflowName}
              </p>
            </div>
          </div>
        </div>
        <div
          className='d-flex flex-row'
          style={{
            height: `${this.state.topHeight}px`,
            backgroundColor: '#8EEDD0',
          }}
        >
          <div
            className='coolScroll'
            id='headerFieldContainer'
            style={{
              backgroundColor: '#F1EEE4',
              width: '280px',
              borderRight: 'solid 1px #B2A796',
              overflow: 'auto',
            }}
          >
            {this.state.currentDoc &&
              this.state.currentDoc.headerFields.map((field) =>
                ((field.isHidden !== true || Number(this.props.userId) === 2) &&
                <div key={field.fieldId}>

                  <FieldEditor
                    fieldId={field.fieldId}
                    systemName={field.systemName}
                    fieldType={field.fieldType}
                    dataType={field.dataType}
                    decimalPlaces={field.decimalPlaces}
                    currencyCode={field.currencyCode}
                    format={field.format}
                    isRequired={field.isRequired}
                    error={field.error}
                    docId={this.state.currentDoc.documentId}
                    hasExtender={field.hasExtender}
                    extender={field.extender}
                    expandView={this.expandView}
                    setError={this.setFieldError}
                    displayName={field.displayName}
                    extenderKey={field.extenderKey}
                    extenderId={
                      field.hasExtender ? field.extender.extenderId : -1
                    }
                    textValue={field.fieldValue}
                    value={
                      field.hasExtender && field.extender.type === 4
                        ? field.fieldValue
                        : field.fieldValue
                    }
                    updateTextValue={this.handleHeaderFieldTextEdit}
                    updateValue={this.handleHeaderFieldEdit}
                    readOnly={!(this.state.userCanEdit && field.canEdit)}
                    closeAllList={this.closeAllList}
                    fontSize={0}
                    runExtender={this.runExtender}
                  />
                </div>
                  )
              )}
          </div>
          <div
            className='flex-fill coolScroll'
            style={{
              backgroundColor: '#DADADA',
              position: 'relative',
              overflow: 'auto',
            }}
          >
            {this.state.currentImage === undefined &&
              !this.state.loadingImage && (
                <div
                  className='h-100 d-flex align-items-center justify-content-center'
                  style={{
                    background: '#4E4E4E',
                    textAlign: 'center',
                    color: '#C1C1C1',
                  }}
                >
                  <div>No Image</div>
                </div>
              )}
            {(this.state.currentImage === undefined ||
              (this.state.currentImage !== undefined &&
                this.state.currentImage.imageBytes === null)) &&
              this.state.loadingImage && (
                <div
                  className='h-100 d-flex align-items-center justify-content-center'
                  style={{
                    background: '#4E4E4E',
                    textAlign: 'center',
                    color: '#C1C1C1',
                  }}
                >
                  <div>
                    <i className='fa-solid fa-spinner' size='4x' spin />
                    <h4>Loading Image</h4>
                  </div>
                </div>
              )}
            {this.state.currentImage !== undefined &&
              this.state.currentImage.imageBytes !== null && (
                <DocImageViewer
                  viewHeight={this.state.imageviewerHeight}
                  base64={this.state.currentImage.imageBytes}
                  viewWidth={this.state.imageviewerWidth}
                  imageHeight={this.state.currentImage.imageHeight}
                  imageWidth={this.state.currentImage.imageWidth}
                  imageCount={this.state.images.length}
                  currentPage={this.state.currentImage.pageId}
                  onPageNext={this.handleImageNav}
                  rotateLeft={this.rotateDocImageLeft}
                  rotateRight={this.rotateDocImageRight}
                  isRotatingLeft={this.state.isRotatingLeft}
                  isRotatingRight={this.state.isRotatingRight}
                  zoom={this.state.documentZoomSetting}
                />
              )}

          </div>
          {this.state.showUserNotes && (
            <div
              className='coolScroll p-2'
              id='userNotesContainer'
              style={{
                backgroundColor: '#FFF',
                width: '280px',
                borderRight: 'solid 1px #B2A796',
                overflow: 'auto',
                borderLeft: 'solid 1px #777',
              }}
            >
              <strong>
                <i className='fa-regular fa-comment-alt' /> Notes
              </strong>
              <hr />
              {this.state.userCanAddNotes && <div>
                <label
                  className='form-Label'
                  onClick={this.toggleAddNote}
                  style={{ cursor: 'pointer' }}
                >
                  {this.state.showAddNote && (
                    <i className='fa-solid fa-chevron-down' />
                  )}
                  {!this.state.showAddNote && (
                    <i className='fa-solid fa-chevron-right' />
                  )}{' '}
                  Add Note
                </label>
                {this.state.showAddNote && (
                  <>
                    <textarea
                      className='form-control'
                      value={this.state.newNote}
                      onChange={this.editNewNote}
                      //maxLength={512}
                      rows='2'
                    />
                    <button
                      className='btn btn-success btn-sm mt-1'
                      onClick={this.addNote}
                    >
                      Add Note
                    </button>
                  </>
                )}
                <hr />
              </div>


              }

              <div>
                {this.state.currentDoc.userNotes.map((note) => (
                  <div className='userNote-note' key={note.noteId}>
                     <div className='userNote-noteBody' style={{whiteSpace: 'pre-line'}}>
                        {note.noteText.split('\n').map((i,key) => {
                          return <div style={{minHeight: '9px'}} key={key}>{i}</div>
                        })}
                      </div>
                    <div className='userNote-noteFooter'>
                      <span>
                        - {note.userName}: {this.convertDate2(note.noteDate)}
                      </span>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          )}
        </div>
        <div
          style={{
            height: '8px',
            backgroundColor: '#AEAEAE',
            cursor: 'row-resize',
            border: 'solid 1px #8E8E8E',
          }}
          onMouseDown={this.onSplitBarMouseDown}
        ></div>
        {this.state.currentDoc !== undefined && (
          <div
            id='bottomDiv'
            style={{
              paddingLeft: '8px',
              paddingTop: '4px',
              backgroundColor: '#d3e1e0',
              height: `${this.state.bottomHeight}px`,
              maxHeight: `${this.state.bottomHeight}px`,
              minHeight: '30px',
              overflow: 'hidden',
            }}
          >

            {this.state.currentDoc.fieldSets.length > 0 && (
              <div className='row' style={{ position: 'relative', zIndex: 5 }}>
                <div className='col-4'>
                  <ul
                    className='nav'
                    style={{
                      display: 'flex',
                      alignItems: 'flex-end',
                      gap: '0px',
                      padding: '6px 0 0 0',
                      margin: 0,
                      listStyle: 'none',
                    }}
                  >
                    {this.state.currentDoc.fieldSets.map((fs, index) => {
                      const isActive = fs.fieldSetId === this.state.currentFieldSet.fieldSetId;
                      return (
                        <li
                          key={fs.fieldSetId}
                          onClick={() => this.toggleFieldSet(fs)}
                          style={{
                            cursor: 'pointer',
                            listStyle: 'none',
                            backgroundColor: isActive ? '#d6dbdf' : '#b5cacc',
                            color: isActive ? '#202124' : '#3c4a4b',
                            fontWeight: isActive ? '500' : '400',
                            fontSize: '12px',
                            padding: '5px 16px',
                            borderRadius: '8px 8px 0 0',
                            border: '1px solid #8a9ea0',
                            borderBottom: isActive ? '1px solid #d6dbdf' : '1px solid #8a9ea0',
                            position: 'relative',
                            bottom: isActive ? '-2px' : '-1px',
                            zIndex: isActive ? 2 : 1,
                            boxShadow: isActive
                              ? '-1px -2px 4px rgba(0,0,0,0.12), 1px -2px 4px rgba(0,0,0,0.12)'
                              : 'none',
                            clipPath: isActive ? 'inset(-10px -10px 0px -10px)' : 'none',
                            whiteSpace: 'nowrap',
                            userSelect: 'none',
                            minWidth: index === 0 ? '80px' : undefined,
                            textAlign: 'center',
                          }}
                        >
                          {fs.fieldSetName} {'('}
                          {fs.rows.filter((r) => r.isNew !== true).length}
                          {')'}
                        </li>
                      );
                    })}
                  </ul>
                </div>
                {this.state.showTools && (
                  <div className='col-6'>
                    <div className='form-check form-check-inline'>
                      <input
                        className='form-check-input'
                        type='checkbox'
                        checked={this.state.showChecks}
                        onChange={this.toggleChecks}
                      />
                      <i
                        style={{ color: '#247E15' }}
                        className='fa-solid fa-square-check'
                      />
                    </div>

                    <button
                      className='btn btn-sm btn-success'
                      onClick={this.writeGridToClipboard}
                    >
                      <span>
                        Copy{' '}
                        <i
                          style={{ color: '#fff' }}
                          className='fa-solid fa-table'
                        />
                      </span>{' '}
                    </button>

                    {this.state.userCanEdit && (
                      <button
                        className='btn btn-sm btn-success ms-2'
                        onClick={this.toggleExcelPaste}
                      >
                        <span>
                          Paste{' '}
                          <i
                            style={{ color: '#fff' }}
                            className='fa-solid fa-table'
                          />
                        </span>{' '}
                      </button>
                    )}
                    <button
                      className='btn btn-sm btn-primary ms-2'
                      onClick={this.toggleColumnEdit}
                    >
                      <span>
                        Columns{' '}
                        <i
                          style={{ color: '#fff' }}
                          className='fa-solid fa-table-columns'
                        />
                      </span>{' '}
                    </button>
                  </div>
                )}
              </div>
            )}


            {this.state.currentDoc.fieldSets.length > 0 && (
              <div
                className='document-grid-container coolScroll2'
                style={{
                  maxWidth: `${this.state.tableWidth}px`,
                  minHeight: `${this.state.bottomHeight - 48}px`,
                  maxHeight: `${this.state.bottomHeight - 48}px`,

                }}
              >
                <div>
                  <table style={{ borderLeft: 'solid 1px #5d6d7e' }}>
                    <tbody>
                      <tr
                      >
                        <td
                          className='document-grider-header-cell1'
                          width='40px'
                          style={{
                            minWidth: '40px',
                            textAlign: 'center',
                            cursor: 'pointer',
                          }}
                        >
                          <input
                            className='form-check-input'
                            type='checkbox'
                            checked={this.state.allRowCheck}
                            onChange={this.setAllRowCheck}
                          />
                        </td>

                        <td
                          className='document-grider-header-cell1'
                          width='40px'
                          style={{ minWidth: '40px' }}
                        >
                          {this.state.userCanEdit && (
                            <button
                              className='btn btn-sm btn-danger'
                              onClick={this.deleteRows}
                            >
                              <i className='fa-solid fa-trash-can' />
                            </button>
                          )}
                        </td>

                        {this.state.showChecks && (
                          <td
                            className='document-grider-header-cell1'
                            width='60px'
                            style={{ minWidth: '60px', textAlign: 'center' }}
                          >
                            <i
                              style={{ color: '#247E15' }}
                              className='mt-1 fa-solid fa-circle-check'
                              size='2x'
                            />
                          </td>
                        )}
                        <td
                          className='document-grider-header-cell1'
                          width='40px'
                          style={{ minWidth: '80px', textAlign: 'center' }}
                        >
                          <button
                            className='btn btn-sm btn-secondary'
                            onClick={this.toggleShowTools}
                          >
                            <i className='fa-solid fa-tools' />
                          </button>
                          <i
                            title='Sort by line ID'
                            onClick={this.onClickSortByRowId}
                            style={{
                              color: rowSortField ? '#165DC3' : '#777',
                              cursor: 'pointer',
                              marginLeft: '6px',
                            }}
                            className='fa-solid fa-arrow-down-1-9'
                          />
                        </td>

                        {this.state.currentFieldSet.fieldDefs.map(
                          (col) =>
                            col.display && (
                              <React.Fragment key={col.fieldId}>
                                {/*<td className='document-grider-header-left' onMouseDown={(e) => this.startDraggingColumn(e, col.fieldId)} width='8px'>{' '}</td>*/}
                                <td
                                  className='document-grider-header-cell2'
                                  width={`${col.colWidth - 8}px`}
                                  style={{
                                    maxWidth: `${col.colWidth - 8}px`,
                                    minWidth: `${col.colWidth - 8}px`,
                                    cursor: 'pointer',
                                    userSelect: 'none',
                                  }}
                                  onClick={() => this.onClickRowColumnHeader(col.fieldId)}
                                >
                                  {col.colName}
                                  {rowSortField === col.fieldId && rowSortDir === 'asc' && (
                                    <i style={{ color: '#165DC3', cursor: 'pointer' }} className='ms-2 fa-solid fa-sort-up' />
                                  )}
                                  {rowSortField === col.fieldId && rowSortDir === 'desc' && (
                                    <i style={{ color: '#165DC3', cursor: 'pointer' }} className='ms-2 fa-solid fa-sort-down' />
                                  )}
                                  {rowSortField !== col.fieldId && (
                                    <i style={{ color: '#777', cursor: 'pointer' }} className='ms-2 fa-solid fa-sort' />
                                  )}
                                  {col.showTotal && (
                                    <span style={{ color: '#2e3fae' }}>
                                      {' '}
                                      <span
                                        id={`${col.fieldId}_runningTotal`}
                                        key={`${col.fieldId}_runningTotal`}
                                      ></span>
                                    </span>
                                  )}
                                </td>
                                <td
                                  className='document-grider-header-right'
                                  onMouseDown={(e) =>
                                    this.startDraggingColumn(e, col.fieldId)
                                  }
                                  width='8px'
                                >
                                  {' '}
                                </td>
                              </React.Fragment>
                            )
                        )}


                        <td
                          className='document-grider-header-right'
                          onMouseDown={(e) => {
                            const lastCol = this.state.currentFieldSet.fieldDefs
                              .filter((c) => c.display)
                              .slice(-1)[0];
                            if (lastCol) {
                              this.startDraggingColumn(e, lastCol.fieldId);
                            }
                          }}
                          width='8px'
                          style={{ cursor: 'col-resize' }}
                        ></td>

                        {/*}
                      <td
                        className='document-grider-header-cell2'
                        width='20px'
                        style={{
                          minWidth: '20px',
                          borderRight: 'solid 1px #5D6D7E',
                        }}
                      ></td>*/}
                      </tr>
                    </tbody>
                  </table>
                </div>

                <div
                  id='mainRowGrid'
                  className='document-grid-rows'
                  style={{
                    maxHeight: `${this.state.tableHeight}px`,
                    width: this.getTableWidth() + 18,
                  }}
                  onWheel={this.onMainScroll}
                >
                  <div
                      id='magicScroll'
                      className='coolScroll3'
                      style={{
                        backgroundColor: 'rgba(255,0,255, 0.0)',
                        //backgroundColor: 'red',
                        color: '#FFF',

                        position: 'absolute',
                        right: '24px',
                        top: `${this.state.topHeight + 210}px`,
                        height: `${this.state.bottomHeight - 100}px`,
                        width: '20px',
                        overflowY: 'auto',
                        overflowX: 'hidden',
                        zIndex: 100,
                      }}
                      onScroll={this.onMagicScroll}
                    >
                      <div style={{ height: `${this.state.rowData.length * 34}px` }}>
                        <span style={{paddingLeft: '50px'}}>.</span>
                        {' '}
                      </div>
                    </div>
                  <table>
                    <tbody>
                      {this.getSortedRows().map((row) => (
                        <React.Fragment key={row.rowId}>
                          <tr>
                            <td
                              className={`document-grider-data-cell1 ${
                                row.isNew ? 'new-rec' : ''
                              }`}
                              width='40px'
                              style={{
                                minWidth: '40px',
                                textAlign: 'center',
                                cursor: 'pointer',
                              }}
                            >
                              {!row.isNew && (
                                <input
                                  className='form-check-input'
                                  type='checkbox'
                                  tabIndex='-1'
                                  checked={row.isChecked}
                                  onChange={(e) =>
                                    this.setRowCheck(e, row.rowId)
                                  }
                                />
                              )}
                            </td>

                            <td
                              className={`document-grider-data-cell1 ${
                                row.isNew ? 'new-rec' : ''
                              }`}
                              width='40px'
                              style={{
                                minWidth: '40px',
                                textAlign: 'center',
                                cursor: 'pointer',
                              }}
                            >
                              {!row.isNew && this.state.userCanEdit && (
                                <i
                                  onClick={() => this.deleteRow(row.rowId)}
                                  style={{ color: '#CD3C3C' }}
                                  className='fa-solid fa-trash-can'
                                />
                              )}
                            </td>

                            {this.state.showChecks && (
                              <td
                                className={`document-grider-data-cell1 ${
                                  row.isNew ? 'new-rec' : ''
                                }`}
                                width='60px'
                                style={{
                                  minWidth: '60px',
                                  textAlign: 'center',
                                }}
                              >
                                <i
                                  onClick={() => this.toggleCheck(row.rowId)}
                                  style={{
                                    cursor: 'pointer',
                                    color: row.auditCheck
                                      ? '#247E15'
                                      : '#D7D7D7',
                                  }}
                                  className='mt-1 fa-solid fa-check'
                                />
                              </td>
                            )}
                            <td
                              className={`document-grider-data-cell1 ${
                                row.isNew ? 'new-rec' : ''
                              }`}
                              width='40px'
                              style={{
                                minWidth: '80px',
                                textAlign: row.isNew ? 'right' : 'center',
                              }}
                            >
                              {!row.isNew && row.rowId}
                              {row.isNew && (
                                <i
                                  style={{
                                    color: '#8C8C8C',
                                    marginRight: '6px',
                                  }}
                                  className='fa-solid fa-asterisk'
                                />
                              )}
                            </td>

                            {row.fieldData.map(
                              (col) =>
                                col.fieldDef !== undefined &&
                                col.fieldDef.display && (
                                  <td
                                    key={col.fieldId}
                                    className='document-grider-data-cell2'
                                    width={`${col.fieldDef.colWidth}px`}
                                    style={{
                                      minWidth: `${col.fieldDef.colWidth}px`,
                                    }}
                                  >
                                    <TableCellEditor
                                      readOnly={!this.state.userCanEdit}
                                      onFocus={this.onCellClick}
                                      value={col.fieldValue}
                                      textValue={col.fieldValue}
                                      extenderKey={col.extenderKey}
                                      updateField={this.handleTableFieldEdit}
                                      fieldDef={col.fieldDef}
                                      orderId={col.displayOrder}
                                      fieldSetId={this.state.currentFieldSet}
                                      onMoveCell={this.onMoveCell}
                                      rowId={row.rowId}
                                      colId={col.fieldId}
                                      hasExtender={col.fieldDef.hasExtender}
                                      extender={col.fieldDef.extender}
                                      extenderId={
                                        col.fieldDef.hasExtender
                                          ? col.fieldDef.extender.extenderId
                                          : -1
                                      }
                                      allowedValues={col.allowedValues}
                                      updateValue={this.handleTableFieldEdit}
                                      setLineFieldError={this.setLineFieldError}
                                      error={col.error}
                                      setError={this.setCellError}
                                      clearError={this.clearCellError}
                                      calculateRunningTotal={
                                        this.calculateRunningTotal
                                      }
                                    />
                                  </td>
                                )
                            )}
                            {/*<td
                            className='document-grider-data-cell2'
                            width='20px'
                            style={{
                              minWidth: '20px',
                              borderRight: 'solid 1px #85929E',
                            }}
                          ></td>*/}
                          </tr>
                        </React.Fragment>
                      ))}
                      {/*<tr>
                        <td className='document-grider-data-cell1 new-rec' width='40px' style={{minWidth: '40px', textAlign: 'center', cursor: 'pointer'}}></td>
                        {this.state.showTrash && <td className='document-grider-data-cell1 new-rec' width='40px' style={{minWidth: '40px'}}></td>}
                        {this.state.showChecks && <td className='document-grider-data-cell1 new-rec' width='60px' style={{minWidth: '60px', textAlign: 'center'}}></td> }
                        <td className='document-grider-data-cell1 new-rec' width='40px' style={{minWidth: '80px', textAlign: 'right'}}><i style={{color: '#8C8C8C', marginRight: '6px' }} className='fa-solid fa-asterisk' /></td>

                        {this.state.currentFieldSet.fieldDefs.map((col) => (
                           col.display &&
                           <td key={col.fieldId} className='document-grider-data-cell2 new-rec`' width={`${col.colWidth}px`} style={{minWidth: `${col.colWidth}px`}}><TableCellEditor readOnly={false} onFocus={this.onCellClick} onLoseFocus={this.createNewRow} value='' onMoveCell={this.onMoveCell} rowId={-1} colId={col.fieldId} /></td>

                        ))}
                        <td className='document-grider-data-cell2' width='20px' style={{minWidth: '20px', borderRight: 'solid 1px #85929E'}}></td>
                        </tr> */}
                      <tr>
                        <td>
                          <br></br>
                          <br />
                          <br />
                          <br />
                          <br />
                          <br />
                          <br />
                          <br />
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            )}
          </div>
        )}

        {this.state.showColumnEdit && (
          <div className='td-dialogue-container'>
            <div className='td-dialogue card' style={{ width: '300px' }}>
              <div className='card-header'>
                Hide/Show columns{' '}
                <button
                  type='button'
                  className='btn-close'
                  onClick={this.toggleColumnEdit}
                />
              </div>
              <div
                className='card-body'
                style={{ height: '300px', overflow: 'auto' }}
              >
                <div className='form-check'>
                  <input
                    className='form-check-input'
                    type='checkbox'
                    checked={this.state.showAllColumns}
                    onChange={(e) => this.toggleShowAllColumns(e)}
                  />
                  <label className='form-check-label'> All Columns</label>
                </div>
                <hr />
                {this.state.currentFieldSet.fieldDefs.map((fs) => (
                  <div key={fs.fieldId} className='form-check'>
                    <input
                      className='form-check-input'
                      type='checkbox'
                      checked={fs.display}
                      onChange={(e) => this.toggleColumnDisplay(e, fs.fieldId)}
                    />
                    <label className='form-check-label'>{fs.colName}</label>
                  </div>
                ))}
              </div>
            </div>
          </div>
        )}

        {this.state.showAudit2  && (
           <div className='td-dialogue-container'>tes
           <div
             className='td-dialogue card'
             style={{ width: '85%', height: '85%' }}
           >
           <div className='card-header'>
                Document Audit History
                <button
                  type='button'
                  className='btn-close'
                  onClick={this.toggleShowAudit}
                />
              </div>
              <div
                className='card-body'
                style={{ height: '600px', overflow: 'auto' }}
              >
                <nav className='nav'>
                  <span onClick={() => this.setAuditTab('user')} className={`nav-link nav-button ${this.state.currentAuditView === 'user' ? 'active' : ''}`}>User Actions</span>
                  <span onClick={() => this.setAuditTab('auto')} className={`nav-link nav-button ${this.state.currentAuditView === 'auto' ? 'active' : ''}`}>Automated Actions</span>
                  <span onClick={() => this.setAuditTab('full')} className={`nav-link nav-button ${this.state.currentAuditView === 'full' ? 'active' : ''}`}>Full Audit</span>
                </nav>
                {this.state.currentAuditView==='user' && (
                  <div>User Activity</div>
                )}
                {this.state.currentAuditView==='auto' && (
                  <div>Plugin Activity</div>
                )}
                {this.state.currentAuditView==='full' && (
                  <div>All Activity</div>
                )}

              </div>
           </div>
           </div>
        )}

        {this.state.showAudit && (
          <div className='td-dialogue-container'>
            <div
              className='td-dialogue card'
              style={{ width: '85%', height: '85%' }}
            >
              <div className='card-header'>
                Document Audit History
                <button
                  type='button'
                  className='btn-close'
                  onClick={this.toggleShowAudit}
                />
              </div>
              <div
                className='card-body'
                style={{ height: '600px', overflow: 'auto' }}
              >
                <ul className='nav nav-pills justify-content-center'>
                  <li className='nav-item greenPill'>
                    <span
                      className={`nav-link ${
                        this.state.currentAuditView === 'user' ? 'active' : ''
                      }`}
                      style={{ cursor: 'pointer' }}
                      onClick={() => this.switchAuditView('user')}
                    >
                      {this.state.fetchingUserActivity &&
                      <span><i className='fa-solid fa-spinner' spin />{'  '}</span>
                      }
                      User Activity
                    </span>
                  </li>
                  <li className='nav-item cyanPill'>
                    <span
                      className={`nav-link ${
                        this.state.currentAuditView === 'auto' ? 'active' : ''
                      }`}
                      style={{ cursor: 'pointer' }}
                      onClick={() => this.switchAuditView('auto')}
                    >
                      {this.state.fetchingIntegrationActivity &&
                        <span><i className='fa-solid fa-spinner' spin />{'  '}</span>
                        }Plugin Activity
                    </span>

                  </li>
                  <li className='nav-item plumPill'>
                    <span
                      className={`nav-link ${
                        this.state.currentAuditView === 'full' ? 'active' : ''
                      }`}
                      style={{ cursor: 'pointer' }}
                      onClick={() => this.switchAuditView('full')}
                    >

                      {(this.state.fetchingIntegrationActivity || this.state.fetchingUserActivity) &&
                        <span><i className='fa-solid fa-spinner' spin />{'  '}</span>
                        }All Activity
                    </span>
                  </li>
                </ul>

                {this.state.isAuditLoading && (
                  <div
                    style={{
                      height: '400px',
                      width: '750px',
                      paddingTop: '100px',
                      textAlign: 'center',
                    }}
                  >
                    <i
                      style={{ color: '#777' }}
                      size='3x'
                      className='fa-solid fa-spinner'
                      spin
                    />
                    <div className='mt-2 mb-2'>
                      Loading audit information...
                    </div>
                  </div>
                )}
                {!this.state.fetchingUserActivity &&
                  this.state.auditInfo !== undefined &&
                  this.state.currentAuditView === 'user' && (
                    <div>
                      <div>
                      </div>
                      <table className='mt-2'>
                        <tr>
                          <td><h3>User Activity</h3></td>
                          <td><div className='form-check form-switch ms-3'>
                            <input
                              className='form-check-input'
                              type='checkbox'
                              id='showViews'
                              onChange={(e) => this.toggleAuditVars(e, 'views')}
                              checked={this.state.showAuditViews}
                            />
                            <label
                              className='form-check-label'
                              htmlFor='preSplitChange'
                            >
                              Show Views
                            </label>
                          </div></td>
                          <td><div className='form-check form-switch ms-3'>
                            <input
                              className='form-check-input'
                              type='checkbox'
                              id='showUserNotes'
                              onChange={(e) => this.toggleAuditVars(e, 'userNotes')}
                              checked={this.state.showAuditUserNotes}
                            />
                            <label
                              className='form-check-label'
                              htmlFor='preSplitChange'
                            >
                              Show User Notes
                            </label>
                          </div></td>
                          <td>
                            <button className='ms-4 btn btn-small btn-info' onClick={this.downloadAuditClick}>Download</button>
                          </td>
                        </tr>
                      </table>
                      <table className='audit-table' style={{ width: '100%' }}>
                        <thead>
                          <tr>
                            <th>Step</th>
                            <th>User</th>
                            <th>Action</th>
                            <th>Date/Time</th>
                            <th>Event detail</th>
                          </tr>
                        </thead>
                        <tbody>
                          {this.state.auditInfo.map((uaudit) => (
                            (uaudit.action !== 'Viewed' || this.state.showAuditViews) && (uaudit.action !== 'User Note' || this.state.showAuditUserNotes) &&
                            <tr
                              style={{
                                backgroundColor:

                                  uaudit.action === 'Viewed'
                                    ? '#FFFEEC'
                                    : uaudit.action === 'User Note' ? '#AFD9A9' : '#FFFCD6',

                              }}



                            >
                              <td>{uaudit.stepName}</td>
                              <td>
                                <span style={{ color: '#676767' }}>
                                  {uaudit.performerType.toUpperCase() ===
                                    'System'.toUpperCase() && (
                                    <i className='fa-solid fa-gear' />
                                  )}
                                  {uaudit.performerType.toUpperCase() ===
                                    'Integration'.toUpperCase() && (
                                    <i className='fa-solid fa-gear' />
                                  )}
                                  {uaudit.performerType.toUpperCase() ===
                                    'User'.toUpperCase() && (
                                    <i className='fa-solid fa-user' />
                                  )}

                                </span>{' '}
                                {uaudit.userName}
                              </td>
                              <td>
                                <span style={{ color: '#676767' }}>
                                  {uaudit.action === 'SAVE' && (
                                    <i className='fa-solid fa-save' />
                                  )}
                                  {(uaudit.action === 'REGISTER' ||
                                    uaudit.action === 'Register') && (
                                    <i
                                      className='fa-solid fa-registered'
                                    />
                                  )}
                                  {(uaudit.action === 'User Note') && (
                                    <i
                                      className='fa-solid fa-note-sticky'
                                    />
                                  )}
                                  {(uaudit.action === 'Execute') && (
                                    <i className='fa-solid fa-play'/>
                                  )}
                                   {(uaudit.action === 'OnDemand') && (
                                    <i className='fa-solid fa-play'/>
                                  )}
                                  {(uaudit.action === 'APPROVE' ||
                                    uaudit.action === 'Approved' ||
                                    uaudit.action === 'Bulk Approved') && (
                                    <i
                                      className='fa-solid fa-thumbs-up'
                                    />
                                  )}
                                  {(uaudit.action === 'Moved' ||
                                    uaudit.action ===
                                      'Bulk Move and Assigned') && (
                                    <i
                                      className='fa-solid fa-truck-moving'
                                    />
                                  )}
                                  {(uaudit.action === 'REJECT' ||
                                    uaudit.action === 'Rejected' ||
                                    uaudit.action === 'Bulk Rejected') && (
                                    <i
                                      className='fa-solid fa-thumbs-down'
                                    />
                                  )}
                                  {uaudit.action ===
                                    'Bulk Changed to Ready' && (
                                    <i
                                      className='fa-solid fa-check-double'
                                    />
                                  )}
                                  {uaudit.action === 'Saved' && (
                                    <i className='fa-solid fa-save' />
                                  )}
                                  {uaudit.action === 'Reset' && (
                                    <i
                                      className='fa-solid fa-check-double'
                                    />
                                  )}
                                  {(uaudit.action === 'ASSIGNED' ||
                                    uaudit.action === 'Assigned') && (
                                    <i className='fa-solid fa-user-tag' />
                                  )}
                                  {(uaudit.action === 'DELETED' ||
                                    uaudit.action === 'Bulk Deleted' ||
                                    uaudit.action === 'Deleted') && (
                                    <i
                                      className='fa-solid fa-trash-alt'
                                    />
                                  )}
                                  {(uaudit.action === 'IMAGEREVIEW' ||
                                    uaudit.action === 'Image Review' ||
                                    uaudit.action ===
                                      'Bulk Sent to Image Review') && (
                                    <i
                                      className='fa-solid fa-file-image'
                                    />
                                  )}
                                </span>{' '}
                                {uaudit.action}
                              </td>
                              <td>{this.convertDate2(uaudit.eventTime)}</td>
                              <td>{uaudit.note} </td>
                            </tr>

                          ))}
                        </tbody>
                      </table>
                    </div>
                  )}
                {!this.state.isAuditLoading &&
                  this.state.auditInfo !== undefined &&
                  this.state.currentAuditView === 'auto' && (
                    <div>
                      <table className='mt-2'>
                        <tr>
                          <td><h3>Plugin Activity</h3></td>
                          <td><div className='form-check form-switch ms-3'>
                            <input
                              className='form-check-input'
                              type='checkbox'
                              id='showSystemNotes1'
                              onChange={(e) => this.toggleAuditVars(e, 'systemNotes')}
                              checked={this.state.showAuditSystemNotes}
                            />
                            <label
                              className='form-check-label'
                              htmlFor='preSplitChange'
                            >
                              Show System Notes
                            </label>
                          </div></td>
                          <td>
                            <button className='ms-4 btn btn-small btn-info' onClick={this.downloadAuditClick}>Download</button>
                          </td>

                        </tr>
                      </table>
                      <table className='audit-table'>
                        <thead>
                          <tr>
                            <th>Step</th>
                            <th>User</th>
                            <th>Action</th>
                            <th>Date/Time</th>
                            <th>Event detail</th>
                          </tr>
                        </thead>
                        <tbody>
                          {this.state.auditInfo2.map((uaudit) => (
                            (uaudit.performerType === 'Integration' || this.state.showAuditSystemNotes) &&
                            <tr key={uaudit.auditKey}
                              style={{
                                backgroundColor:
                                  uaudit.performerType === 'System'
                                    ? '#DFDFDF'
                                    : '#C3F5FF',
                              }}
                            >
                              <td>{uaudit.stepName}</td>
                              <td>
                                <span style={{ color: '#676767' }}>
                                  {uaudit.performerType === 'System' && (
                                    <i className='fa-solid fa-note-sticky' />
                                  )}
                                  {uaudit.performerType === 'Integration' && (
                                    <i className='fa-solid fa-plug' />
                                  )}
                                  {uaudit.performerType === 'User' && (
                                    <i className='fa-solid fa-user' />
                                  )}
                                </span>{' '}
                                {uaudit.userName}
                              </td>
                              <td>
                                <span style={{ color: '#676767' }}>
                                  {uaudit.action === 'SAVE' && (
                                    <i className='fa-solid fa-save' />
                                  )}
                                   {(uaudit.action === 'Execute') && (
                                    <i className='fa-solid fa-play'/>
                                  )}
                                  {(uaudit.action === 'REGISTER' ||
                                    uaudit.action === 'Register') && (
                                    <i
                                      className='fa-solid fa-registered'
                                    />
                                  )}
                                  {(uaudit.action === 'APPROVE' ||
                                    uaudit.action === 'Approved' ||
                                    uaudit.action === 'Bulk Approved') && (
                                    <i
                                      className='fa-solid fa-thumbs-up'
                                    />
                                  )}
                                  {(uaudit.action === 'Moved' ||
                                    uaudit.action ===
                                      'Bulk Move and Assigned') && (
                                    <i
                                      className='fa-solid fa-truck-moving'
                                    />
                                  )}
                                  {(uaudit.action === 'REJECT' ||
                                    uaudit.action === 'Rejected' ||
                                    uaudit.action === 'Bulk Rejected') && (
                                    <i
                                      className='fa-solid fa-thumbs-down'
                                    />
                                  )}
                                  {uaudit.action ===
                                    'Bulk Changed to Ready' && (
                                    <i
                                      className='fa-solid fa-check-double'
                                    />
                                  )}
                                  {uaudit.action === 'Saved' && (
                                    <i className='fa-solid fa-save' />
                                  )}
                                  {uaudit.action === 'Reset' && (
                                    <i
                                      className='fa-solid fa-check-double'
                                    />
                                  )}
                                  {(uaudit.action === 'ASSIGNED' ||
                                    uaudit.action === 'Assigned') && (
                                    <i className='fa-solid fa-user-tag' />
                                  )}
                                  {(uaudit.action === 'DELETED' ||
                                    uaudit.action === 'Bulk Deleted' ||
                                    uaudit.action === 'Deleted') && (
                                    <i
                                      className='fa-solid fa-trash-alt'
                                    />
                                  )}
                                  {(uaudit.action === 'IMAGEREVIEW' ||
                                    uaudit.action === 'Image Review' ||
                                    uaudit.action ===
                                      'Bulk Sent to Image Review') && (
                                    <i
                                      className='fa-solid fa-file-image'
                                    />
                                  )}
                                </span>{' '}
                                {uaudit.action}
                              </td>
                              <td>{this.convertDate(uaudit.eventTime)}</td>
                              <td>{uaudit.note} </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  )}
                {!this.state.isAuditLoading &&
                  this.state.auditInfo !== undefined &&
                  this.state.currentAuditView === 'full' && (
                    <div>
                      <table className='mt-2'>
                        <tr>
                          <td><h3>All Activity</h3></td>
                          <td><div className='form-check form-switch ms-3'>
                            <input
                              className='form-check-input'
                              type='checkbox'
                              id='showViews'
                              onChange={(e) => this.toggleAuditVars(e, 'views')}
                              checked={this.state.showAuditViews}
                            />
                            <label
                              className='form-check-label'
                              htmlFor='preSplitChange'
                            >
                              Show Views
                            </label>
                          </div></td>
                          <td><div className='form-check form-switch ms-3'>
                            <input
                              className='form-check-input'
                              type='checkbox'
                              id='showUserNotes'
                              onChange={(e) => this.toggleAuditVars(e, 'userNotes')}
                              checked={this.state.showAuditUserNotes}
                            />
                            <label
                              className='form-check-label'
                              htmlFor='preSplitChange'
                            >
                              Show User Notes
                            </label>
                          </div></td>
                          <td><div className='form-check form-switch ms-3'>
                            <input
                              className='form-check-input'
                              type='checkbox'
                              id='showSystemNotes1'
                              onChange={(e) => this.toggleAuditVars(e, 'systemNotes')}
                              checked={this.state.showAuditSystemNotes}
                            />
                            <label
                              className='form-check-label'
                              htmlFor='preSplitChange'
                            >
                              Show System Notes
                            </label>
                          </div></td>
                          <td><div className='form-check form-switch ms-3'>
                            <input
                              className='form-check-input'
                              type='checkbox'
                              id='showSystemActivity'
                              onChange={(e) => this.toggleAuditVars(e, 'system')}
                              checked={this.state.showAuditSystemActivity}
                            />
                            <label
                              className='form-check-label'
                              htmlFor='preSplitChange'
                            >
                              Show Workflow Activity
                            </label>
                          </div></td>
                          <td>
                            <button className='ms-4 btn btn-small btn-info' onClick={this.downloadAuditClick}>Download</button>
                          </td>


                        </tr>
                      </table>
                      <table className='audit-table'>
                        <thead>
                          <tr>
                            <th>Step</th>
                            <th>User</th>
                            <th>Action</th>
                            <th>Date/Time</th>
                            <th>Event detail</th>
                          </tr>
                        </thead>
                        <tbody>
                          {this.state.auditInfo3.map((uaudit) => (
                            (uaudit.action !== 'Viewed' || this.state.showAuditViews) &&
                            (uaudit.action !== 'User Note' || this.state.showAuditUserNotes) &&
                            (uaudit.performerType !== 'Workflow' || this.state.showAuditSystemActivity) &&
                            ((uaudit.action !== 'IntegrationSystem' && uaudit.action !== 'IntegrationNote') || this.state.showAuditSystemNotes) &&
                            <tr
                              style={{
                                backgroundColor:
                                  uaudit.performerType === 'System'
                                    ? '#DFDFDF'
                                    : uaudit.performerType === 'Integration'
                                    ? '#C3F5FF'
                                    : uaudit.action === 'Viewed'
                                    ? '#FFFEEC'
                                    : uaudit.action === 'User Note'
                                    ? '#AFD9A9'
                                    : uaudit.performerType === 'Workflow'
                                    ? '#FFDCC3'
                                    : '#FFFCD6'
                              }}
                            >
                              <td>{uaudit.stepName}</td>
                              <td>
                                <span style={{ color: '#676767' }}>
                                  {uaudit.performerType === 'System' && (
                                    <i className='fa-solid fa-gear' />
                                  )}
                                  {uaudit.performerType === 'Integration' && (
                                    <i className='fa-solid fa-plug' />
                                  )}
                                  {uaudit.performerType === 'User' && (
                                    <i className='fa-solid fa-user' />
                                  )}

                                  {uaudit.performerType === 'Workflow' && (
                                    <i className='fa-solid fa-sitemap' />
                                  )}
                                </span>{' '}
                                {uaudit.userName}
                              </td>
                              <td>
                                <span style={{ color: '#676767' }}>
                                  {uaudit.action === 'SAVE' && (
                                    <i className='fa-solid fa-save' />
                                  )}
                                  {(uaudit.action === 'REGISTER' ||
                                    uaudit.action === 'Register') && (
                                    <i
                                      className='fa-solid fa-registered'
                                    />
                                  )}
                                    {(uaudit.action === 'Execute') && (
                                    <i className='fa-solid fa-play'/>
                                  )}
                                   {(uaudit.action === 'OnDemand') && (
                                    <i className='fa-solid fa-play'/>
                                  )}
                                  {(uaudit.action === 'APPROVE' ||
                                    uaudit.action === 'Approved' ||
                                    uaudit.action === 'Bulk Approved') && (
                                    <i
                                      className='fa-solid fa-thumbs-up'
                                    />
                                  )}
                                  {(uaudit.action === 'Moved' ||
                                    uaudit.action ===
                                      'Bulk Move and Assigned') && (
                                    <i
                                      className='fa-solid fa-truck-moving'
                                    />
                                  )}
                                  {(uaudit.action === 'REJECT' ||
                                    uaudit.action === 'Rejected' ||
                                    uaudit.action === 'Bulk Rejected') && (
                                    <i
                                      className='fa-solid fa-thumbs-down'
                                    />
                                  )}
                                  {(uaudit.action === 'User Note') && (
                                    <i
                                      className='fa-solid fa-note-sticky'
                                    />
                                  )}

                                  {uaudit.action ===
                                    'Bulk Changed to Ready' && (
                                    <i
                                      className='fa-solid fa-check-double'
                                    />
                                  )}
                                  {uaudit.action === 'Saved' && (
                                    <i className='fa-solid fa-save' />
                                  )}
                                  {uaudit.action === 'Reset' && (
                                    <i
                                      className='fa-solid fa-check-double'
                                    />
                                  )}
                                  {(uaudit.action === 'ASSIGNED' ||
                                    uaudit.action === 'Assigned') && (
                                    <i className='fa-solid fa-user-tag' />
                                  )}
                                  {(uaudit.action === 'DELETED' ||
                                    uaudit.action === 'Bulk Deleted' ||
                                    uaudit.action === 'Deleted') && (
                                    <i
                                      className='fa-solid fa-trash-alt'
                                    />
                                  )}
                                  {(uaudit.action === 'IMAGEREVIEW' ||
                                    uaudit.action === 'Image Review' ||
                                    uaudit.action ===
                                      'Bulk Sent to Image Review') && (
                                    <i
                                      className='fa-solid fa-file-image'
                                    />
                                  )}
                                </span>{' '}
                                {uaudit.action}
                              </td>
                              <td>{this.convertDate(uaudit.eventTime)}</td>
                              <td>{uaudit.note} </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  )}
              </div>
            </div>
          </div>
        )}

        {this.state.showAudit2 && (
          <div className='td-dialogue-container'>
             <div
              className='td-dialogue card'
              style={{ width: '85%', height: '85%' }}
            >
              <div className='card-header'>
                Document Audit History
                <button
                  type='button'
                  className='btn-close'
                  onClick={this.toggleShowAudit}
                />
              </div>
              <div
                className='card-body'
                style={{ height: '600px', overflow: 'auto' }}
              >
              </div>
            </div>
          </div>
        )}

        {this.state.showTemplateChange && (
          <div className='td-dialogue-container'>
            <div className='td-dialogue card' style={{ width: '700px', height:'450px' }}>
              <div className='card-header'>
                Change Read Settings:
                <button
                  type='button'
                  className='btn-close'
                  onClick={this.toggleTemplateChange}
                />
              </div>
              <div
                className='card-body'
                style={{ height: '350px', overflow: 'auto' }}
              >
                <label className='form-label'>AI OCR Reader</label>
                <AutoComplete
                  id={`ChReaderList`}
                  allowedValues={this.state.allReaders}
                  value={this.state.suggestedReaderId}
                  valueField='readerId'
                  displayField='name'
                  onChange={this.readerSuggestionClick}
                  //setFocus={this.setCurrentRoute}
                />
                <label className='form-label'>Default</label>
                <AutoComplete
                  id={`ChDefaultList`}
                  allowedValues={this.state.allDefaults}
                  value={this.state.suggestedDefaultId}
                  valueField='defaultsDBId'
                  displayField='defaultName'
                  onChange={this.defaultSuggestionClick}
                  //setFocus={this.setCurrentRoute}
                />
                <label className='form-label'>Template</label>
                <AutoComplete
                  id={`ChTemplateList`}
                  allowedValues={this.state.filteredTemplates}
                  value={this.state.suggestedTemplateId}
                  valueField='templateId'
                  displayField='templateName'
                  onChange={this.templateSuggestionClick}
                  //setFocus={this.setCurrentRoute}
                />


                <div className='d-grid gap-2 mt-3'>
                <button onClick={() => this.onClickTemplateChange(1)} type='button' className='btn btn-secondary'>Save above changes</button>
                <button onClick={() => this.onClickTemplateChange(2)} type='button' className='btn btn-success'>Save and apply changes</button>
                <button onClick={() => this.onClickTemplateChange(3)} type='button' className='btn btn-primary'>Save, clear out fields, and send to start of workflow</button>
                </div>
              </div>
            </div>
          </div>
        )}

        {this.state.showDeleteConfirm && (
          <div className='td-dialogue-container'>
            <div className='td-dialogue card' style={{ width: '700px' }}>
              <div className='card-header'>
                Confirm delete:
                <button
                  type='button'
                  className='btn-close'
                  onClick={this.cancelTrashClick}
                />
              </div>
              <div
                className='card-body'
                style={{ height: '180px', overflow: 'auto' }}
              >
                <div>
                  Are you sure you want to delete Document{' '}
                  {this.state.currentDoc.documentId}?
                </div>
                <div className='mt-3'>
                  <button className='btn btn-success' onClick={this.deleteDoc}>
                    <i className='fa-solid fa-check' /> Yes
                  </button>
                  <button
                    className='btn btn-secondary ms-2'
                    onClick={this.cancelTrashClick}
                  >
                    <i className='fa-solid fa-times' /> No
                  </button>
                </div>
              </div>
            </div>
          </div>
        )}

        {this.state.showExcelPaste && (
          <div className='td-dialogue-container'>
            <div className='td-dialogue card' style={{ width: '700px' }}>
              <div className='card-header'>
                Paste from Excel:
                <button
                  type='button'
                  className='btn-close'
                  onClick={this.toggleExcelPaste}
                />
              </div>
              <div
                className='card-body'
                style={{ height: '380px', overflow: 'auto' }}
              >
                <div>
                  <label className='form-label'>Paste here:</label>
                  <input
                    className='form-control'
                    value=''
                    onChange={this.pasteExcel}
                  ></input>
                </div>
                <div>
                  <label className='form-label'>Preview:</label>
                  <div
                    style={{
                      height: '200px',
                      width: '665px',
                      overflow: 'auto',
                      border: '1px solid #43683F',
                    }}
                  >
                    <table className='table table-success table-striped table-sm'>
                      <thead>
                        <tr>
                          {this.state.currentFieldSet.fieldDefs.map((field) => (
                            <th key={field.fieldId} scope='col'>
                              {field.colName}
                            </th>
                          ))}
                        </tr>
                      </thead>
                      <tbody>
                        {this.state.excelData.map((row) => (
                          <tr key={row.rowId}>
                            {row.rowData.cells.map((cell) => (
                              <td key={cell.cellId}>{cell.value}</td>
                            ))}
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                  <div className='mt-2'>
                    <button
                      className='btn btn-primary me-1'
                      onClick={this.replaceExcelData}
                    >
                      Replace
                    </button>
                    <button
                      className='btn btn-primary'
                      onClick={this.appendExcelData}
                    >
                      Append
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}
        {this.state.showProperties && (
          <div className='td-dialogue-container'>
            <div className='td-dialogue card' style={{ width: '720px', height: '500px' }}>
              <div className='card-header'>
                Document Properties:
                <button
                  type='button'
                  className='btn-close'
                  onClick={this.toggleProperties}
                />
              </div>
              <div
                className='card-body'
                style={{ height: '400px' }}
              >
                <div className='fs-5'>Document Properties</div>
                <hr />
                <div className='row justify-content-center'>
                  <div className='col-auto'>
                    <span className='propLabel'>
                      <i className='fa-solid fa-file' style={{ color: '#209627' }} />{' '}
                      Document Id:
                    </span>
                    <span className='propValue'>
                      {this.state.currentDoc.documentId}
                    </span>
                  </div>
                  <div className='col-auto'>
                    <span className='propLabel'>
                      <i
                        className='fa-solid fa-file-alt'
                        style={{ color: '#2E439E' }}
                      />{' '}
                      FormType:
                    </span>
                    <span className='propValue'>
                      {this.state.currentDoc.formTypeName}
                    </span>
                  </div>
                </div>

                <div className='row  justify-content-center gx-5'>

                  <div className='col-auto'>
                    <span className='propLabel'>
                      <i
                        className='fa-solid fa-sitemap'
                        style={{ color: '#F17F13' }}
                      />{' '}
                      Workflow:
                    </span>
                    <span className='propValue'>
                      {this.state.currentDoc.workflowName}
                    </span>
                  </div>
                  <div className='col-auto'>
                    <span className='propLabel'>
                      <i
                        className='fa-solid fa-puzzle-piece'
                        style={{ color: '#30D93A' }}
                      />{' '}
                      Template:
                    </span>
                    <span className='propValue'>
                      {this.state.currentDoc.templateName}
                    </span>
                  </div>
                </div>
                <div className='row justify-content-center'>

                </div>

                <hr />
                <div className='row justify-content-center'>
                  <div className='col-auto'>
                    <span className='propLabel'>
                      <i
                        className='fa-solid fa-upload'
                        style={{ color: '#2E9E94' }}
                      />{' '}
                      Upload Information:
                    </span>
                  </div>
                </div>
                <div
                  className='row justify-content-center'
                  style={{ marginTop: '12px' }}
                >
                  <div className='col-auto'>
                    <div>
                      <span className='propLabel2'>Upload Method:</span>{' '}
                      <span propValue2>
                        {this.state.currentDoc.uploadInfo.uploadMethod}
                      </span>
                    </div>
                    <div>
                      <span className='propLabel2'>Upload Date:</span>{' '}
                      <span propValue2>
                        {this.convertDate2(
                          this.state.currentDoc.uploadInfo.uploadDate
                        )}
                      </span>
                    </div>

                    <div>
                      <span className='propLabel2'>Received From:</span>{' '}
                      <span propValue2>
                        {this.state.currentDoc.uploadInfo.receivedFrom}
                      </span>
                    </div>
                    <div>
                      <span className='propLabel2'>Document Source:</span>{' '}
                      <span propValue2>
                        {this.state.currentDoc.uploadInfo.docSource}
                      </span>
                    </div>
                    <div>
                      <span className='propLabel2'>File Name:</span>{' '}
                      <span propValue2>
                        {this.state.currentDoc.uploadInfo.fileName}
                      </span>
                    </div>
                    {this.state.currentDoc.uploadInfo.intakeStrategy !== undefined && this.state.currentDoc.uploadInfo.intakeStrategy && <div>
                      <span className='propLabel2'>Intake Strategy:</span>{' '}
                      <span propValue2>
                        {this.state.currentDoc.uploadInfo.intakeStrategy}
                      </span>
                    </div>}
                    {this.state.currentDoc.uploadInfo.ocrType !== undefined && this.state.currentDoc.uploadInfo.ocrType && <div>
                      <span className='propLabel2'>OCR Type:</span>{' '}
                      <span propValue2>
                        {this.state.currentDoc.uploadInfo.ocrType}
                      </span>
                    </div>}
                    {this.state.currentDoc.uploadInfo.ocrQuality !== undefined && this.state.currentDoc.uploadInfo.ocrQuality && <div>
                      <span className='propLabel2'>OCR Quality:</span>{' '}
                      <span propValue2>
                        {this.state.currentDoc.uploadInfo.ocrQuality}
                      </span>
                    </div>}
                    {this.state.currentDoc.uploadInfo.barcodes !== undefined && this.state.currentDoc.uploadInfo.barcodes && <div>
                      <span className='propLabel2'>Barcodes:</span>{' '}
                      <span propValue2>
                        {this.state.currentDoc.uploadInfo.barcodes}
                      </span>
                    </div>}
                  </div>
                </div>
                <hr />
              </div>
            </div>
          </div>
        )}
        {this.state.showIntakeLogs && (
          <div className='td-dialogue-container'>
            <div className='td-dialogue card' style={{ width: '85vw', maxWidth: '100vw', height: '80vh', maxHeight: '100vh', display: 'flex', flexDirection: 'column' }}>
              <div className='card-header'>
                Intake Logs:
                <button
                  type='button'
                  className='btn-close'
                  onClick={this.toggleIntakeLogs}
                />
              </div>

              {this.state.intakeLogs.length > 0 && (() => {
                const headerLogs = this.state.intakeLogs.filter(l => l.lineId === 0);
                const lineLogs = this.state.intakeLogs.filter(l => l.lineId !== 0);
                const lineIds = [...new Set(lineLogs.map(l => l.lineId))].sort((a, b) => a - b);

                // Collect unique field names across all line logs (preserving order of first appearance)
                const lineFieldNames = [];
                lineLogs.forEach(l => {
                  if (!lineFieldNames.includes(l.fieldName)) lineFieldNames.push(l.fieldName);
                });

                const renderHeaderRow = (intakeLog, rowKey) => (
                  <React.Fragment key={rowKey}>
                    <tr
                      style={{ cursor: intakeLog.history?.length ? 'pointer' : 'default' }}
                      onClick={() => intakeLog.history?.length && this.toggleIntakeLogRow(rowKey)}
                    >
                      <td>{intakeLog.fieldName}</td>
                      <td>{intakeLog.value}</td>
                      <td>{intakeLog.source}</td>
                      <td>{intakeLog.sourceDetail}: {intakeLog.description}</td>
                      <td>
                        {new Date(intakeLog.timeStamp).toLocaleString()}
                        {intakeLog.history?.length > 0 && (
                          <i
                            className={`fas fa-caret-${this.state.expandedIntakeLogRows.includes(rowKey) ? 'up' : 'down'}`}
                            style={{ cursor: 'pointer', paddingLeft: '5px' }}
                            onClick={(e) => { e.stopPropagation(); this.toggleIntakeLogRow(rowKey); }}
                          />
                        )}
                      </td>
                    </tr>
                    {this.state.expandedIntakeLogRows.includes(rowKey) &&
                      intakeLog.history?.map((h, hIndex) => (
                        <tr key={`${rowKey}-h-${hIndex}`} className="history-row">
                          <td className="ps-4 text-muted fst-italic"></td>
                          <td><small>{h.value}</small></td>
                          <td><small>{h.source}</small></td>
                          <td><small>{h.sourceDetail}: {h.description}</small></td>
                          <td><small>{new Date(h.timeStamp).toLocaleString()}</small></td>
                        </tr>
                      ))}
                  </React.Fragment>
                );

                return (
                  <div className="card-body" style={{ overflow: 'auto' }}>
                    {/* Headers — vertical layout */}
                    {headerLogs.length > 0 && (
                      <>
                        {lineIds.length > 0 && <h6 className="mb-1">Headers</h6>}
                        <table className="table table-striped table-bordered w-100">
                          <thead className="thead-light">
                            <tr>
                              <th>Field</th>
                              <th>Value</th>
                              <th>Source</th>
                              <th>Source Detail</th>
                              <th>History</th>
                            </tr>
                          </thead>
                          <tbody>
                            {headerLogs.map((log, i) => renderHeaderRow(log, `h-${i}`))}
                          </tbody>
                        </table>
                      </>
                    )}

                    {/* Lines — horizontal layout, one row per lineId */}
                    {lineIds.length > 0 && (
                      <>
                        {headerLogs.length > 0 && <h6 className="mt-2 mb-1">Lines</h6>}
                        <table className="table table-striped table-bordered w-100">
                          <thead className="thead-light">
                            <tr>
                              <th>Line</th>
                              {lineFieldNames.map(name => <th key={name}>{name}</th>)}
                            </tr>
                          </thead>
                          <tbody>
                            {lineIds.map(lineId => {
                              const fieldsForLine = lineLogs.filter(l => l.lineId === lineId);
                              const fieldMap = Object.fromEntries(fieldsForLine.map(l => [l.fieldName, l]));
                              const rowKey = `l-${lineId}`;
                              const isExpanded = this.state.expandedIntakeLogRows.includes(rowKey);
                              const hasHistory = fieldsForLine.some(l => l.history?.length > 0);
                              const maxHistoryLen = Math.max(0, ...fieldsForLine.map(l => l.history?.length || 0));
                              const lineSource = lineFieldNames
                                .map(name => fieldMap[name]?.source)
                                .find(s => s != null) ?? '';

                              return (
                                <React.Fragment key={rowKey}>
                                  <tr
                                    style={{ cursor: hasHistory ? 'pointer' : 'default' }}
                                    onClick={() => hasHistory && this.toggleIntakeLogRow(rowKey)}
                                  >
                                    <td>
                                      <strong>{lineId}</strong>
                                      {hasHistory && (
                                        <i
                                          className={`fas fa-caret-${isExpanded ? 'up' : 'down'}`}
                                          style={{ cursor: 'pointer', paddingLeft: '5px' }}
                                          onClick={(e) => { e.stopPropagation(); this.toggleIntakeLogRow(rowKey); }}
                                        />
                                      )}
                                      {' '}
                                      <small className="text-muted">Read From: {lineSource}</small>
                                    </td>
                                    {lineFieldNames.map(name => (
                                      <td key={name}>{fieldMap[name]?.value ?? ''}</td>
                                    ))}
                                  </tr>
                                  {isExpanded && Array.from({ length: maxHistoryLen }, (_, hIndex) => {
                                    const historySource = lineFieldNames
                                      .map(name => fieldMap[name]?.history?.[hIndex]?.source)
                                      .find(s => s != null) ?? '';
                                    return (
                                      <tr key={`${rowKey}-h-${hIndex}`} className="history-row">
                                        <td className="text-muted fst-italic"><small>Read From: {historySource}</small></td>
                                        {lineFieldNames.map(name => (
                                          <td key={name}><small>{fieldMap[name]?.history?.[hIndex]?.value ?? ''}</small></td>
                                        ))}
                                      </tr>
                                    );
                                  })}
                                </React.Fragment>
                              );
                            })}
                          </tbody>
                        </table>
                      </>
                    )}
                  </div>
                );
              })()}
              {this.state.intakeLogs.length === 0 &&(
                <div className='p-3'>
                  The intake logs for this document have either expired or this was uploaded in a way that does not log this data.
                  Intake log data is only retained for 90 days.
                </div>
              )}
            </div>
          </div>
        )}
        {this.state.showStampScreen && (
          <div className='td-dialogue-container'>
            <div className='td-dialogue card' style={{ width: '720px' }}>
              <div className='card-header'>
                Download with Stamps:
                <button
                  type='button'
                  className='btn-close'
                  onClick={this.toggleStamps}
                />
              </div>
              <div
                className='card-body'
                style={{ height: '430px', overflow: 'auto' }}
              >
                <div className='row'>
                  <div className='col-6'>
                    <label>Show:</label>
                    <div className='form-group'>
                      <input
                        className='form-check-input me-2'
                        checked={this.state.stampRequest.showDocId}
                        onChange={(e) => this.editStampRequest(e, 'docId')}
                        type='checkbox'
                      />
                      <label className='form-check-label'>Doc Id</label>
                    </div>
                    <div className='form-group'>
                      <input
                        className='form-check-input me-2'
                        checked={this.state.stampRequest.showUserName}
                        onChange={(e) => this.editStampRequest(e, 'userName')}
                        type='checkbox'
                      />
                      <label className='form-check-label'>User Name</label>
                    </div>
                    <div className='form-group'>
                      <input
                        className='form-check-input me-2'
                        checked={this.state.stampRequest.showDate}
                        onChange={(e) => this.editStampRequest(e, 'date')}
                        type='checkbox'
                      />
                      <label className='form-check-label'>Date</label>
                    </div>
                    <div className='form-group'>
                      <input
                        className='form-check-input me-2'
                        checked={this.state.stampRequest.showTime}
                        onChange={(e) => this.editStampRequest(e, 'time')}
                        type='checkbox'
                      />
                      <label className='form-check-label'>Time</label>
                    </div>
                    <label>Size:</label>
                    <div className='slidecontainer'>
                      <input
                        type='range'
                        min='1'
                        step='1'
                        max='3'
                        value={this.state.stampRequest.size}
                        onChange={(e) => this.editStampRequest(e, 'size')}
                        className='slider'
                        id='myRange'
                      />{' '}
                      <span>{this.state.stampRequest.sizeDesc}</span>
                    </div>
                    <div className='form-group'>
                      <input
                        className='form-check-input me-2'
                        value={this.state.stampRequest.useTransparency}
                        onChange={(e) =>
                          this.editStampRequest(e, 'transparency')
                        }
                        type='checkbox'
                      />
                      <label className='form-check-label'>Transparent</label>
                    </div>
                    <label className='mt-4'>Stamps:</label>
                    {this.state.stampRequest.stamps.map((stamp) => (
                      <div>
                        <span className='stamp-index'>{stamp.stampId}</span>
                        <span>{stamp.stampDesc}</span>
                      </div>
                    ))}
                  </div>
                  <div className='col-6'>
                    <div>
                      <label>Positions:</label>{' '}
                      <span style={{ color: '#999', fontSize: '9pt' }}>
                        (click to place stamps)
                      </span>
                    </div>
                    <div
                      id='stampPositionArea'
                      style={{
                        maxWidth: '300px',
                        maxHeight: '300px',
                        position: 'relative',
                      }}
                    >
                      <img
                        alt='stamp_image'
                        onClick={this.stampImageClick}
                        src={this.state.images[0].imageBytes}
                        style={{
                          width: `${
                            (this.state.images[0].imageWidth /
                              Math.max(
                                this.state.images[0].imageWidth,
                                this.state.images[0].imageHeight
                              )) *
                            300
                          }px`,
                          height: `${
                            (this.state.images[0].imageHeight /
                              Math.max(
                                this.state.images[0].imageWidth,
                                this.state.images[0].imageHeight
                              )) *
                            300
                          }px`,
                          border: '1px solid #555',
                          cursor: 'pointer',
                        }}
                      />

                      {this.state.stampRequest.stamps.map(
                        (stamp) =>
                          stamp.x > -1 && (
                            <div
                              key={stamp.stampId}
                              style={{
                                top: `${
                                  (stamp.y /
                                    Math.max(
                                      this.state.images[0].imageWidth,
                                      this.state.images[0].imageHeight
                                    )) *
                                  300
                                }px`,
                                left: `${
                                  (stamp.x /
                                    Math.max(
                                      this.state.images[0].imageWidth,
                                      this.state.images[0].imageHeight
                                    )) *
                                  300
                                }px`,
                              }}
                              className={`stamp-position-icon
                                 ${
                                   this.state.stampRequest.size === 3
                                     ? 'stamp-position-large'
                                     : ''
                                 }
                                 ${
                                   this.state.stampRequest.size === 2
                                     ? 'stamp-position-medium'
                                     : ''
                                 }
                                 ${
                                   this.state.stampRequest.size === 1
                                     ? 'stamp-position-small'
                                     : ''
                                 }
                                 ${
                                   this.state.stampRequest.useTransparency
                                     ? 'stamp-transparent'
                                     : ''
                                 }
                                 `}
                            >
                              {stamp.stampId}
                            </div>
                          )
                      )}
                    </div>
                  </div>
                </div>
                <button
                  className='btn btn-primary mt-3'
                  style={{ width: '100%' }}
                  onClick={this.downloadDocumentWithStamps}
                >
                  Download
                </button>
              </div>
            </div>
          </div>
        )}
        {this.state.showMoveAssign && (
          <div className='td-dialogue-container'>
            <div className='td-dialogue card' style={{ width: '720px' }}>
              <div className='card-header'>
                Move and Assign
                <button
                  type='button'
                  className='btn-close'
                  onClick={this.toggleShowMoveAssign}
                />
              </div>
              <div
                className='card-body'
                style={{ height: '500px', padding: '40px', overflow: 'auto' }}
              >
                <label className='form-label'>Workflow step</label>
                <select
                  className='form-select'
                  value={this.state.moveAssignStepId}
                  onChange={this.editMoveAssignStep}
                >
                  <option value='-1'></option>
                  {this.state.currentDoc.destinations.map((dest) => (
                    <option key={dest.stepId} value={dest.stepId}>
                      {dest.stepName}
                    </option>
                  ))}
                </select>
                <label className='form-label mt-4'>Assign User(s)</label>
                <div className='d-flex flex-row'>
                  {this.state.moveAssignSelectedUsers.map((user) => (
                    <div key={user.userId} className='queueAssignOther mt-2'>
                      {user.userName}{' '}
                      <i
                        style={{ cursor: 'pointer' }}
                        onClick={(e) =>
                          this.onClickRemoveMoveAssignUser(e, user)
                        }
                        className='fa-solid fa-times'
                      />
                    </div>
                  ))}
                </div>
                <div id='moveContainerAssignUserText' className='autocomplete2'>
                  <input
                    type='text'
                    className='form-control'
                    placeholder='Assign User...'
                    onFocus={this.editMoveAssignUser}
                    value={this.state.moveAssignUserSearch}
                    onBlur={this.moveAssignUserBlur}
                    onChange={this.editMoveAssignUser}
                  ></input>
                </div>
                {this.state.moveAssignStepId !== -1 && (
                  <button
                    className='btn btn-success mt-3'
                    onClick={this.moveAssignDoc}
                  >
                    <i className='fa-solid fa-check' /> OK
                  </button>
                )}
              </div>
            </div>
          </div>
        )}

        {this.state.showChangeBusinessProcess && (
          <div className='td-dialogue-container'>
            <div className='td-dialogue card' style={{ width: '720px' }}>
              <div className='card-header'>
                Change Business Process
                <button
                  type='button'
                  className='btn-close'
                  onClick={this.toggleChangeBusinessProcess}
                />
              </div>
              <div
                className='card-body'
                style={{ height: '500px', padding: '40px', overflow: 'auto' }}
              >
                <label className='form-label'>Business Process</label>
                <select
                  className='form-select'
                  value={this.state.selectedBpId2}
                  onChange={this.editBps}
                >
                  <option value='-1'></option>
                  {this.state.availableBps.map((dest) => (
                    <option key={dest.bpId} value={dest.bpId}>
                      {dest.bpName}
                    </option>
                  ))}
                </select>
                <label className='form-label'>Choose Template</label>
                <select
                  className='form-select'
                  value={this.state.selectedChangeBpTemplate}
                  onChange={this.editSelectedChangeBpTemplate}
                >
                  {/* <option value='-1'>Smart Template Matching</option> */}
                  {this.state.availableTemplates2.map((template) => (
                    <option
                      key={template.templateId}
                      value={template.templateId}
                    >
                      {template.templateName}
                    </option>
                  ))}
                </select>

                {this.state.selectedBpId2 !== -1 && (
                  <button
                    className='btn btn-success mt-3'
                    onClick={this.moveBpDocsClick}
                  >
                    <i className='fa-solid fa-check' /> OK
                  </button>
                )}
              </div>
            </div>
          </div>
        )}

        {this.state.showReasonForReject && (
          <div className='td-dialogue-container'>
            <div className='td-dialogue card' style={{ width: '720px' }}>
              <div className='card-header'>Document reject:</div>
              <div
                className='card-body'
                style={{ height: '400px', overflow: 'auto' }}
              >
                <div className='fs-5'>
                  Please provide a reason for document rejection
                </div>

                <>
                  <textarea
                    className='form-control'
                    value={this.state.rejectReasonNote}
                    onChange={this.editRejectNote}
                    maxLength={512}
                    rows='2'
                  />
                  <button
                    className='btn btn-danger mt-2'
                    style={{ marginRight: '10px' }}
                    onClick={this.confirmReject}
                    disabled={this.state.rejectReasonNote.length <= 2}
                  >
                    Reject
                  </button>
                  <button
                    className='btn btn-secondary mt-2'
                    onClick={this.cancelReject}

                  >
                    Cancel
                  </button>
                </>
              </div>
            </div>
          </div>
        )}

        {/* This is a popup that confirms that you would like to send a document to AI Capture. 
        This was included because we had a charge per document plan for AI Capture Requests,
        but we have pivoted to a tier system. So we no longer have a need for this popup. 
        Commenting out, but leaving here in case we need to reimplement one day */}
        {/* {this.state.showAICaptureConfirm && (
          <div className='td-dialogue-container'>
            <div className='td-dialogue card' style={{ width: '500px' }}>
              <div className='card-header'>Send to AI Capture
                   <button
                  type='button'
                  className='btn-close'
                  onClick={this.cancelAICaptureConfirm}
                />
              </div>
              <div className='card-body'>
                <p>This document will be processed using AI Capture, which will incur additional costs. Do you want to continue?</p>
                <button
                  className='btn btn-success mt-2'
                  style={{ marginRight: '10px' }}
                  onClick={this.sendToAICapture}
                >
                  Continue
                </button>
                <button
                  className='btn btn-secondary mt-2'
                  onClick={this.cancelAICaptureConfirm}
                >
                  Cancel
                </button>
              </div>
            </div>
          </div>
        )} */}

        {this.state.inProgressAnimation && (
          <div className='td-dialogue-container'>
            <div className='td-dialogue card' style={{ width: '450px' }}>
              <div className='card-header'>Action is in progress:</div>
              <div
                className='card-body'
                style={{ height: '250px', overflow: 'auto' }}
              >
                <div className='fs-5'>
                  Please wait while TrinDocs processes your request...
                </div>
                <div className='fa-5x' style={{ textAlign: 'center' }}>
                  <i
                    className='fa-solid fa-spinner fa-spin-pulse'
                  />
                </div>
              </div>
            </div>
          </div>
        )}

        {this.state.showEmailPDF && (
          <div className='td-dialogue-container'>
            <div className='td-dialogue card' style={{ width: '720px' }}>
              <div className='card-header'>
                E-Mail PDF{' '}
                <button
                  type='button'
                  className='btn-close'
                  onClick={this.cancelEmailPDF}
                />
              </div>
              <div
                className='card-body'
                style={{ height: '400px', overflow: 'auto' }}
              >
                <div className='mb-3'>
                  <label className='form-labael'>To:</label>
                  <input
                    className='form-control'
                    value={this.state.emailTo}
                    onChange={this.onEditEmailTo}
                  />
                </div>
                <div className='mb-3'>
                  <label className='form-labael'>Subject:</label>
                  <input
                    className='form-control'
                    value={this.state.emailSubject}
                    onChange={this.onEditEmailSubject}
                  />
                </div>
                <div className='mb-3'>
                  <label className='form-labael'>Message:</label>
                  <textarea
                    className='form-control'
                    value={this.state.emailMessage}
                    onChange={this.onEditEmailMessage}
                  />
                </div>

                <div>
                  <button
                    className='btn btn-danger mt-2'
                    style={{ marginRight: '10px' }}
                    onClick={this.cancelEmailPDF}
                  >
                    <i className='fa-solid fa-times' /> Cancel
                  </button>
                  <button
                    className='btn btn-success mt-2'
                    onClick={this.validateAndSendEmail}
                  >
                    <i className='fa-solid fa-check' /> OK
                  </button>
                </div>
              </div>
            </div>
          </div>
        )}

        {this.state.showExpandedView && (
          <div className='td-dialogue-container'>
            <div className='td-dialogue card' style={{ width: '720px' }}>
              <div className='card-header'>
                {this.state.expandedViewTitle}{' '}
                <button
                  type='button'
                  className='btn-close'
                  onClick={this.hideExpandedView}
                />
              </div>
              <div
                className='card-body'
                style={{ height: '300px', overflow: 'auto' }}
              >
               <div m-4>
                <textarea className='form-control' readOnly style={{width:'671px', border: 'solid,1px,#BBB'}} rows='8'>{this.state.expandedViewText}</textarea>
               </div>
              </div>
            </div>
          </div>
        )}
        {this.state.showIntegrationAlert && this.state.currentDoc.integrationAlerts.length > 0 && (
          <div className='td-dialogue-container'>
            <div className='td-dialogue card' style={{ width: '600px' }}>
              <div className='card-header'>
                {this.state.currentDoc.integrationAlerts[0].integration === 'system' && (
                  <>{' Alert from system '}</>
                )}
                {this.state.currentDoc.integrationAlerts[0].integration !== 'system' && (
                  <>{' Alert from plugin "'}{this.state.currentDoc.integrationAlerts[0].integration}{'" '}</>
                )}
                
                <button
                  type='button'
                  className='btn-close'
                  onClick={this.hideIntegrationAlert}
                />
              </div>
              <div
                className='card-body'
                style={{ height: '300px', overflow: 'auto' }}
              >
               <div>
                <div>


                  {this.state.currentDoc.integrationAlerts.map((integrationAlert) => (
                    <div span className='m-2'>
                      {integrationAlert.type === 'Success' && (
                        <span className='me-1' style={{ color: 'green' }}>
                          <i className='fa-solid fa-circle-check' />
                        </span>
                      )}
                      {integrationAlert.type === 'Information' && (
                        <span className='me-1' style={{ color: 'black' }}>
                          <i className='fa-solid fa-circle-info' />
                        </span>
                      )}
                      {integrationAlert.type === 'Error' && (
                        <span className='me-1' style={{ color: 'red' }}>
                          <i className='fa-solid fa-triangle-exclamation' />
                        </span>
                      )}
                      {' '}<span className='ml-1' >{integrationAlert.message}</span>
                    </div>

                    ))}
                </div>
               </div>
              </div>

              <button
                  className='btn btn-sm btn-success m-3'
                  onClick={this.adknowledgeIntegrationAlert}
                >
                  Acknowledge
              </button>

            </div>
          </div>
        )}
        {this.state.showCreateTemplate && (
          <div className='td-dialogue-container'>
            <div className='td-dialogue card' style={{ width: '500px' }}>
              <div className='card-header'>
                Create Template
                <button
                  type='button'
                  className='btn-close'
                  onClick={this.hideCreateTemplate}
                />
              </div>
              <div
                className='card-body'
                style={{ height: '180px', overflow: 'auto' }}
              >
               <div>
                  <div className='form-group mb-2'>
                    <label>Template Name</label>
                    <input type='text' value={this.state.newTemplateName} onChange={this.editNewTemplateName} autoComplete='OFF' id='createTemplateName' className='form-control' />
                  </div>
                  {this.state.newTemplateError !== '' &&
                    <div className='text-danger mb-2'>{this.state.newTemplateError}</div>
                  }
                  <button className='btn btn-primary me-2' onClick={this.createTemplate2}>Create</button>
                  <button className='btn btn-secondary' onClick={this.hideCreateTemplate}>Cancel</button>
               </div>
              </div>



            </div>
          </div>
        )}
        {this.state.preventViewing && (
          <div className='td-dialogue-container'>
            <div className='td-dialogue card' style={{ width: '720px' }}>
              <div className='card-header'>
                Document {this.state.documentID}
                <button
                  type='button'
                  onClick={this.goToActiveDocs}
                  className='btn-close'
                />
              </div>
              <div
                className='card-body'
                style={{ height: '200px', overflow: 'auto' }}
              >
                <div className='mb-3'>
                  <p>You are not permitted to view this document</p>
                </div>
              </div>
            </div>
          </div>
        )}
        {this.state.showErrorMessage && (
          <div className='td-dialogue-container'>
            <div className='td-dialogue card' style={{ width: '720px' }}>
              <div className='card-header'>
                Document Errors
                <button
                  type='button'
                  onClick={this.toggleShowErrorMessage}
                  className='btn-close'
                />
              </div>
              <div
                className='card-body'
                style={{ height: '200px', overflow: 'auto' }}
              >
                <div className='mb-3'>
                  {this.state.errorMessages.map((error) => (
                    <p style={{ color: 'red' }}>{error}</p>
                  ))}
                </div>
              </div>
            </div>
          </div>
        )}

        {this.state.showAlert && (
          <div className='td-dialogue-container'>
            <div className='td-error-dialogue card' style={{ width: '720px' }}>
              <div className='card-header'>
               {this.state.alertTitle}
                <button
                  type='button'
                  onClick={this.toggleShowAlert}
                  className='btn-close'
                />
              </div>
              <div
                className='card-body'
                style={{ height: '200px', overflow: 'auto' }}
              >
                <div className='mb-3'>

                    <p>{this.state.alertMessage}</p>

                </div>
              </div>
            </div>
          </div>
        )}

        <Link id='actdocLink' to='/' style={{ display: 'none' }}>
          ActiveDocs
        </Link>
        <Link
          id='nextDocLink'
          to={'/Document/' + this.state.currentDocId}
          style={{ display: 'none' }}
        >
          HiddenLink
        </Link>
        <Link
          id='docLink'
          to={'/Document/' + this.state.goToDocId}
          style={{ display: 'None' }}
        />
        {this.state.currentDoc !== undefined && (
          <Link
            id='inspectTempLink'
            className='nav-link'
            to={`/TemplateEditor/${
              this.state.currentDoc === undefined
                ? 0
                : this.state.currentDoc.templateId
            }/${this.state.currentDocId}`}
            style={{ display: 'none' }}
          ></Link>

        )}
        {this.state.currentDoc !== undefined && (
          <Link
            id='createTempLink'
            className='nav-link'
            to={`/TemplateEditor/${
              this.state.newTemplateId
            }`}
            style={{ display: 'none' }}
          ></Link>

        )}
        {this.state.relatedInfo.show && (
          <div
            className='relatedTip'
            style={{ left: `${this.state.relatedInfo.left}px`, top: '107px' }}
          >
            <div>FormType: {this.state.relatedInfo.formType}</div>
            <div>Field: {this.state.relatedInfo.field}</div>
          </div>
        )}
        <input
          id='acctchUploadInput'
          onChange={this.uploadAttachmentSubmit}
          type='file'
          hidden
        />
      </div>
    );
  }
}

export default DocumentEditor;
